/**
 * Frontend-owned translations.
 *
 * API values and API-provided messages must not be added here.  Keep the
 * namespaces below stable so pages can be migrated independently.
 */
const baseResources = {
  vi: {
    translation: {
      common: {
        appName: "M-Invoice",
        language: "Ngôn ngữ",
        vietnamese: "Tiếng Việt",
        english: "Tiếng Anh",
        chinese: "Tiếng Trung",
        japanese: "Tiếng Nhật",
        korean: "Tiếng Hàn",
        tokenUsb: "USB token",
        tokenFileCa: "FILE CA",
        tokenServiceEasyCa: "Service EASYCA",
        tokenServiceNcca: "Service NCCA",
        tokenServiceIca: "Service I-CA",
        tokenServiceIntrustCa: "Service Intrust-CA",
        close: "Đóng",
        cancel: "Hủy",
        save: "Lưu",
        update: "Cập nhật",
        updateInvoiceNumber: "Cập nhật số hóa đơn",
        qrPaymentNotRegistered: "Bạn chưa đăng kí thanh toán mQR",
        startRow: "Bắt đầu từ dòng",
        enterTaxCode: "Nhập MST cần tra cứu",
        searchMultipleTaxCodes: "Tra cứu nhiều MST",
        exportSearchResults: "Xuất kết quả tra cứu ra Excel",
        transaction: "giao dịch",
        compensateTransaction: "Bù giao dịch",
        qrCodePayment: "Thanh toán QR Code",
        groupTransactions: "Gộp giao dịch",
        cancelReason: "Lý do hủy",
        missing: "bị thiếu",
        create: "Tạo mới",
        edit: "Chỉnh sửa",
        detail: "Chi tiết",
        delete: "Xóa",
        confirm: "Đồng ý",
        restoreTemplate: "Khôi phục ban đầu",
        restoreTemplateQuestion: "Bạn chắc chắn muốn khôi phục lại mẫu hóa đơn này?",
        consentConfirmTitle: "Xác nhận đồng ý điều khoản",
        consentRequiredQuestion: "Tài khoản ngân hàng thụ hưởng của bạn cần đồng ý chia sẻ biến động số dư trước khi lưu. Bạn có muốn tiếp tục không?",
        consentCheckFailed: "Kiểm tra consent thất bại",
        consentLinkMissing: "Chưa có liên kết consent",
        equals: "Bằng",
        notEquals: "Khác",
        contains: "Chứa",
        startsWith: "Bắt đầu",
        endsWith: "Kết thúc",
        containsList: "Chứa danh sách",
        notContains: "Không chứa",
        emptyValue: "Trống",
        nonEmptyValue: "Không trống",
        greaterThan: "Lớn hơn",
        greaterThanOrEqual: "Lớn hơn hoặc bằng",
        lessThan: "Nhỏ hơn",
        lessThanOrEqual: "Nhỏ hơn hoặc bằng",
        reject: "Không",
        yes: "Có",
        no: "Không",
        back: "Quay lại",
        search: "Tìm kiếm",
        filter: "Bộ lọc",
        clear: "Xóa bộ lọc",
        reset: "Đặt lại",
        refresh: "Tải dữ liệu",
        export: "Xuất dữ liệu",
        import: "Nhập dữ liệu",
        download: "Tải xuống",
        upload: "Tải lên",
        copy: "Sao chép",
        importExcel: "Nhập dữ liệu từ Excel",
        exportExcel: "Kết xuất Excel",
        fileRequired: "Bạn chưa chọn file.",
        chooseFile: "Chọn file",
        downloadTemplate: "Tải file mẫu",
        receiveFile: "Nhận file",
        more: "Khác",
        actions: "Thao tác",
        functions: "Chức năng",
        statement: "Biên bản",
        symbol: "Ký hiệu",
        invoiceNo: "Số hóa đơn",
        invoiceDate: "Ngày hóa đơn",
        today: "Hôm nay",
        yesterday: "Hôm qua",
        status: "Trạng thái",
        receive: "Nhận",
        all: "- Tất cả -",
        currentPageReport: "{first} - {last} trong {totalRecords} bản ghi",
        templatePrintRows: "Số dòng in mẫu",
        viewInvoiceTemplate: "Xem mẫu hóa đơn",
        printConvertedInvoice: "In chuyển đổi",
        configuration: "Cấu hình",
        languageCustomization: "Tùy chỉnh ngôn ngữ",
        bilingualVietnameseEnglish: "Song ngữ (Việt - Anh)",
        signCustomization: "Tùy chỉnh ký",
        signImmediately: "Ký hóa đơn gửi ngay CQT",
        signSummaryAtPeriodEnd: "Ký hóa đơn gửi bảng tổng hợp cuối kỳ",
        colorCustomization: "Tùy chỉnh màu",
        fontCustomization: "Tùy chỉnh font",
        buyerCustomization: "Tùy chỉnh người mua",
        underlineBuyerValue: "Giá trị người mua có gạch chân",
        tableCustomization: "Tùy chỉnh bảng",
        tableRowBorders: "Bảng có dòng kẻ hàng",
        columnSymbolRows: "Thiết lập số dòng ký hiệu cột",
        blankRows: "Số dòng trắng",
        multiPageInvoiceRows: "Số dòng hóa đơn nhiều trang",
        signatureLabelCustomization: "Tùy chỉnh nhãn ký",
        headSignature: "Chữ ký thủ trưởng",
        emailInvoice: "Hóa đơn gửi email",
        htmlFormat: "Định dạng Html",
        logoFileSizeExceeded: "Dung lượng file logo không được vượt quá 100KB",
        imageFileRequired: "File phải là định dạng hình ảnh",
        logoDimensionExceeded: "Kích thước logo vượt quá giới hạn. Kích thước tối đa: {{width}}x{{height}}px",
        imageReadFailed: "Không thể đọc file hình ảnh",
        borderFileSizeExceeded: "Dung lượng file upload không được vượt quá 300kb",
        borderDimensionExceeded: "Kích thước khung viền vượt quá giới hạn, khuyến cáo dưới: {{pageSize}}: {{width}} x {{height}}",
        backgroundFileSizeExceeded: "Dung lượng file hình nền không được vượt quá 200KB",
        backgroundDimensionExceeded: "Kích thước hình nền vượt quá giới hạn. Kích thước tối đa: {{width}}x{{height}}px",
        useQrCode: "Sử dụng QR code",
        sizeCustomization: "Tùy chỉnh kích thước",
        useLogo: "Sử dụng logo",
        chooseLogoFromComputer: "Chọn từ máy tính dung lượng không quá 100KB",
        maxDimension: "Kích thước tối đa: ({{dimension}})",
        useBackground: "Sử dụng hình nền",
        chooseImageFromComputer: "Chọn ảnh từ máy tính",
        chooseBackgroundFromLibrary: "Chọn ảnh nền từ thư viện",
        chooseBackgroundFromComputer: "Chọn từ máy tính dung lượng không quá 200KB",
        opacity: "Độ mờ",
        useBorder: "Sử dụng khung viền",
        chooseBorderFromComputer: "Chọn từ máy tính dung lượng không quá 300Kb",
        maxPageDimension: "Kích thước tối đa {{pageSize}}: ({{width}}x{{height}})",
        pendingApproval: "Chờ duyệt",
        waitingSignature: "Chờ ký",
        signed: "Đã ký",
        sending: "Đang gửi",
        signing: "Đang ký",
        invoiceListType: "Loại bảng kê",
        taxAuthoritySendStatus: "Trạng thái gửi CQT",
        invoiceListTemplateSymbol: "Ký hiệu mẫu số bảng kê",
        adjustmentReplacementDate: "Ngày lập HĐĐC/TT",
        buyerLegalName: "Tên đơn vị mua",
        linkedInvoiceListEditBlocked: "Bảng kê đã được liên kết với hóa đơn nên không được phép sửa.",
        linkedInvoiceListDeleteBlocked: "Bảng kê đã được liên kết với hóa đơn nên không được phép xóa.",
        invoiceListPrintSelectionRequired: "Bạn cần chọn một bảng kê trước khi Xem in",
        invoiceListPrintPreview: "Xem in bảng kê",
        invoiceList: "Bảng kê",
        createInvoice: "Lập hóa đơn",
        createdBy: "Người tạo",
        discountInvoiceList: "Hóa đơn điều chỉnh",
        understood: "Đã hiểu",
        businessLocationDeclarationGuide: "Hướng dẫn khai báo địa điểm kinh doanh",
        step: "Bước {{number}}:",
        declareBusinessLocations: "Khai báo danh sách địa điểm kinh doanh →",
        assignBusinessLocationToSymbol: "Gán địa điểm với ký hiệu hóa đơn →",
        invoiceSymbolManagement: "Quản lý ký hiệu hóa đơn",
        dateRangeSameMonthRequired: "Vui lòng chọn Từ ngày và Đến ngày trong cùng một tháng.",
        toDateBeforeFromDate: "Đến ngày không được nhỏ hơn Từ ngày.",
        selectAtLeastOneInvoice: "Vui lòng chọn ít nhất một hóa đơn.",
        selectedInvoicesSameMonthRequired: "Các hóa đơn được chọn phải nằm trong cùng một tháng.",
        selectedInvoicesSameBuyerRequired: "Các hóa đơn được chọn phải có cùng Tên đơn vị/Tên người mua.",
        selectInvoiceForList: "Chọn hóa đơn vào bảng kê",
        month: "Tháng",
        year: "Năm",
        statementList: "Bảng kê",
        createInvoiceList: "Tạo bảng kê",
        // Bổ sung bản dịch cho lựa chọn trong/ngoài khu phi thuế quan.
        inside: "Trong",
        outside: "Ngoài",
        // Bổ sung bản dịch cho tiêu đề xử lý nhiều hóa đơn trong namespace common.
        multipleInvoiceReplacement: "Thay thế nhiều hóa đơn",
        multipleInvoiceAdjustment: "Điều chỉnh nhiều hóa đơn",
        createMultipleReplacementInvoice: "Lập hóa đơn thay thế nhiều",
        createMultipleAdjustmentInvoice: "Lập hóa đơn điều chỉnh nhiều",
        printStatement: "In biên bản",
        logoBackground: "Logo - Hình nền",
        detailCustomization: "Tùy chỉnh chi tiết",
        saveInfo: "Lưu thông tin",
        noData: "Không có dữ liệu",
        productServiceName: "Tên hàng hóa dịch vụ",
        vatRate: "Thuế suất GTGT",
        taxAmount: "Tiền thuế GTGT",
        otherAmount: "Tổng tiền khác",
        totalAfterTax: "Tổng tiền sau thuế",
        serialNumberShort: "STT",
        invoiceNumber: "Số hóa đơn",
        invoiceSymbol: "Ký hiệu",
        invoiceNature: "Tính chất hóa đơn",
        beforeReplacementInfo: "Thông tin trước thay thế",
        beforeAdjustmentInfo: "Thông tin trước điều chỉnh",
        afterReplacementInfo: "Thông tin sau thay thế",
        afterAdjustmentInfo: "Thông tin sau điều chỉnh (Ghi thông tin đúng của hóa đơn, làm căn cứ tính toán cột chênh lệch)",
        difference: "Chênh lệch",
        invoiceListSelectionLimit: "Mỗi bảng kê chỉ được chọn tối đa {{count}} hóa đơn.",
        invoiceListItemsLoadFailed: "Lấy danh sách hóa đơn trong bảng kê thất bại!",
        invoiceListLoadFailed: "Lấy thông tin bảng kê thất bại!",
        invoiceInfoLoadFailed: "Lấy thông tin hóa đơn thất bại!",
        invoiceListCreated: "Tạo bảng kê thành công!",
        invoiceListUpdated: "Cập nhật bảng kê thành công!",
        invoiceListTitle: "Bảng kê hóa đơn",
        invoiceListViewTitle: "Xem bảng kê hóa đơn",
        invoiceListSymbol: "Ký hiệu bảng kê",
        buyerNameRequired: "Phải nhập Tên đơn vị mua hoặc Tên người mua",
        invoiceListItemsRequired: "Danh sách hóa đơn không được để trống",
        saveAndCreateInvoice: "Lưu và tạo hóa đơn",
        deleteInvoiceRowWithShortcut: "Xóa dòng (F8)",
        deleteNoDifferenceRows: "Xóa hàng loạt dòng không có chênh lệch",
        consumerBuyer: "Bán cho người tiêu dùng",
        cityPrefix: "Thành phố",
        provincePrefix: "Tỉnh",
        taxCodeSearchV2Failed: "Lỗi khi tìm kiếm MST (V2).",
        taxCodeSearchFailed: "Lỗi khi tìm kiếm MST.",
        paymentTotalMismatch: "Tổng tiền thanh toán không khớp với Tổng tiền trước thuế + Tiền thuế",
        paymentUnitPriceMismatch: "Tổng tiền thanh toán không khớp so với Số lượng x Đơn giá bao gồm VAT.",
        saveAndPrint: "Lưu và Xem in",
        saveAndContinue: "Lưu và Tạo tiếp",
        exportForBusiness: "Xuất cho doanh nghiệp",
        signTimeWarningNonCompliant: "Danh sách các hóa đơn sau không thỏa mãn quy định trên.",
        continueSignQuestion: "Bạn có muốn tiếp tục thao tác ký gửi không?",
        signTimeWarningLegalRule: "Theo quy định tại Khoản 7, Phụ lục \"Nội dung của hóa đơn\" Nghị định 254/2026/NĐ-CP, thời điểm ký gửi dữ liệu hóa đơn lên CQT chậm nhất là ngày làm việc tiếp theo kể từ thời điểm lập hóa đơn.",
        signTimeWarningInvoiceDetails: "Hóa đơn đang ký có ngày lập {{date}}, ký hiệu {{symbol}}, số {{number}} không thỏa mãn quy định trên. Bạn có muốn tiếp tục thao tác ký gửi không?",
        discountSignTimeWarningLegalRule: "Theo quy định tại Điểm c Khoản 7 và Điểm b Khoản 14, Điều 1, Nghị định 254/2026/NĐ-CP, thời điểm ký gửi dữ liệu hóa đơn lên CQT chậm nhất là ngày làm việc tiếp theo kể từ thời điểm lập hóa đơn.",
        itemListFieldRequired: "Danh sách hàng hóa: Trường {{field}} không được để trống",
        itemListEmpty: "Danh sách hàng hóa trống",
        invoiceAmountMismatch: "Mặt hàng {{product}} tại dòng {{line}} có Số lượng x Đơn giá khác Thành tiền; chênh lệch {{difference}}",
        invoicePreTaxMismatch: "Tổng tiền trước thuế Chi tiết {{detail}} khác với tổng tiền trước thuế Đầu phiếu {{header}}; chênh lệch {{difference}}",
        invoiceTotalMismatch: "Tổng tiền trước thuế {{beforeTax}} + Tổng tiền thuế {{tax}} khác với Tổng tiền thanh toán {{total}}; chênh lệch {{difference}}",
        commercialDiscountLegalNotice: "Căn cứ Điểm b, Khoản 5, Điều 10, Thông tư 91/2026/TT-BTC: Trường hợp việc chiết khấu thương mại căn cứ vào số lượng, doanh số hàng hóa, dịch vụ được lập hóa đơn điều chỉnh kèm theo bảng kê các số hóa đơn cần điều chỉnh, số tiền, tiền thuế điều chỉnh. Bảng kê được lưu tại đơn vị và xuất trình khi cơ quan thuế hoặc cơ quan nhà nước có thẩm quyền yêu cầu.",
        commercialDiscountStepsTitle: "Thao tác tạo hóa đơn chiết khấu thương mại gồm 2 bước sau:",
        commercialDiscountStepOne: "Bước 1: Lập bảng kê chứa danh sách hóa đơn thỏa mãn chương trình Chiết khấu",
        commercialDiscountStepTwo: "Bước 2: Tạo hóa đơn Điều chỉnh gắn với Số bảng kê, Ngày bảng kê đã lập",
        commercialDiscountLineNote: "(Tính chất dòng hàng là Hàng hóa dịch vụ, Tổng tiền là số dương)",
        invoiceSaveBlockedSummary: "Không thể lưu",
        saveFailed: "Không thể lưu thông tin. Vui lòng thử lại.",
        businessLocationRequiredBeforeSave: "Vui lòng khai báo và gán địa điểm kinh doanh cho ký hiệu hóa đơn (Danh mục → Danh mục địa điểm kinh doanh) trước khi lưu.",
        frameEngineRequiredForVehicle: "Số khung; Số máy không được để trống đối với hàng hóa đặc trưng thuộc loại xe ô tô, xe mô tô.",
        vehiclePlateRequiredForTransport: "Biển số xe không được để trống đối với hàng hóa đặc trưng thuộc loại Dịch vụ vận chuyển.",
        senderInfoRequiredForDigitalTransport: "Tên người gửi hàng, địa chỉ người gửi hàng, Mã số thuế người gửi hàng, CCCD người gửi hàng không được để trống đối với hàng hóa đặc trưng thuộc loại Dịch vụ vận chuyển trên nền tảng số",
        invalidInvoiceIdForSigning: "Không tìm thấy ID hóa đơn hợp lệ để ký.",
        invoiceListAlreadyCreated: "Bạn không thể tạo hóa đơn do bảng kê đã được tạo trước đó",
        cancelInvoiceSelectionRestriction: "Bạn chỉ được Hủy hóa đơn ký gửi thành công ở trạng thái Gốc - Giải trình",
        afterConfirmation: "Sau khi Xác nhận, hệ thống sẽ:",
        updateInvoiceListStatus: "Cập nhật trạng thái các hóa đơn trong bảng kê.",
        invoiceListLockedAfterConfirm: "Không cho phép sửa hoặc xóa bảng kê.",
        deleteMultipleInvoiceToEditList: "Nếu cần sửa hoặc xóa bảng kê sau này, bạn phải xóa hóa đơn điều chỉnh/thay thế nhiều để khôi phục trạng thái các hóa đơn trong bảng kê.",
        saveInvoiceQuestion: "Bạn có chắc chắn muốn lưu hóa đơn này?",
        citizenDataNotFound: "Không tìm thấy dữ liệu CCCD.",
        citizenSearchFailed: "Lỗi khi tìm kiếm CCCD.",
        taxCodeNotFound: "Không tìm thấy dữ liệu MST.",
        taxCodeV2NotFound: "Không tìm thấy dữ liệu MST (V2).",
        taxCodeFormatInvalid: "Mã số không hợp lệ. Vui lòng kiểm tra lại.",
        supportChatCaption: "M-invoice Hỗ trợ",
        supportChatTagline: "Chúng tôi luôn sẵn sàng hỗ trợ Quý khách. Thường phản hồi trong vòng 5 phút",
        supportChatGreeting: "Hãy nhập đầy đủ thông tin để M-invoice hỗ trợ bạn tốt hơn :wave:",
        statementNumber: "Số biên bản",
        todayDate: "Hôm nay, ngày",
        seller: "Bên A (Bên bán)",
        buyer: "Bên B (Bên mua)",
        address: "Địa chỉ",
        phone: "Số điện thoại",
        representative: "Đại diện",
        position: "Chức vụ",
        parties: "Chúng tôi gồm có:",
        cancelled: "hủy",
        replacement: "Thay thế",
        adjustment: "Điều chỉnh",
        reason: "Lý do",
        statementCreate: "Lập biên bản",
        statementCreated: "Đã lập biên bản",
        statementTitle: "Biên bản {{action}} hóa đơn",
        statementToday: "Hôm nay, ngày {{day}} tháng {{month}} năm {{year}}, chúng tôi gồm có:",
        statementCancelSentence: "Hai bên thống nhất lập biên bản này để thu hồi và huỷ hoá đơn có mẫu số {{form}}, ký hiệu {{serial}}, số {{number}}, ngày {{date}} theo quy định.",
        statementMultipleSentence: "Hai bên thống nhất lập biên bản này để xác nhận sai sót và lập hóa đơn {{action}} cho nhiều hóa đơn sai sót kèm theo bảng kê có Số {{listNumber}}, Ngày {{listDate}} theo quy định.",
        statementSingleSentence: "Hai bên thống nhất lập biên bản này để xác nhận sai sót và lập hóa đơn {{action}} cho hóa đơn có mẫu số {{form}}, ký hiệu {{serial}}, số {{number}}, ngày {{date}} theo quy định.",
        statementCommitment: "Chúng tôi xin cam đoan các thông tin khai ở trên là hoàn toàn chính xác. Nếu có bất kỳ sai sót nào chúng tôi xin chịu trách nhiệm trước pháp luật.",
        statementActionCommitment: "Chúng tôi cam kết và hoàn toàn chịu trách nhiệm về việc {{action}} cho hóa đơn này.",
        republicTitle: "CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM",
        nationalMotto: "Độc lập - Tự do - Hạnh phúc",
        householdTaxOrCitizenId: "MST/CCCD chủ hộ",
        lawBasisDecree123: "Căn cứ Nghị định 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ.",
        lawBasisDecree70: "Căn cứ Nghị định 70/2025/NĐ-CP ngày 20/03/2025 của Chính phủ sửa đổi, bổ sung một số điều của Nghị định 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ.",
        lawBasisCircular32: "Căn cứ Thông tư 32/2025/TT-BTC ngày 31/05/2025 của Bộ Tài chính hướng dẫn thực hiện Nghị định số 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ, Nghị định số 70/2025/NĐ-CP ngày 20/03/2025 sửa đổi, bổ sung một số điều Nghị định số 123/2020/NĐ-CP.",
        lawBasisDecree254: "Căn cứ Nghị định số 254/2026/NĐ-CP ngày 30/06/2026 của Chính phủ quy định chi tiết một số điều và biện pháp để tổ chức, hướng dẫn thi hành Luật Quản lý thuế số 108/2025/QH15 về hóa đơn điện tử, chứng từ điện tử.",
        lawBasisCircular91: "Căn cứ Thông tư số 91/2026/TT-BTC ngày 30/06/2026 của Bộ Tài chính quy định một số điều của Luật Quản lý thuế số 108/2025/QH15 và Nghị định số 254/2026/NĐ-CP của Chính phủ quy định chi tiết một số điều và biện pháp để tổ chức, hướng dẫn thi hành Luật Quản lý thuế về hóa đơn điện tử, chứng từ điện tử.",
        lawBasisAgreement: "Căn cứ vào thỏa thuận giữa các bên.",
        logo: "Logo",
        businessRegistrationInfo: "Số ĐKKD {{number}} do {{authority}} cấp ngày {{date}}",
        branch: "CHI NHÁNH",
        copyright: "Bản quyền © 2025 {{company}}. Bảo lưu mọi quyền.",
        attachment: "File đính kèm",
        printInvoice: "In hóa đơn",
        emailStatementForSignature: "Gửi email biên bản cho người mua ký",
        registerAdjustmentInvoice: "Lập hóa đơn điều chỉnh",
        registerReplacementInvoice: "Lập hóa đơn thay thế",
        selectSymbol: "Chọn ký hiệu",
        saveAndSign: "Lưu & ký",
        sendForSignature: "Gửi hóa đơn cho người mua ký",
        representativeSeller: "Đại diện bên A",
        representativeBuyer: "Đại diện bên B",
        digitalSignature: "(Chữ ký số, chữ ký điện tử)",
        signatureValid: "Chữ ký hợp lệ",
        signedBy: "Ký bởi:",
        signedDate: "Ngày ký:",
        addLine: "Thêm dòng",
        deleteLine: "Xóa dòng",
        copyLine: "Sao chép",
        insertLine: "Chèn dòng",
        chooseProduct: "Chọn hàng hóa",
        receiveExcelDetail: "Nhận Excel chi tiết",
        selectReplacementProduct: "Chọn mặt hàng cần thay thế",
        itemCode: "Mã hàng",
        code: "Mã",
        itemName: "Tên hàng",
        quantity: "Số lượng",
        unitPrice: "Đơn giá",
        amount: "Thành tiền",
        totalRecords: "Tổng số {{count}} bản ghi",
        printView: "Xem in",
        sendEmail: "Gửi email",
        downloadInvoicePdf: "Tải hóa đơn PDF",
        bulkSign: "Ký hóa đơn hàng loạt",
        relatedStatement: "Biên bản liên quan",
        invoiceHistory: "Lịch sử hóa đơn",
        senderEmail: "Email người gửi",
        alias: "Bí danh",
        customerEmail: "Email khách hàng",
        subject: "Tiêu đề",
        enterCustomerEmail: "Nhập email khách hàng",
        emailFallback: "Nếu để trống nội dung này, hệ thống sẽ mặc định lấy email đã điền sẵn trong hóa đơn để gửi đi",
        emailSeparator: "Các email được ngăn cách bằng dấu phẩy (,)",
        reviewEmail: "Kiểm tra nội dung đầy đủ của email",
        paymentNotification: "Thông báo thanh toán",
        paymentHistory: "Lịch sử thanh toán",
        transactionId: "Mã giao dịch",
        paidAmount: "Khoản đã thanh toán",
        paymentTime: "Thời gian thanh toán",
        paymentStatus: "Trạng thái thanh toán",
        content: "Nội dung",
        field: "Trường",
        uploadPdf: "Tải lên tệp PDF",
        attachStatement: "Đính kèm biên bản",
        fromDate: "Từ ngày",
        toDate: "Đến ngày",
        buyerName: "Tên đơn vị/Tên người mua",
        taxAuthorityCode: "Mã cơ quan thuế",
        selectInvoice: "Chọn hóa đơn",
        invoicePaymentHistory: "Lịch sử thanh toán hóa đơn",
        qrPaymentHistory: "Lịch sử thanh toán QR Code",
        invoiceNoPayment: "Hóa đơn chưa phát sinh giao dịch thanh toán qua QR",
        qrNoPayment: "Giao dịch chưa phát sinh giao dịch thanh toán qua QR",
        pump: "Vòi bơm",
        store: "cửa hàng",
        time: "thời gian",
        notificationType: "Loại thông báo",
        notificationNo: "Số thông báo",
        taxAuthorityNotificationNo: "Số thông báo từ CQT",
        taxAuthorityNotificationDate: "Ngày thông báo từ CQT",
        taxAuthorityReceiving: "Cơ quan thuế tiếp nhận",
        taxpayerName: "Tên người nộp thuế",
        placeOfCreation: "Nơi lập",
        appliedInvoiceType: "Loại hóa đơn áp dụng",
        noticeProperty: "Tính chất thông báo",
        taxAuthorityIssuedCode: "Mã cơ quan thuế cấp",
        wrongInvoiceDeclaration: "Khai báo thông tin hóa đơn sai sót",
        oldSymbol: "Ký hiệu cũ",
        newSymbol: "Ký hiệu mới",
        changeInvoiceSerial: "Chuyển ký hiệu hóa đơn",
        receiveExcel: "Nhận Excel",
        downloadXml: "Tải XML",
        declarationType: "Loại tờ khai",
        contactEmail: "Email liên hệ",
        contactPerson: "Người liên hệ",
        contactAddress: "Địa chỉ liên hệ",
        contactPhone: "Điện thoại liên hệ",
        lookupCode: "Mã tra cứu",
        sourceData: "Nguồn dữ liệu",
        qrCreatedAmount: "Tổng tiền tạo QR",
        paidTotal: "Tổng tiền đã thanh toán",
        qrCreationTime: "Thời gian tạo QR",
        qrPaymentTime: "Thời gian thanh toán QR",
        lastModificationTime: "Thời gian cập nhật",
        selectDataSource: "Vui lòng chọn ít nhất một nguồn dữ liệu",
        selectQrCreationPeriod: "Vui lòng chọn khoảng thời gian tạo QR",
        noticeFromTaxpayer: "Thông báo của Người nộp thuế",
        noticeFromTaxAuthority: "Thông báo của Người nộp thuế theo thông báo của Cơ quan thuế",
        invoiceTypeN123: "Hóa đơn điện tử NĐ123,NĐ70,NĐ254",
        verifiedInvoiceQd1209: "Hóa đơn xác thực QĐ1209",
        invoiceN51: "Hóa đơn NĐ51",
        preprintedInvoiceN123: "Hóa đơn đặt in NĐ123",
        manualInvoiceHint: "Chọn hóa đơn có sẵn trên phần mềm hoặc Thêm dòng để nhập thủ công hóa đơn NCC khác, hóa đơn Thông tư 32",
        invoicesForErrorNotice: "Danh sách hóa đơn cần thông báo sai sót đến Cơ quan thuế:",
        signErrorNotice: "Ký gửi 04/SS-HĐĐT",
        restoreErrorNoticeStatusQuestion: "Bạn có thực sự muốn khôi phục trạng thái Thông báo về Chờ ký để gửi lại CQT không?",
        requestCode: "Mã hóa đơn/log bơm",
        bankTransactionCode: "Mã GD ngân hàng",
        invoiceInfoNotFound: "Không tìm thấy thông tin hóa đơn",
        pumpLogInfoNotFound: "Không tìm thấy thông tin log bơm",
        paymentFull: "Thanh toán đủ",
        paymentShort: "Thanh toán thiếu",
        paymentExcess: "Thanh toán thừa",
        todayShort: "Hôm nay",
        daysUnit: "ngày",
        yearUnit: "năm",
        days7: "7 ngày",
        days30: "30 ngày",
        days90: "90 ngày",
        year1: "1 năm",
        customOption: "Tùy chọn",
        paymentPendingStatus: "Đang thanh toán",
        paymentErrorStatus: "Thanh toán lỗi",
        paymentSuccessStatus: "Thanh toán thành công",
        errorDescription: "Mô tả lỗi",
        declarationDate: "Ngày lập",
        submissionStatus: "Trạng thái gửi CQT",
        taxAuthorityFeedback: "Phản hồi CQT",
        sender: "Người gửi",
        declarationRegister: "Đăng ký",
        declarationChange: "Thay đổi",
        notSubmitted: "Chưa gửi",
        submitted: "Đã gửi",
        declarationSigned: "Đã ký",
        received: "Tiếp nhận",
        notReceived: "Không tiếp nhận",
        accepted: "Chấp nhận",
        notAccepted: "Không chấp nhận",
        explanation: "Giải trình",
        discontinued: "Ngừng sử dụng",
        nextStep: "Bước tiếp theo",
        nextStepVerifyAtTaxAuthority: "Xác thực thông tin trực tiếp tại CQT",
        nextStepVerifyBiometric: "Xác thực thông tin sinh trắc học",
        nextStepVerifyOtp: "Xác thực thông tin OTP",
        nextStepCreateNewDeclaration: "Tạo tờ khai mới",
        nextStepExplainRisk: "Hướng dẫn giải trình",
        nextStepCompleted: "Hoàn thành",
        nextStepSignAndSend: "Vui lòng ký & gửi CQT",
        nextStepWaitForResponse: "Chờ phản hồi từ CQT",
        nextStepPreliminaryChecking: "Cơ quan Thuế đang tiến hành kiểm tra sơ bộ tờ khai",
        taxAuthorityFeedbackPending: "Chưa phản hồi",
        viewNextStepGuidance: "Xem hướng dẫn xác thực thông tin",
        cloneRejectedDeclaration: "Tạo tờ khai mới từ tờ khai bị từ chối",
        declarationGuidanceLoadFailed: "Không thể tải dữ liệu hướng dẫn. Vui lòng thử lại sau.",
        declarationCloneLoadFailed: "Không thể tải tờ khai bị từ chối. Vui lòng thử lại sau.",
        invoiceForm: "Hình thức hóa đơn",
        requiredFieldsMessage: "Vui lòng nhập đầy đủ các trường bắt buộc",
        taxAuthorityConnectionFailed: "Không thể kết nối tới CQT lúc này. Vui lòng lưu nháp hoặc gửi lại sau.",
        decree123Text: "Theo nghị định số 123/2020/NĐ-CP ngày 19 tháng 10 năm 2020 của chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng hóa đơn điện tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa đơn điện tử như sau:",
        decree254Text: "Theo nghị định số 254/2026/NĐ-CP ngày 30 tháng 06 năm 2026 của Chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng hóa đơn điện tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa đơn điện tử như sau:",
        acceptanceTime: "Thời gian chấp thuận",
        acceptanceFile: "File PDF hoặc XML của CQT",
        uploadAcceptanceFile: "Tải lên file chấp nhận",
        declarationTransferHistory: "Lịch sử truyền nhận tờ khai",
        declarationFormTitle: "Tờ khai",
        declarationFormSubtitle: "Đăng ký/Thay đổi thông tin sử dụng hoá đơn điện tử",
        declarationRegisterNew: "Đăng ký mới",
        declarationChangeInfo: "Thay đổi thông tin",
        managedTaxAuthority: "Cơ quan thuế quản lý",
        legalRepresentativeName: "Tên người đại diện",
        passportLabel: "Hộ chiếu",
        dateOfBirth: "Ngày tháng năm sinh",
        gender: "Giới tính",
        female: "Nữ",
        male: "Nam",
        legalRepresentativeNotice: "Thông tin người đại diện pháp luật phục vụ Xác thực sinh trắc học trên hệ thống phần mềm của CQT",
        acceptedDeclarationNotice: "Sau khi tờ khai được chấp nhận, cơ quan thuế sẽ gửi các thông báo quan trọng liên quan đến hoá đơn điện tử tới email/số điện thoại/địa chỉ này.",
        invoiceFormSection: "1. Hình thức hóa đơn:",
        invoiceDataSendingSection: "2. Hình thức gửi dữ liệu hóa đơn điện tử:",
        skipIfNotApplicable: "Vui lòng bỏ qua nếu bạn không thuộc đối tượng nào trong các đối tượng dưới đây.",
        codedInvoiceWithoutServiceFeeCase: "a. Trường hợp sử dụng hóa đơn điện tử có mã không phải trả tiền dịch vụ theo khoản 1 Điều 14 của Nghị định:",
        noCodeInvoiceCase: "b. Trường hợp sử dụng hóa đơn điện tử không có mã của cơ quan thuế:",
        dataTransferMethodSection: "3. Phương thức chuyển dữ liệu hóa đơn điện tử:",
        invoiceTypeUseSection: "4. Loại hóa đơn sử dụng",
        certificateUseSection: "5. Danh sách chứng thư số sử dụng",
        serviceProviderSection: "6. Tổ chức cung cấp dịch vụ",
        receivingUnitSection: "7. Thông tin đơn vị truyền nhận",
        dependentUnitSection: "8. Thông tin đơn vị hạch toán phục thuộc cần cấp quyền tra cứu",
        suspensionRequestSection: "9. Đề nghị tạm ngừng sử dụng hóa đơn điện tử",
        invoiceWithTaxCode: "Có mã của cơ quan thuế",
        invoiceWithCashRegister: "Có mã của cơ quan thuế (Khởi tạo từ máy tính tiền)",
        invoiceWithoutTaxCode: "Không có mã của cơ quan thuế",
        difficultAreaBusiness: "Doanh nghiệp nhỏ và vừa, hợp tác xã, hộ, cá nhân kinh doanh tại địa bàn có điều kiện kinh tế xã hội khó khăn, địa bàn có điều kiện kinh tế xã hội đặc biệt khó khăn.",
        otherSmallBusiness: "Doanh nghiệp nhỏ và vừa khác theo đề nghị của Ủy ban nhân dân tỉnh, thành phố trực thuộc trung ương gửi Bộ Tài chính trừ doanh nghiệp hoạt động tại các khu kinh tế, khu công nghiệp, khu công nghệ cao.",
        publicAssetAuthority: "Cơ quan thuế hoặc cơ quan được giao nhiệm vụ tổ chức, xử lý tài sản công theo quy định pháp luật về quản lý, sử dụng tài sản công",
        viaInvoiceProvider: "Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử (điểm b2, khoản 3, Điều 22 của Nghị định).",
        directToTaxAuthority: "Chuyển dữ liệu hóa đơn điện tử trực tiếp đến cơ quan thuế (điểm b1, khoản 3, Điều 22 của Nghị định).",
        fullInvoiceContent: "Chuyển đầy đủ nội dung từng hóa đơn.",
        summaryInvoiceData: "Chuyển theo bảng tổng hợp dữ liệu hóa đơn điện tử (điểm a1, khoản 3, Điều 22 của Nghị định).",
        vatInvoice: "Hóa đơn GTGT",
        salesInvoice: "Hóa đơn bán hàng",
        publicAssetInvoice: "Hóa đơn bán tài sản công",
        nationalReserveInvoice: "Hóa đơn bán hàng dự trữ quốc gia",
        otherInvoiceTypes: "Các loại hóa đơn khác",
        managedDocumentsAsInvoice: "Các chứng từ được in, phát hành, sử dụng và quản lý như hóa đơn",
        integratedVatReceipt: "Hóa đơn GTGT tích hợp biên lai thu thuế, phí, lệ phí",
        integratedSalesReceipt: "Hóa đơn bán hàng tích hợp biên lai thu thuế, phí, lệ phí",
        commercialInvoice: "Hóa đơn thương mại",
        legacyOtherInvoiceTypes: "Các loại hóa đơn khác: Tem, vé, thẻ điện tử",
        legacyManagedDocumentsAsInvoice: "Các chứng từ được in, phát hành, sử dụng và quản lý như hóa đơn: Phiếu xuất kho kiêm vận chuyển nội bộ, phiếu xuất kho gửi bán đại lý",
        tableIndex: "STT",
        effectiveDate: "Ngày hiệu lực",
        unitNameLabel: "Tên đơn vị",
        dependentUnitName: "Tên đơn vị hạch toán phụ thuộc",
        permissionStartDate: "Ngày bắt đầu cấp quyền tra cứu",
        permissionEndDate: "Ngày kết thúc cấp quyền tra cứu",
        receivingUnitName: "Tên đơn vị truyền nhận",
        serviceStartDate: "Ngày bắt đầu sử dụng dịch vụ",
        serviceEndDate: "Ngày kết thúc sử dụng dịch vụ",
        serviceProviderName: "Tên tổ chức cung cấp dịch vụ",
        invoiceTypeName: "Tên loại hóa đơn",
        integratedTemplateSymbol: "Ký hiệu mẫu hóa đơn tích hợp",
        integratedInvoiceSymbol: "Ký hiệu hóa đơn tích hợp",
        integratedOrganization: "Tên tổ chức được hoặc nhận tích hợp hóa đơn",
        integratedOrganizationTaxCode: "MST tổ chức được hoặc nhận tích hợp hóa đơn",
        integrationPurpose: "Mục đích tích hợp",
        providerSolutionTaxCode: "Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử",
        certificateSerialShort: "Số seri chứng thư",
        invoiceServiceProvider: "Tên đơn vị cung cấp dịch vụ hóa đơn",
        suspensionStartDate: "Ngày bắt đầu ngừng sử dụng",
        suspensionEndDate: "Ngày kết thúc ngừng sử dụng",
        deleteLabel: "Xoá",
        restoreDeclarationStatusQuestion: "Bạn có thực sự muốn khôi phục trạng thái Tờ khai đăng ký về Chờ ký để gửi lại CQT không?",
        receivedTime: "Thời gian nhận",
        taxAuthorityReceivedAndCheckingMessage: "CQT đã nhận được thông điệp và tiến hành kiểm tra dữ liệu",
        statusError: "Có lỗi",
        unknownMessage: "Lỗi chưa xác định",
        taxAuthorityReceivedDeclaration: "CQT tiếp nhận tờ khai",
        taxAuthorityApprovedDeclaration: "CQT duyệt tờ khai",
        declarationExplanation: "Giải trình tờ khai",
        taxAuthorityCheckedData: "CQT kiểm tra dữ liệu",
        taxAuthorityGrantedInvoiceCode: "CQT cấp mã hóa đơn",
        taxAuthorityApprovedErrorNotice: "CQT duyệt thông báo sai sót",
        taxAuthorityReceivedMessage: "CQT đã nhận được thông điệp",
        taxAuthorityApprovedDiscontinuation: "CQT duyệt ngừng sử dụng",
        pdf: "PDF",
        xml: "XML",
        updateTaxAuthorityStatus: "Cập nhật trạng thái HĐ từ CQT",
        businessOperation: "Nghiệp vụ",
        viewAllInvoices: "Xem toàn bộ HĐ",
        addDiscountInvoice: "Thêm HĐ chiết khấu",
        replace: "Thay thế",
        multipleReplace: "Thay thế nhiều hóa đơn",
        multipleAdjust: "Điều chỉnh nhiều hóa đơn",
        adjust: "Điều chỉnh",
        replaceOtherSystem: "Thay thế HĐ trên hệ thống khác",
        adjustOtherSystem: "Điều chỉnh HĐ trên hệ thống khác",
        multipleInvoiceDialogHeader: "Lập hóa đơn {{title}} nhiều hóa đơn",
        multipleInvoiceLegalNotice: "Căn cứ Điểm b.2, Khoản 1, Điều 10 Thông tư 91/2026/TT-BTC: Trường hợp trong tháng người bán đã lập sai cùng thông tin về người mua, tên hàng, đơn giá, số lượng, thuế suất trên nhiều hóa đơn của cùng một người mua trong cùng tháng, thì người bán được lập một hóa đơn điều chỉnh hoặc thay thế cho nhiều hóa đơn điện tử đã lập sai trong cùng tháng và đính kèm bảng kê các hóa đơn điện tử đã lập sai theo Mẫu số 01/BK-ĐCTT.",
        multipleInvoiceInstruction: "Thao tác tạo hóa đơn {{actionName}} cho nhiều hóa đơn gồm 2 bước sau:",
        multipleInvoiceStep1: "Bước 1: Lập bảng kê chứa danh sách chi tiết hóa đơn sai sót cần {{title}}",
        multipleInvoiceStep2: "Bước 2: Tạo hóa đơn {{actionName}} gắn với Số bảng kê, Ngày bảng kê đã lập",
        askCreateInvoiceList: "Bạn có muốn lập bảng kê đính kèm không?",
        createInvoiceSkipList: "Lập hóa đơn, bỏ qua bước lập bảng kê",
        createInvoiceWithList: "Lập bảng kê đính kèm",
        invoiceCreationDate: "Ngày lập",
        paymentType: "HT thanh toán",
        storeName: "Tên cửa hàng",
        pumpCode: "Mã vòi bơm",
        customerCode: "Mã khách hàng",
        entityName: "Tên đơn vị",
        buyerContact: "Người mua hàng",
        citizenId: "Căn cước công dân",
        identityCard: "CCCD",
        budgetUnitCode: "Mã đơn vị quan hệ ngân sách",
        buyerCode: "Mã KH",
        vehiclePlate: "Biển số xe",
        buyerDisplayName: "Tên người mua",
        provinceCode: "Mã tỉnh",
        wardCode: "Mã xã",
        passport: "Số hộ chiếu",
        productType: "Chọn loại hàng",
        totalPayment: "Tổng tiền thanh toán",
        liters: "Số lít",
        unitPriceInclVat: "Đơn giá (Bao gồm VAT)",
        totalBeforeTax: "Tổng tiền trước thuế",
        totalTax: "Tổng tiền thuế",
        amountInWords: "Tổng tiền bằng chữ",
        oilInvoice: "Hóa đơn xăng dầu",
        note: "Ghi chú",
        sellerTaxCode: "Mã số thuế bên bán",
        buyerTaxCode: "Mã số thuế bên mua",
        invoiceListNo: "Số bảng kê",
        invoiceListDate: "Ngày bảng kê",
        sellerName: "Tên đơn vị bán",
        buyerAddress: "Địa chỉ người mua",
        sellerAddress: "Địa chỉ bên bán",
        generalInfo: "Thông tin chung",
        sellerInfo: "Thông tin bên bán",
        buyerInfo: "Thông tin bên mua",
        relatedInvoiceInfo: "Hóa đơn liên quan",
        otherInfo: "Thông tin khác",
        grandTotal: "Tổng cộng",
        preview: "Xem trước",
        confirmCreateInvoiceWithList: "Xác nhận tạo hóa đơn kèm bảng kê",
        reviewInvoiceList: "Xem lại bảng kê",
        confirmation: "Xác nhận",
        checkInvoiceAndList: "Vui lòng kiểm tra kỹ thông tin hóa đơn và bảng kê trước khi xác nhận.",
        discountedInvoiceListTitle: "Danh sách hóa đơn được chiết khấu theo doanh số",
        discountInvoiceAttachmentTitle: "Bảng kê đính kèm hóa đơn chiết khấu",
        commercialDiscountInvoice: "Lập hóa đơn Chiết khấu thương mại",
        syncFromSigningTool: "Đồng bộ từ tool ký",
        syncInvoice: "Đồng bộ hóa đơn",
        taxPayerCodeShort: "MST người bán",
        currentInvoiceStatus: "Trạng thái HĐ hiện tại",
        taxAuthorityInvoiceStatus: "Trạng thái HĐ tại CQT",
        queryTaxAuthority: "Kiểm tra trên CQT",
        taxAuthorityFeatureRestriction: "Chức năng chỉ áp dụng với các hóa đơn có Trạng thái gửi CQT: Đang gửi, Thành công, Có lỗi",
        statusMatches: "Trạng thái hóa đơn trùng khớp.",
        statusChanged: "Trạng thái hóa đơn có thay đổi!",
        original: "Gốc",
        statusCancelled: "Hủy",
        statusWaitingApproval: "Chờ duyệt",
        statusWaitingSignature: "Chờ ký",
        statusSigning: "Đang ký",
        statusSigned: "Đã ký",
        statusSending: "Đang gửi",
        statusSuccessful: "Thành công",
        statusFailed: "Có lỗi",
        statusAdjustment: "Điều chỉnh",
        statusReplacement: "Thay thế",
        statusExplanation: "Giải trình",
        statusAdjusted: "Bị điều chỉnh",
        statusReplaced: "Bị thay thế",
        itemGoodsService: "Hàng hóa dịch vụ",
        itemPromotion: "Khuyến mại",
        itemCommercialDiscount: "Chiết khấu thương mại",
        itemDescription: "Ghi chú diễn giải",
        itemSpecialGoods: "Hàng hóa đặc trưng",
        beingCancelled: "Hủy",
        beingAdjusted: "Bị điều chỉnh",
        beingReplaced: "Bị thay thế",
        restoreStatus: "Khôi phục trạng thái",
        paymentCompleted: "Hóa đơn đã được thanh toán",
        paymentCompletedWithNumber: "Hóa đơn {{serial}} số {{number}} đã được thanh toán",
        paymentPending: "Hóa đơn chờ thanh toán",
        unitCode: "Mã đơn vị tính",
        unitName: "Tên đơn vị tính",
        salePrice: "Giá bán",
        bulkTaxChange: "Thay đổi thuế suất hàng loạt",
        lookupAccount: "Tạo tài khoản tra cứu hóa đơn",
        createLookupUser: "Tạo User tra cứu",
        customerAccountCreated: "Đã tạo tài khoản",
        customerName: "Tên khách hàng",
        emailSeparatorPlaceholder: "Email ngăn cách bởi dấu , hoặc ;",
        searchCccdNotFound: "Không tìm thấy dữ liệu CCCD.",
        searchCccdError: "Lỗi khi tìm kiếm CCCD.",
        searchTaxDataNotFound: "Không tìm thấy dữ liệu",
        searchTaxDataError: "Lỗi khi tìm kiếm MST.",
        searchTaxDataV2Error: "Lỗi khi tìm kiếm MST (V2).",
        electronicSocialInsurance: "Bảo hiểm xã hội điện tử",
        invoiceRiskManagement: "Quản lý rủi ro hóa đơn mSMI",
        electronicContract: "Hợp đồng điện tử",
        serviceTerms: "Đồng ý điều khoản dịch vụ",
        mqrTerms: "Đồng ý điều khoản MQR",
        applyNewTaxRate: "Áp dụng thuế suất mới",
        changeTaxRate: "Chuyển đổi thuế suất",
        convert: "Chuyển đổi",
        editor: "Người sửa",
        calculationMethod: "Cách tính",
        saveAndExportDiscountInvoice: "Lưu và xuất hóa đơn chiết khấu",
        addInvoice: "Thêm hóa đơn",
        deleteInvoiceRow: "Xóa dòng HĐ",
        discountedInvoiceHint: "Vui lòng ấn \"Thêm hóa đơn\" để lấy danh sách hóa đơn lên bảng kê hóa đơn chiết khấu",
        currencyUnit: "Đơn vị tiền tệ",
        exchangeRate: "Tỷ giá",
        taxAuthorityShortCode: "Mã CQT",
        fillRequiredInfo: "Vui lòng nhập đầy đủ thông tin",
        invoiceNotSelected: "Chưa chọn hóa đơn",
        discount: "Chiết khấu",
        multipleInvoices: "Nhiều HĐ",
        paid: "Đã thanh toán",
        unpaid: "Chưa thanh toán",
        invoiceSelectionRequired: "Bạn cần chọn hóa đơn trước khi thao tác",
        printInvoiceSelectionRequired: "Bạn cần chọn hóa đơn trước khi Xem in",
        signInvoiceSelectionRequired: "Bạn cần chọn hóa đơn trước khi Ký",
        emailInvoiceSelectionRequired: "Bạn cần chọn hóa đơn trước khi Gửi email",
        onlyWaitingSignature: "Chỉ được phép thao tác với hóa đơn Chờ ký",
        invalidReplaceStatus: "Bạn chỉ được Thay thế hóa đơn ký gửi thành công ở trạng thái Gốc hoặc Thay thế",
        invalidAdjustStatus: "Bạn chỉ được Điều chỉnh hóa đơn ký gửi thành công ở trạng thái Gốc hoặc Bị điều chỉnh",
        invalidDeleteStatus: "Bạn không được Xóa hóa đơn Đã ký, Đã gửi, Thành Công, Có lỗi",
        signTimeWarningTitle: "Cảnh báo ký gửi hóa đơn sai thời điểm",
        continueSign: "Có, tiếp tục ký",
        restoreInvoiceStatusQuestion: "Bạn có thực sự muốn khôi phục trạng thái hóa đơn về Chờ ký để gửi lại CQT không?",
        retrieveSuccessMessageQuestion: "Bạn có thực sự muốn lấy lại thông điệp thành công?",
        restoreSuccess: "Khôi phục thành công",
        retrieveSuccess: "Lấy thành công",
        reloadSuccess: "Tải lại thành công",
        execute: "Thực hiện",
        check: "Kiểm tra",
        transactionInfo: "Thông tin giao dịch",
        invoiceTransferHistory: "Lịch sử truyền nhận hóa đơn",
        invoiceEmailHistory: "Lịch sử gửi email",
        checkEmailHistory: "Kiểm tra lịch sử gửi email",
        sentDate: "Ngày gửi",
        sentStatus: "Trạng thái gửi",
        viewed: "Đã xem",
        notViewed: "Chưa xem",
        emailRecipientPlaceholder: "Nhập email người nhận trước khi gửi email",
        emailRequired: "Địa chỉ Email không được để trống",
        emailInvalidAtIndex: "Email thứ {{index}} không hợp lệ",
        invoiceHeader: "Hóa đơn",
        invoiceTypeApplied: "Loại hóa đơn áp dụng",
        noticeType: "Loại thông báo",
        noticeNumber: "Số thông báo",
        noticeDate: "Ngày thông báo",
        taxAuthority: "Cơ quan thuế",
        taxPayer: "Người nộp thuế",
        creationPlace: "Nơi lập",
        invoiceReason: "Lý do sai sót",
        sampleNumber: "Mẫu số",
        invoiceProperty: "Tính chất hóa đơn",
        statementHistory: "Lịch sử biên bản",
        columnName: "Tên cột",
        columnWidth: "Độ rộng (px)",
        total: "Tổng cộng",
        restoreDefault: "Lấy lại mặc định",
        view: "Xem",
        print: "In",
        select: "Chọn",
        choose: "Lựa chọn",
        loading: "Đang tải...",
        empty: "Không có dữ liệu",
        noResults: "Không tìm thấy kết quả",
        success: "Thành công",
        error: "Có lỗi xảy ra",
        requestError: "Có lỗi xảy ra. Vui lòng kiểm tra lại nghiệp vụ",
        updated: "Dữ liệu đã được cập nhật!",
        invalidData: "Dữ liệu không hợp lệ, vui lòng kiểm tra lại",
        sequenceNumber: "Số thứ tự",
        description: "Mô tả",
        taxCode: "Mã số thuế",
        user: "Người dùng",
        profile: "Tài khoản",
        notifications: "Thông báo",
        digitalTransformationNotice: "Kính mời quý khách hàng đọc ấn phẩm Thông tin chuyển đổi số 04",
        guide: "Hướng dẫn",
        changePassword: "Đổi mật khẩu",
        logout: "Đăng xuất",
        home: "Trang chủ",
        mst: "MST",
        accept: "Đồng ý",
        rejectAction: "Từ chối",
        requiredField: "{{field}} là bắt buộc",
        selectField: "Vui lòng chọn {{field}}",
        fileDownloadFailed: "Tải xuống thất bại!",
        errorCode: "Có lỗi xảy ra [MÃ {{code}}]",
        continueSaving: "Bạn có muốn tiếp tục lưu không?",
        minutes: "phút",
        currentPassword: "Mật khẩu hiện tại",
        pinCode: "Mã PIN",
        certificatePassword: "Mật khẩu chứng thư số",
        applicationId: "ID ứng dụng",
        uploadCertificateFile: "Tải lên tệp chứng thư số",
        validCertificateFileFormat: "Định dạng hợp lệ là tệp đuôi .p12 hoặc .fpx",
        signingServerSetup: "Thiết lập kết nối đến máy chủ ký số",
        certificateConnectionInfo: "Thông tin kết nối do đơn vị cung cấp chứng thư số cấp",
        addCertificate: "Thêm chứng thư số",
        editCertificate: "Sửa chứng thư số",
        deleteCertificate: "Xóa chứng thư số",
        changeCertificatePassword: "Đổi mật khẩu",
        defaultSign: "Mặc định ký",
        cancelNoticeTypeTaxpayer: "Thông báo hủy/giải trình của Người nộp thuế",
        cancelNoticeTypeTaxAuthority: "Thông báo hủy/giải trình của Người nộp thuế theo thông báo của Cơ quan thuế",
        taxAuthorityNoticeHint: "Lưu ý: Để thông báo hóa đơn sai sót, Quý khách hàng cần cập nhật đúng mã cơ quan thuế quản lý",
        here: "Tại đây",
        sendErrorNoticeQuestion: "Bạn có muốn gửi thông báo hóa đơn sai sót đến Cơ quan thuế theo mẫu 04/SS-HĐĐT ngay không?",
        signSS04: "Ký gửi 04/SS-HĐĐT",
        sendLater: "Không, tôi sẽ gửi sau",
        invoiceListInvalid: "Danh sách hóa đơn không hợp lệ",
        wrongInvoiceReasonRequired: "Lý do sai sót hóa đơn số {{number}} không được để trống.",
        certificateDataInvalid: "Dữ liệu không hợp lệ",
        selectCertificateRequired: "Vui lòng chọn một chứng thư số",
        usedCertificateCannotDelete: "Các chứng thư số đang được sử dụng không được xóa",
        unsupportedCertificatePasswordChange: "Loại chứng thư số không hỗ trợ đổi mật khẩu",
        fees: "Phí, lệ phí",
        otherInformation: "Thông tin khác",
        nonTaxableDeduction: "Giảm trừ KCT",
        otherDeduction: "Giảm trừ khác",
        specialInvoice: "Hóa đơn đặc trưng",
        variableName: "Tên biến",
        labelWidth: "Độ rộng nhãn",
        valueWidth: "Độ rộng giá trị",
        maxLength: "Giới hạn ký tự",
        decimalPlaces: "Thập phân",
        editable: "Cho phép sửa",
        multipleFormula: "Nhiều công thức",
        group: "Nhóm",
        requiredInput: "Bắt buộc nhập",
        excelFormula: "Công thức Excel",
        excelColumnTitle: "Tiêu đề cột Excel",
        calculationOrder: "Thứ tự tính",
        excelValue: "Giá trị Excel",
        xmlGroup: "Nhóm XML",
        sort: "Sắp xếp",
        cancelRecordQuestion: "Bạn chắc chắn muốn hủy bản ghi này?",
        cancelRecord: "Xác nhận hủy",
        deleteRecordQuestion: "Bạn chắc chắn muốn xóa bản ghi này?",
        deleteData: "Xác nhận xóa dữ liệu",
        signAndSendQuestion: "Bạn có chắc chắn muốn ký và gửi CQT không?",
        signAndSend: "Ký và gửi CQT",
        signedStatementWarning: "Biên bản đã ký. Thao tác này sẽ làm mất chữ ký số trước đó.",
        notice: "Thông báo",
        restorePermissionQuestion: "Bạn chắc chắn khôi phục về toàn quyền dữ liệu?",
        restorePermission: "Khôi phục quyền",
        taxAuthorityCodeQuestion: "Bạn chắc chắn xác nhận lấy lại mã cơ quan thuế đối với hóa đơn ở trạng thái đã gửi và gửi lỗi?",
        getTaxAuthorityCode: "Lấy lại mã cơ quan thuế",
        changeTaxQuestion: "Bạn chắc chắn áp dụng thuế suất cho tất cả mặt hàng đã chọn?",
        changeTax: "Xác nhận chuyển thuế suất",
        updateSellerInfoQuestion: "Bạn có chắc chắn muốn cập nhật thông tin bên bán trên hóa đơn theo thông tin doanh nghiệp đã khai báo?",
        updateSellerInfo: "Cập nhật thông tin bên bán",
        machineInvoiceWarning: "Theo quy định hiện hành, hóa đơn điện tử từ máy tính tiền lập sai phải được thay thế. Bạn có muốn tiếp tục điều chỉnh hóa đơn này không?",
        registeredAssetInvoiceAdjustmentWarning: "Theo quy định Thông tư 91/2026/TT-BTC, Hóa đơn bán tài sản đăng ký quyền sở hữu, sử dụng chỉ được phép thực hiện Lập Hóa đơn Thay thế. Bạn có muốn chuyển sang Lập hóa đơn thay thế không?",
        replaceInvoice: "Thay thế hóa đơn",
        continueAdjustment: "Tiếp tục Điều chỉnh",
        warning: "Cảnh báo",
        permissionQuestion: "Tài khoản vừa tạo sẽ được sử dụng toàn bộ ký hiệu hóa đơn, chữ ký số và quyền xem hóa đơn của tài khoản khác. Bạn có muốn phân quyền chi tiết thêm không?",
        products: "Sản phẩm",
        purchases: "Mua hàng",
        registerAgent: "Đăng ký đại lý",
        sign: "Ký điện tử",
        socialDemo: "Demo",
        settings: "Cài đặt",
        displayScale: "Kích thước hiển thị",
        theme2022: "Giao diện IAM Software - 2022",
        theme2021: "Giao diện IAM Software - 2021",
        certificateNotConfigured: "Bạn chưa đăng ký chứng thư số hoặc chưa được phân quyền chứng thư số.",
        selectCertificate: "Chọn chứng thư số",
        certificateProvider: "Tên đơn vị cấp chứng thư số",
        certificateOwner: "Tên chủ sở hữu",
        certificateType: "Loại",
        tokenIssuer: "Tên tổ chức cơ quan chứng thực/cấp/công nhận chữ ký số, chữ ký điện tử",
        tokenSerial: "Số sê-ri chứng thư",
        tokenRegistrationForm: "Hình thức đăng ký",
        tokenFormNew: "Thêm mới",
        tokenFormRenew: "Gia hạn",
        tokenFormDiscontinued: "Ngừng sử dụng",
        add: "Thêm",
        pauseInvoiceGuideTitle: "Đề nghị tạm ngừng sử dụng hóa đơn điện tử",
        pauseInvoiceGuideIntro: "Khai báo các thông tin đăng ký tạm ngừng sử dụng hóa đơn điện tử khi:",
        pauseInvoiceGuideReason: "Doanh nghiệp tạm ngừng kinh doanh, giải thể hoặc theo yêu cầu của CQT",
        guideNote: "Lưu ý",
        pauseInvoiceGuideDateRule: "Ngày bắt đầu và kết thúc ngừng sử dụng:",
        pauseInvoiceGuideDateRequired: "Hai thông tin này bắt buộc nhập",
        pauseInvoiceGuideDateAfterDeclaration: "Ngày bắt đầu ngừng sử dụng phải lớn hơn ngày lập tờ khai",
        pauseInvoiceGuideDateOrder: "Ngày bắt đầu ngừng sử dụng phải nhỏ hơn ngày kết thúc ngừng sử dụng",
        pauseInvoiceGuideMultipleProviders: "Nếu sử dụng nhiều phần mềm phát hành hóa đơn điện tử khác nhau, đơn vị cần khai báo đầy đủ thông tin của các tổ chức cung cấp dịch vụ đăng ký tạm ngừng sử dụng.",
        pauseInvoiceGuideSpecificCertificate: "Chỉ khai báo số sê-ri chứng thư số nếu đơn vị cần đăng ký tạm ngừng sử dụng cho 1 hoặc nhiều chứng thư số cụ thể. Trường hợp đăng ký ngừng sử dụng cho toàn bộ chứng thư số thì có thể để trống thông tin này.",
        pluginUpdate: "Cập nhật M-INVOICE Plugin",
        pluginDownload: "Tải bộ cài",
        pluginVersionRequirement: "Ký USB hóa đơn điều chỉnh/thay thế nhiều kèm bảng kê yêu cầu M-INVOICE Plugin bản {{version}} trở lên. Vui lòng cập nhật plugin rồi ký lại.",
        jobNotFound: "Không tìm thấy job",
        resumeSuccess: "Tiếp tục chạy job thành công",
        retryError: "Có lỗi xảy ra. Vui lòng thử lại",
        exportErrorTitle: "Lỗi kết xuất dữ liệu",
        exportErrorMessage: "Không thể tạo báo cáo do lỗi hệ thống.",
        errorDetails: "Chi tiết lỗi:",
        copiedError: "Đã sao chép lỗi",
        exportProgress: "Đang kết xuất dữ liệu",
        exportSuccess: "Đã kết xuất thành công",
        exportFailed: "Kết xuất thất bại",
        records: "bản ghi",
        exportRunningMessage: "Quá trình kết xuất dữ liệu đang chạy. Vui lòng đợi.",
        currentlyExported: "Hiện tại đã kết xuất được",
        filesInZip: "Có tổng cộng {{count}} trong file.zip",
        viewDetails: "Xem chi tiết",
        continue: "Tiếp tục",
        exportSuccessMessage: "Kết xuất dữ liệu thành công",
        templateCode: "Mã mẫu",
        templateName: "Tên mẫu",
        invoiceType: "Loại hóa đơn",
        invoiceTemplate: "Mẫu hóa đơn",
        financialYearTemplateTitle: "TẠO MẪU HÓA ĐƠN THEO NĂM TÀI CHÍNH",
        copyInvoiceTemplate: "Copy mẫu hóa đơn",
        financialYearTemplateNotice: "Theo nghị định 123/2020/NĐ-CP và Thông tư 78/2021/TT-BTC, Ký hiệu hóa đơn được đánh theo năm và số hóa đơn bắt đầu lại số 1 từ 01/01 hoặc ngày bắt đầu sử dụng hóa đơn điện tử. Quý khách vui lòng tích chọn các ký hiệu cần sử dụng và ấn Copy mẫu hóa đơn để chuyển sang năm sau.",
        paperSize: "Khổ giấy",
        paperOrientation: "Hướng giấy",
        charactersPerLine: "Số ký tự 1 dòng",
        caseConversion: "Quy đổi hoa thường",
        linesPerPage: "Số dòng nhiều trang",
        blankLines: "Số dòng trắng",
        showSequence: "Hiện STT",
        htmlFile: "File html",
        imageFile: "File ảnh",
        image: "Hình ảnh",
        creator: "Người tạo",
        createdDate: "Ngày tạo",
        companyType: "Loại doanh nghiệp",
        normal: "Thông thường",
        petroleum: "Xăng dầu",
        jewelry: "Vàng bạc",
        airline: "Vé máy bay",
        vehicleSales: "Mua bán xe",
        vehicleSalesNd254: "Mua bán xe NĐ 254",
        transportation: "Dịch vụ vận chuyển",
        digitalTransportation: "Dịch vụ vận chuyển trên nền tảng số",
        previewFiles: "Xem file mẫu và ảnh",
        notificationManagement: "Quản lý thông báo",
        notificationTitle: "Tiêu đề",
        effectiveFrom: "Hiệu lực từ ngày",
        effectiveTo: "Hiệu lực đến ngày",
        active: "Sử dụng",
        priority: "Thứ tự ưu tiên",
        errorHelp: "Hướng dẫn xử lý lỗi",
        messageType: "Loại thông điệp",
        messageCode: "Mã thông điệp",
        errorCodeLabel: "Mã lỗi",
        errorReason: "Nguyên nhân lỗi",
        resolution: "Cách xử lý",
        recommendation: "Khuyến nghị của M-Invoice",
        recoverPassword: "Lấy lại mật khẩu",
        recoverByEmail: "Vui lòng nhập mã số thuế và email để lấy lại mật khẩu",
        recoverByToken: "Vui lòng cắm USB Token và cài Plugin ký để lấy lại mật khẩu",
        confirmPassword: "Xác nhận mật khẩu",
        newPassword: "Mật khẩu mới",
        passwordMismatch: "Mật khẩu nhập lại không đúng",
        fieldFormatInvalid: "{{field}} không đúng định dạng",
      },
      declarationGuidance: {
        authDirectTitle: "Hướng dẫn xác thực trực tiếp tại CQT",
        authDirectSubject: "Người đại diện theo pháp luật là người nước ngoài không đủ điều kiện thực hiện xác thực sinh trắc học trên ứng dụng eTax Mobile hoặc các trường hợp đặc biệt theo yêu cầu của cơ quan thuế.",
        authDirectDeadline: "Trong ngày làm việc hoặc chậm nhất ngày làm việc tiếp theo kể từ khi nhận được thông báo yêu cầu xác thực trực tiếp.",
        authDirectDocumentId: "Căn cước công dân hoặc Hộ chiếu bản gốc.",
        authDirectDocumentPortrait: "Bản photo ảnh chân dung.",
        authDirectDocumentNotice: "Bản in thông báo hoặc tờ khai đang chờ xác thực trên hệ thống (nếu có).",
        authDirectSteps: "Người nộp thuế đến CQT đang trực tiếp quản lý doanh nghiệp, xuất trình CCCD hoặc Hộ chiếu bản gốc, ảnh chân dung và thực hiện sinh trắc học theo yêu cầu của CQT.",
        authBiometricTitle: "Hướng dẫn xác thực sinh trắc học - eTax Mobile",
        authBiometricSubjectFirst: "Trường hợp đăng ký sử dụng hóa đơn điện tử lần đầu hoặc",
        authBiometricSubjectSecond: "Các lần thay đổi thông tin nếu có thay đổi thông tin Người đại diện pháp luật.",
        authBiometricDeadline: "Trong ngày làm việc hoặc chậm nhất ngày làm việc tiếp theo kể từ khi nhận được thông báo yêu cầu xác thực sinh trắc học.",
        authOtpTitle: "Hướng dẫn xác thực OTP - eTax Mobile",
        authOtpSubject: "Trường hợp đăng ký thay đổi thông tin sử dụng HĐĐT như thông tin người nộp thuế, chứng thư số ký tờ khai/hóa đơn, cơ quan thuế quản lý, hình thức hóa đơn, hình thức/phương thức gửi dữ liệu HĐĐT, loại hóa đơn,…nhưng không thay đổi thông tin người đại diện pháp luật.",
        authOtpDeadline: "Trong ngày làm việc hoặc chậm nhất ngày làm việc tiếp theo kể từ khi nhận được thông báo yêu cầu xác thực OTP.",
        mobileSteps: "Mở ứng dụng eTax Mobile và thực hiện xác nhận theo hướng dẫn",
        explanationTitle: "Hướng dẫn giải trình hóa đơn rủi ro",
        explanationSubjectFirst: "Doanh nghiệp thay đổi người đại diện pháp luật (Người đại diện pháp luật mới sai lệch dữ liệu CCCD/VNeID hoặc có lịch sử nợ thuế, vi phạm thuế ở doanh nghiệp cũ).",
        explanationSubjectSecond: "Doanh nghiệp thay đổi trụ sở sang địa chỉ ảo, chung cư không được kinh doanh, hoặc trùng địa chỉ với doanh nghiệp bỏ trốn.",
        explanationSubjectThird: "Doanh nghiệp mới thành lập hoặc vừa hoạt động trở lại thuộc nhóm thương mại, bán buôn, logistics có vốn ảo, thiếu kho bãi.",
        explanationDeadline: "Trong ngày làm việc hoặc chậm nhất ngày làm việc tiếp theo kể từ khi nhận được thông báo yêu cầu giải trình thông tin.",
        explanationStepFirst: "Kiểm tra thông báo chi tiết từ CQT để biết lý do cần giải trình (mã lỗi rủi ro).",
        explanationStepSecond: "Chuẩn bị hồ sơ chứng minh (CCCD, Giấy phép ĐKKD, Hợp đồng thuê VP/hình ảnh trụ sở).",
        explanationStepThird: "Soạn công văn giải trình, nộp kèm hồ sơ trực tuyến qua hệ thống eTax hoặc nộp trực tiếp tại CQT.",
        commonNote: "Sau khi xác nhận, cơ quan thuế sẽ tiếp tục kiểm tra thông tin người nộp thuế và phản hồi nếu cần bổ sung.",
        qrUnavailable: "Không tải được mã QR",
        qrAlt: "Mã QR tải eTax Mobile trên {{storeName}}",
        openStore: "Mở {{storeName}} để tải eTax Mobile",
        fallbackTitle: "Hướng dẫn",
        close: "Đóng hướng dẫn",
        subject: "Đối tượng thực hiện",
        deadline: "Thời gian thực hiện",
        documents: "Hồ sơ chuẩn bị",
        method: "Cách thực hiện",
        openGuide: "TẠI ĐÂY",
        qrCaption: "Scan để tải ứng dụng eTax Mobile",
      },
      auth: {
        username: "Tên đăng nhập",
        password: "Mật khẩu",
        rememberMe: "Ghi nhớ đăng nhập",
        login: "Đăng nhập",
        forgotPassword: "Quên mật khẩu?",
        registerPrompt: "Chưa có tài khoản?",
        register: "Đăng ký",
        loginTitle: "Đăng nhập",
        forgotPasswordTitle: "Quên mật khẩu",
        email: "Email",
        send: "Gửi",
        resetPassword: "Đặt lại mật khẩu",
        forgotPasswordSuccess: "Yêu cầu đặt lại mật khẩu đã được gửi.",
        forgotPasswordSuccessEmail: "Vui lòng kiểm tra email để tiếp tục.",
        forgotPasswordSuccessToken: "Vui lòng kiểm tra USB Token để tiếp tục.",
        recoverByEmailSuccess: "Mật khẩu mới đã được gửi về email của quý khách. Vui lòng sử dụng mật khẩu mới để đăng nhập.",
        recoverByTokenSuccess: "Mật khẩu của quý khách đã được thay đổi. Vui lòng sử dụng mật khẩu mới để đăng nhập.",
        backToLogin: "Quay lại đăng nhập",
        signStatementTitle: "Xác nhận ký biên bản",
      },
      menu: {
        invoice: "Hóa đơn",
        issue: "Phát hành",
        history: "Lịch sử truyền nhận",
        errors: "Xử lý sai sót",
        reports: "Báo cáo",
        catalog: "Danh mục",
        system: "Hệ thống",
        configuration: "Cấu hình",
        languageCustomization: "Tùy chỉnh ngôn ngữ",
        bilingualVietnameseEnglish: "Song ngữ (Việt - Anh)",
        signCustomization: "Tùy chỉnh ký",
        signImmediately: "Ký hóa đơn gửi ngay CQT",
        signSummaryAtPeriodEnd: "Ký hóa đơn gửi bảng tổng hợp cuối kỳ",
        colorCustomization: "Tùy chỉnh màu",
        fontCustomization: "Tùy chỉnh font",
        buyerCustomization: "Tùy chỉnh người mua",
        underlineBuyerValue: "Giá trị người mua có gạch chân",
        tableCustomization: "Tùy chỉnh bảng",
        tableRowBorders: "Bảng có dòng kẻ hàng",
        columnSymbolRows: "Thiết lập số dòng ký hiệu cột",
        blankRows: "Số dòng trắng",
        multiPageInvoiceRows: "Số dòng hóa đơn nhiều trang",
        signatureLabelCustomization: "Tùy chỉnh nhãn ký",
        headSignature: "Chữ ký thủ trưởng",
        emailInvoice: "Hóa đơn gửi email",
        htmlFormat: "Định dạng Html",
        invoiceType: "Loại hóa đơn",
        templatePrintRows: "Số dòng in mẫu",
        creator: "Người lập",
        active: "Sử dụng",
        viewInvoiceTemplate: "Xem mẫu hóa đơn",
        copyInvoiceTemplate: "Copy mẫu hóa đơn",
        printConvertedInvoice: "In chuyển đổi",
        logoBackground: "Logo - Hình nền",
        detailCustomization: "Tùy chỉnh chi tiết",
        saveInfo: "Lưu thông tin",
        logoFileSizeExceeded: "Dung lượng file logo không được vượt quá 100KB",
        imageFileRequired: "File phải là định dạng hình ảnh",
        logoDimensionExceeded: "Kích thước logo vượt quá giới hạn. Kích thước tối đa: {{width}}x{{height}}px",
        imageReadFailed: "Không thể đọc file hình ảnh",
        borderFileSizeExceeded: "Dung lượng file upload không được vượt quá 300kb",
        borderDimensionExceeded: "Kích thước khung viền vượt quá giới hạn, khuyến cáo dưới: {{pageSize}}: {{width}} x {{height}}",
        backgroundFileSizeExceeded: "Dung lượng file hình nền không được vượt quá 200KB",
        backgroundDimensionExceeded: "Kích thước hình nền vượt quá giới hạn. Kích thước tối đa: {{width}}x{{height}}px",
        useQrCode: "Sử dụng QR code",
        sizeCustomization: "Tùy chỉnh kích thước",
        useLogo: "Sử dụng logo",
        chooseLogoFromComputer: "Chọn từ máy tính dung lượng không quá 100KB",
        maxDimension: "Kích thước tối đa: ({{dimension}})",
        useBackground: "Sử dụng hình nền",
        chooseImageFromComputer: "Chọn ảnh từ máy tính",
        chooseBackgroundFromLibrary: "Chọn ảnh nền từ thư viện",
        chooseBackgroundFromComputer: "Chọn từ máy tính dung lượng không quá 200KB",
        opacity: "Độ mờ",
        useBorder: "Sử dụng khung viền",
        chooseBorderFromComputer: "Chọn từ máy tính dung lượng không quá 300Kb",
        maxPageDimension: "Kích thước tối đa {{pageSize}}: ({{width}}x{{height}})",
        issueRegistration: "Đăng ký phát hành",
        declaration123: "Tờ khai đăng ký/thay đổi NĐ123/2020",
        declaration70: "Tờ khai đăng ký/thay đổi NĐ70/2025-NĐ254/2026",
        outputInvoice: "Hóa đơn đầu ra",
        errorNotification: "Thông báo HĐ sai sót 04/SS-HĐĐT",
        invoiceReplacement: "Thay thế hóa đơn",
        invoiceAdjustment: "Điều chỉnh hóa đơn",
        invoiceCancellation: "Hủy hóa đơn",
        otherInvoiceReplacement: "Thay thế hóa đơn trên hệ thống khác",
        otherInvoiceAdjustment: "Điều chỉnh hóa đơn trên hệ thống khác",
        multipleInvoiceReplacement: "Thay thế nhiều hóa đơn",
        multipleInvoiceAdjustment: "Điều chỉnh nhiều hóa đơn",
        electronicInvoiceN123: "Hóa đơn điện tử NĐ123,NĐ70,NĐ254",
        authenticatedInvoiceQD1209: "Hóa đơn xác thực QĐ1209",
        invoiceN51: "Hóa đơn NĐ51",
        preprintedInvoiceN123: "Hóa đơn đặt in NĐ123",
        commercialDiscountInvoiceTypeName: "hóa đơn chiết khấu thương mại đính kèm bảng kê",
        inside: "Trong",
        outside: "Ngoài",
        invoiceList: "Bảng kê điều chỉnh/thay thế",
        invoiceDiscountList: "Bảng kê Hóa đơn chiết khấu",
        declaration: "Tờ khai đăng ký",
        paymentHistory: "Lịch sử thanh toán QRCode",
        usageReport: "Báo cáo tình hình sử dụng hóa đơn",
        invoiceSummaryReport: "Báo cáo tổng hợp hóa đơn",
        invoiceDetailReport: "Báo cáo chi tiết hóa đơn",
        pmktReport: "Báo cáo nhận vào PMKT",
        plReport: "Báo cáo PL101/2023/QH15",
        salesReport: "Báo cáo bảng kê bán ra (PL01)",
        petrolReport: "Báo cáo xăng dầu mẫu thuế",
        summary01Report: "Lập bảng tổng hợp mẫu 01/TH-HĐĐT",
        mstStatus: "Kiểm tra trạng thái MST",
        bank: "Ngân hàng",
        businessLocation: "Địa điểm kinh doanh",
        petrolManagement: "Quản lý xăng dầu",
        petrolStore: "Cửa hàng xăng dầu",
        petrolProduct: "Mặt hàng xăng dầu",
        pump: "Vòi bơm",
        integratedDevices: "Danh mục thiết bị tích hợp",
        petrolTransactions: "Danh sách giao dịch xăng dầu",
        petrolInvoiceConfig: "Cấu hình tạo hóa đơn xăng dầu",
        companyManagement: "Quản lý doanh nghiệp",
        companyInfo: "Thông tin doanh nghiệp",
        license: "Bản quyền",
        userManagement: "Quản lý người dùng",
        digitalCertificateRegistration: "Đăng ký chứng thư số",
        systemParameterDeclaration: "Khai báo tham số hệ thống",
        invoiceConfiguration: "Cấu hình hóa đơn",
        valueReplacement: "Giá trị thay thế",
        defaultValue: "Giá trị mặc định",
        invoiceTemplateManagement: "Quản trị - Quản lý mẫu hóa đơn",
      },
      validation: {
        required: "{{field}} là bắt buộc",
        multiInvoiceCashRegisterRestricted: "Cơ quan thuế chỉ cho phép {{actionName}} nhiều hoá đơn loại Có mã, Không mã",
        multiInvoiceRegisteredAssetRestricted: "Cơ quan thuế chưa hỗ trợ nghiệp vụ này cho hóa đơn mua bán xe",
        invalid: "{{field}} không hợp lệ",
        businessLocationCodeLengthHouseholdOrBranch: "Mã địa điểm kinh doanh của Hộ kinh doanh/Cá nhân kinh doanh không được dài quá 5 ký tự",
        businessLocationCodeLengthPetrolBusiness: "Mã địa điểm kinh doanh của Doanh nghiệp kinh doanh xăng dầu không được dài quá 14 ký tự",
        monthRange: "Tháng phải nằm trong khoảng từ 1 đến 12",
        quarterRange: "Quý phải nằm trong khoảng từ 1 đến 4",
        yearFormat: "Năm phải là một số nguyên có 4 chữ số",
        fromDateInvalid: "Điều kiện Từ ngày không hợp lệ",
        toDateInvalid: "Điều kiện Đến ngày không hợp lệ",
        dateRangeOrder: "Điều kiện Từ ngày phải nhỏ hơn hoặc bằng Đến ngày",
        dateRangeRequired: "Trường từ ngày - đến ngày không được để trống.",
        operatorRequired: "Toán tử {{field}} không được để trống.",
        invoiceStatusConditionInvalid: "Điều kiện tìm Trạng thái tạo hóa đơn không hợp lệ.",
        selectTransaction: "Chưa chọn giao dịch.",
        invoiceAlreadyCreated: "Bản ghi đã được tạo hóa đơn, không được tạo lại",
        invoiceCreationFailed: "Bản ghi tạo hóa đơn bị lỗi, không được tạo lại",
        invoiceCancelledCannotCreate: "Bản ghi đã Hủy, bạn không thể tạo hóa đơn",
        noData: "Không tìm thấy dữ liệu.",
        containsCreatedInvoice: "Danh sách lựa chọn chứa bản ghi đã tạo hóa đơn, vui lòng kiểm tra lại",
        containsUncreatedInvoice: "Danh sách lựa chọn chứa bản ghi chưa tạo hóa đơn, vui lòng kiểm tra lại",
        selectMultipleTransactions: "Vui lòng chọn nhiều hơn 1 bản ghi trước khi gom log hóa đơn",
        cancelledCannotEdit: "Giao dịch đã được Hủy, bạn không được Sửa lại.",
        previousVolumeInvalid: "Tổng khối lượng đã bơm lần trước không hợp lệ.",
        positiveDifferenceOnly: "Chỉ chọn giao dịch có chênh lệch lớn hơn 0.",
        alreadyCompensated: "Giao dịch đã được bù, không thể tạo thêm.",
        cannotCancelInvoiced: "Không hủy được giao dịch đã tạo hóa đơn.",
        alreadyCancelled: "Giao dịch đã được Hủy, bạn không được Hủy lại.",
        createInvoiceQuestion: "Bạn có muốn tạo hóa đơn cho các bản ghi này không?",
        groupTransactionQuestion: "Bạn có muốn gộp các giao dịch đã chọn lại không?",
        updateInvoiceNumberQuestion: "Xác nhận Cập nhật số hóa đơn cho {{count}} giao dịch",
        compensateTransactionQuestion: "Xác nhận bù giao dịch cho {{count}} giao dịch đang chọn",
        selectDevice: "Bạn cần chọn thiết bị trước khi sửa",
        selectProduct: "Bạn cần chọn hàng hóa trước khi sửa",
        selectProductForTaxChange: "Bạn cần chọn hàng hóa trước khi chuyển đổi thuế suất mới",
        selectCustomer: "Chưa chọn khách hàng",
        chooseStore: "Vui lòng chọn cửa hàng",
        enterSecurityCode: "Vui lòng nhập mã bảo mật",
        pecoDeviceIdMissing: "Không tìm thấy DeviceId hợp lệ cho cửa hàng đã chọn trong cấu hình DOI_GIA_TU_PECO.",
        pecoPriceUpdateFailed: "Không thể gửi yêu cầu đổi giá tới tủ PECO.",
        taxStatusNotFound: "Không tìm thấy thông tin",
        codeChars: "Chỉ được chữ, số, dấu gạch ngang (-) và gạch dưới (_).",
        taxCodeInvalid: "Mã số thuế không đúng",
        emailInvalid: "Email không hợp lệ",
        passwordRequired: "Mật khẩu là bắt buộc",
        wrongInvoiceDenominatorRange: "Mẫu số hóa đơn chỉ được nhập giá trị từ 1 đến 6",
        wrongInvoiceRelatedSerialLength: "Độ dài ký hiệu hóa đơn liên quan không hợp lệ.",
        wrongInvoiceFormChar: "Ký tự hình thức hóa đơn không hợp lệ",
        wrongInvoiceYearChar: "Ký tự năm của ký hiệu không hợp lệ",
        wrongInvoiceTypeChar: "Ký tự loại hóa đơn không hợp lệ",
        wrongInvoiceDenominatorLength: "Độ dài ký hiệu hóa đơn liên quan không hợp lệ.",
        wrongInvoiceFirstTypeChars: "Hai ký tự đầu về loại hóa đơn không hợp lệ",
        wrongInvoiceKindChars: "Bốn ký tự loại hóa đơn không hợp lệ",
        wrongInvoiceCopiesChar: "Ký tự số liên không hợp lệ",
        wrongInvoiceSeparator: "Ký tự phân cách trong ký hiệu không hợp lệ",
        wrongInvoiceIssueSequence: "Ba ký tự lần phát hành không hợp lệ",
        wrongInvoiceSerialLength: "Độ dài Ký hiệu hóa đơn không hợp lệ.",
        wrongInvoiceSerialPrefix: "Hai ký tự đầu không hợp lệ",
        wrongInvoiceSerialYear: "Ký tự năm phát hành không hợp lệ",
        wrongInvoiceSerialType: "Ký tự loại hình hóa đơn không hợp lệ",
        relatedInvoiceDateCannotBeFuture: "Ngày hóa đơn có liên quan không được lớn hơn ngày hiện tại",
        wrongInvoiceLine: "Dòng {{line}}: {{message}}",
      },
      invoice: {
        electronicInvoiceSolution: "Giải pháp hóa đơn điện tử",
        invoice: "Hóa đơn",
        printInvoice: "In HĐ",
        downloadPdf: "Tải PDF",
        signToTaxAuthority: "Ký gửi CQT",
        printSwitch: "In chuyển đổi",
        invoiceNumber: "Số hóa đơn",
        invoiceSymbol: "Ký hiệu hóa đơn",
        seller: "Bên bán",
        buyer: "Bên mua",
        lineItems: "Hàng hóa, dịch vụ",
        payment: "Thanh toán",
        signAndSend: "Ký và gửi CQT",
      },
      catalog: {
        unit: "Đơn vị tính",
        product: "Hàng hóa, dịch vụ",
        customer: "Khách hàng",
        currency: "Tiền tệ",
        paymentMethod: "Hình thức thanh toán",
        taxRate: "Thuế suất",
        businessLocation: "Địa điểm kinh doanh",
        businessLocationType: "Loại doanh nghiệp",
        businessLocationTypeHouseholdOrBranch: "Hộ kinh doanh/Cá nhân kinh doanh",
        businessLocationTypePetrolBusiness: "Doanh nghiệp kinh doanh xăng dầu",
        businessLocationCode: "Mã địa điểm kinh doanh",
        businessLocationName: "Tên địa điểm kinh doanh",
        businessLocationAddress: "Địa chỉ địa điểm kinh doanh",
        businessLocationHint: "Vui lòng khai báo Địa điểm kinh doanh cho Ký hiệu HĐ này",
        petrolStoreCode: "Mã cửa hàng",
        petrolStoreName: "Tên cửa hàng",
        petrolStoreAddress: "Địa chỉ cửa hàng",
        priceUpdateLink: "Liên kết cập nhật giá xăng",
        priceUpdateResult: "Kết quả cập nhật giá",
        oldPrice: "Giá cũ",
        newUnitPrice: "Đơn giá mới",
        iotPriceUpdateStatus: "Trạng thái cập nhật giá trên hệ thống IoT",
        priceChangeHistory: "Lịch sử điều chỉnh giá",
        pumpNozzleCode: "Mã vòi bơm",
        fuel: "Nhiên liệu",
        fuelCodeAtPump: "Mã nhiên liệu của vòi",
        fuelAtPump: "Nhiên liệu của vòi",
        pumpSeries: "Series vòi",
        measuringColumnType: "Kiểu cột đo",
        modelApproval: "Phê duyệt mẫu",
        maintenance: "Bảo trì",
        effectiveTime: "Thời gian áp dụng",
        expiryTime: "Thời gian hết hiệu lực",
        chooseStore: "Chọn cửa hàng",
        securityCode: "Mã bảo mật",
        newPrice: "Giá mới",
        pecoPriceChange: "Đổi giá xăng dầu tủ PECO",
        confirmPumpPriceUpdate: "Bạn có chắc chắn muốn cập nhật giá xuống vòi bơm không?",
        deviceCode: "Mã thiết bị",
        deviceName: "Tên thiết bị",
        integrationSymbol: "Ký hiệu",
        integrationType: "Loại tích hợp",
        paymentSpeaker: "Loa thanh toán",
        taxCode: "Mã thuế suất",
        currencyCode: "Mã tiền tệ",
        currencyName: "Tên tiền tệ",
        quantityDecimals: "Số chữ số thập phân của số lượng",
        unitPriceDecimals: "Số chữ số thập phân của đơn giá",
        totalDecimals: "Số chữ số thập phân của tổng tiền",
        taxDetailDecimals: "Số chữ số thập phân của tiền thuế chi tiết",
        taxAmountDecimals: "Số chữ số thập phân của tổng tiền thuế",
        readCurrency: "Đọc tiền tệ",
        readDecimal: "Đọc số thập phân",
        integratedDeviceCatalog: "Danh mục thiết bị tích hợp",
        createInvoiceFromTransactions: "Tạo hóa đơn từ danh sách giao dịch xăng dầu",
        productCode: "Mã hàng hóa",
        productName: "Tên hàng hóa",
        listedPrice: "Giá bán niêm yết",
        listedPriceWithVat: "Giá bán niêm yết (Đã bao gồm thuế GTGT)",
        invoicePrice: "Giá bán trên hóa đơn",
        mobileUsage: "Sử dụng trên ứng dụng di động",
        priceList: "Danh sách mệnh giá",
        order: "Thứ tự",
        paymentCode: "Mã",
        paymentName: "Tên",
        paymentMaximumValue: "Giá trị tối đa",
        emailTemplate: "Mẫu email",
        emailSubject: "Tiêu đề",
        emailUsage: "Sử dụng",
        emailBusinessType: "Loại nghiệp vụ",
        emailSendInvoice: "Gửi hóa đơn",
        emailSendConfirmation: "Gửi xác nhận",
        emailSendAccount: "Gửi tài khoản",
        emailErrorNotice: "Thông báo sai sót",
        emailPaymentReminder: "Nhắc nợ thanh toán",
        paymentProductType: "Loại sản phẩm",
        beneficiaryBank: "Ngân hàng thụ hưởng",
        accountNumber: "Số tài khoản",
        accountName: "Tên tài khoản",
        primaryBeneficiaryAccount: "Tài khoản thụ hưởng chính",
        saleDateTime: "Ngày giờ bán hàng",
        storeCode: "Mã cửa hàng",
        pumpCode: "Mã vòi bơm",
        pumpActionCode: "Mã lần bơm",
        pumpStartTime: "Giờ bắt đầu bơm",
        pumpedTotal: "Tổng khối lượng đã bơm",
        salesStaffCode: "Mã nhân viên bán hàng",
        previousPumpedTotal: "Tổng khối lượng đã bơm lần trước",
        petrolTransactionList: "Danh sách giao dịch xăng dầu",
        qrCodePaymentLabel: "Thanh toán QrCode",
        errorName: "Tên lỗi",
        integrationKey: "Key tích hợp",
        reportType: "Loại báo cáo",
        detailTransactionReport: "Báo cáo chi tiết giao dịch",
        summaryTransactionReport: "Báo cáo tổng hợp giao dịch",
        store: "Cửa hàng",
        pump: "Vòi bơm",
        staffCode: "Mã nhân viên",
        invoiceCreationStatus: "Trạng thái tạo hóa đơn",
        invoiceCreationStatusShort: "Trạng thái tạo HĐ",
        customerTaxCode: "MST Khách hàng",
        customerPhone: "SĐT khách hàng",
        notCreated: "Chưa tạo",
        created: "Đã tạo",
        createError: "Tạo lỗi",
        cancelled: "Bị hủy",
        unpaid: "Chưa thanh toán",
        paid: "Đã thanh toán",
      },
      system: {
        company: "Doanh nghiệp",
        companyName: "Tên doanh nghiệp",
        serial: "Serial",
        licenseQuantity: "Số lượng cấp",
        product: "Sản phẩm",
        issueDate: "Ngày cấp",
        startDate: "Ngày bắt đầu",
        expiryDate: "Ngày hết hạn",
        permissionGroupName: "Tên nhóm quyền",
        users: "Người sử dụng",
        permissionGroups: "Nhóm quyền",
        digitalCertificate: "Chứng thư số",
        systemParameters: "Tham số hệ thống",
        emailServer: "Cấu hình email server",
        formulaType: "Cách tính",
        formula: "Công thức",
        addFormula: "Thêm công thức",
        formulaConfig: "Cấu hình công thức",
        selectCalculation: "Chọn cách tính",
        dataArea: "Vùng lấy dữ liệu",
        numericValues: "Các giá trị số",
        operation: "Phép tính",
        value: "Giá trị",
        resetFormula: "Thiết lập lại",
        testFormula: "Kiểm tra công thức",
        calculate: "Tính",
        invalidFormula: "Công thức không hợp lệ",
        testFormulaHeader: "Kiểm tra công thức",
        permissionDialog: "Phân quyền",
        accessOtherUserDocuments: "Xem chứng từ của NSD khác",
        editOtherUserDocuments: "Sửa chứng từ của NSD khác",
        deleteOtherUserDocuments: "Xóa chứng từ của NSD khác",
        signingMethod: "Hình thức ký gửi",
        signSummary: "Ký gửi Bảng tổng hợp",
        signNowTaxAuthority: "Ký gửi ngay CQT",
        identityCode: "Mã cơ quan thuế cấp",
        province: "Tỉnh thành",
        bankAccount: "Tài khoản",
        bankName: "Tại ngân hàng",
        paymentIntegrationCode: "Mã tích hợp thanh toán",
        legalRepresentativeSection: "THÔNG TIN NGƯỜI ĐẠI DIỆN PHÁP LUẬT",
        legalRepresentative: "Người đại diện pháp luật",
        legalRepresentativePhone: "Điện thoại người đại diện pháp luật",
        useCitizenId: "Hộ kinh doanh sử dụng CCCD thay cho mã số thuế",
        contactSection: "THÔNG TIN NGƯỜI LIÊN HỆ",
        taxAuthoritySection: "THÔNG TIN CƠ QUAN THUẾ, TRA CỨU HÓA ĐƠN",
        provincialTaxAuthority: "CQ thuế cấp tỉnh",
        managingTaxAuthority: "CQ thuế quản lý",
        agentInfo: "Thông tin đại lý",
        changeHistory: "Lịch sử thay đổi",
        modifiedBy: "Người sửa",
        modifiedDate: "Ngày sửa",
        data: "Dữ liệu",
        viewChangeHistory: "Xem lịch sử thay đổi",
        changeHistoryInfo: "Lịch sử thay đổi thông tin",
        dataPermission: "Phân quyền theo dữ liệu",
        fullDataPermission: "Toàn quyền dữ liệu",
        resetDefaultPermission: "Reset quyền mặc định",
        permissions: "Quyền",
        helpUrl: "URL trợ giúp",
        default: "Mặc định",
        petrolSyncConfigTitle: "Cấu hình tạo hóa đơn xăng dầu từ bảng log",
        invoiceResyncTime: "Thời gian đồng bộ lại hóa đơn",
        condition: "Điều kiện",
        syncType: "Loại đồng bộ",
        startTime: "Giờ bắt đầu",
        endTime: "Giờ kết thúc",
        defaultEndTime: "23:59:59 (Mặc định)",
        fieldName: "Tên trường",
        creationTime: "Ngày tạo hóa đơn",
        autoSignConditionTitle: "Điều kiện",
        autoSignEndTimeBeforeStart: "Giờ kết thúc không được nhỏ hơn giờ bắt đầu.",
        autoSignConditionIncomplete: "Vui lòng nhập đầy đủ trường, điều kiện và giá trị cho các dòng đã sử dụng.",
        autoSignCreationTimeInvalid: "Thời gian tạo hóa đơn phải theo định dạng HH:mm:ss từ 00:00:00 đến 23:59:59.",
        autoSignInvoiceDateInvalid: "Ngày hóa đơn chỉ nhận Hôm nay hoặc Hôm qua.",
        autoSignTimeOverlap: "Khoảng thời gian bị trùng với job ký tự động khác cùng ký hiệu.",
        takeLogRecords: "Số bản ghi log được lấy để tạo hóa đơn mỗi lần quét",
        scanConditionRequired: "Bạn chưa nhập điều kiện quét dữ liệu",
        emailMttConfigTitle: "Cấu hình gửi email thông báo hóa đơn máy tính tiền cần ký",
        notificationEmail: "Email nhận thông báo",
        notificationResendTime: "Thời gian gửi lại thông báo/ký lại hóa đơn",
        feature: "Chức năng",
        autoSignInvoice: "Ký tự động hóa đơn",
        sendNotificationEmail: "Gửi email thông báo",
        signAgainTime: "Thời gian ký lại hóa đơn",
        resendNotificationTime: "Thời gian gửi lại thông báo",
        emailSeparatorHint: "Các email được ngăn cách bằng dấu phẩy (,) hoặc chấm phẩy (;)",
        conditionLabel: "Điều kiện:",
        certificateCondition: "Khách hàng đã đăng ký chứng thư số FILE hoặc Service trên phần mềm",
        invoiceStatusCondition: "Hóa đơn có trạng thái Chờ ký và đã có ngày hóa đơn",
        emailServerConfig: "Cấu hình email server",
        alias: "Bí danh",
        displayAddress: "Địa chỉ hiển thị",
        smtpHost: "Máy chủ SMTP",
        smtpPort: "Cổng SMTP",
        sslAuthentication: "Xác thực SSL",
        defaultLogin: "Đăng nhập mặc định",
        invoiceConfig: "Cấu hình hóa đơn",
        configCode: "Mã cấu hình",
        invoiceType: "Loại hóa đơn",
        configCodeRequired: "Mã cấu hình không được để trống",
        invoiceTypeRequired: "Loại hóa đơn không được để trống",
        exit: "Thoát",
      },
      report: {
        report: "Báo cáo",
        filters: "Điều kiện lọc",
        summary: "Bảng tổng hợp",
        day: "Ngày",
        month: "Tháng",
        quarter: "Quý",
        submissionCount: "Lần nộp",
        firstSubmission: "Lần đầu",
        supplementarySubmission: "Nộp bổ sung",
        dataPeriod: "Kỳ dữ liệu",
        monthOrQuarter: "Tháng/Quý",
        year: "Năm",
        summaryNumber: "Số bảng tổng hợp",
        supplementCount: "Số lần bổ sung",
        currencyUnit: "Đơn vị tiền tệ",
        createdBy: "Người lập",
        signDateTime: "Ngày giờ ký",
        summaryDetails: "Chi tiết bảng tổng hợp",
        summaryTransferHistory: "Lịch sử truyền nhận",
        summaryLookup: "Chọn hóa đơn vào bảng tổng hợp",
        summaryLimitNotice: "Để đảm bảo dung lượng khi truyền dữ liệu với CQT. Chỉ chọn tối đa 2000 hóa đơn trong một bảng tổng hợp",
        summaryCreateTitle: "Lập bảng tổng hợp dữ liệu hóa đơn",
        summaryFindInvoices: "Tìm hóa đơn lấy lên bảng tổng hợp",
        summaryInvoiceSelectionLegend: "{{action}} hóa đơn lấy lên bảng tổng hợp",
        summaryUpdateAction: "Cập nhật",
        summarySupplementAction: "Bổ sung",
        summaryInvoiceSerialPlaceholder: "Chọn ký hiệu hóa đơn",
        goodsType: "Loại hàng hóa",
        otherGoods: "Khác",
        flightGoods: "Vận tải hàng không",
        currencyCode: "Mã tiền tệ",
        multipleTax: "Sử dụng nhiều loại thuế trong một hóa đơn",
        invoiceNumberShort: "Số",
        summaryPeriodPlaceholder: "Tháng hoặc quý",
        accountingSoftware: "Phần mềm kế toán",
        productNameWithService: "Tên hàng hóa dịch vụ",
        amountBeforeTax: "Giá trị chưa có thuế",
        vatRateByRegulation: "Thuế suất GTGT theo quy định",
        vatRateAfterReduction: "Thuế suất GTGT sau khi giảm 20%",
        vatReductionAmount: "Thuế GTGT được giảm",
        petrolStoreCode: "Số CHXD",
        pumpColumnCount: "Số cột bơm",
        quantitySold: "Số lượng xuất bán",
        issuedInvoiceQuantity: "Số lượng hóa đơn phát hành",
        petrolRevenue: "Doanh thu bán hàng đối với mặt hàng xăng dầu",
        totalCount: "Tổng số",
        retailCustomerCount: "Trong đó: Bán lẻ cho khách hàng",
        successfulInvoiceStatus: "Trạng thái hóa đơn gửi thành công",
        successfulInvoiceCount: "Tổng số hóa đơn gửi thành công",
        failedInvoiceCount: "Tổng số hóa đơn gửi không thành công",
        usedInvoiceCount: "Tổng số hóa đơn sử dụng",
        totalAfterTax: "Thành tiền sau thuế",
        signDate: "Ngày ký",
        totalOtherDeductions: "Tổng giảm trừ khác",
        exchangeRate: "Tỷ giá",
        totalFee: "Tổng tiền phí",
        relatedInvoiceType: "Loại hóa đơn liên quan",
        relatedInvoiceTemplateNumber: "Mẫu số hóa đơn liên quan",
        relatedInvoiceSymbol: "Ký hiệu hóa đơn liên quan",
        relatedInvoiceNumber: "Số hóa đơn liên quan",
        adjustmentPeriodType: "Loại kỳ dữ liệu điều chỉnh",
        adjustmentPeriod: "Kỳ dữ liệu điều chỉnh",
        summaryStatusOrigin: "Gốc",
        summaryStatusRefused: "Hủy",
        summaryStatusAdjusting: "Điều chỉnh",
        summaryStatusReplacing: "Thay thế",
        summaryStatusExplaining: "Giải trình",
        summaryStatusAdjusted: "Bị điều chỉnh",
        summaryStatusReplaced: "Bị thay thế",
        summaryStatusError: "Sai sót do tổng hợp",
        summaryStatusNotifying: "Thông báo",
        summaryCreated: "Tạo bảng tổng hợp thành công",
        summaryUpdated: "Cập nhật bảng tổng hợp thành công",
        summarySupplemented: "Bổ sung bảng tổng hợp thành công",
        summaryExcelUploaded: "Tải file Excel thành công",
        summarySigned: "Ký bảng tổng hợp thành công",
        summaryNotSelected: "Chưa lựa chọn bảng tổng hợp",
        summaryXmlUnavailable: "Bảng tổng hợp chưa ký không tồn tại XML",
        summaryDuplicateInvoice: "Đã tồn tại hóa đơn số {{serial}} - {{number}}",
        summaryDeleteBlocked: "Bảng tổng hợp đã ký hoặc trước bảng tổng hợp lớn nhất không thể xóa",
        summaryInvoiceTypeNd123: "Hóa đơn điện tử NĐ123,NĐ70,NĐ254",
        summaryInvoiceTypeQd1209: "Hóa đơn Xác thực QĐ1209",
        summaryInvoiceTypeNd51: "Hóa đơn Nghị định 51",
        summaryPaperInvoiceNd51: "Hóa đơn giấy Nghị định 51",
        summary01Placeholder: "Chức năng đang được tạm thời ẩn",
        periodToday: "Hôm nay",
        periodThisWeek: "Tuần này",
        periodThisMonth: "Tháng này",
        periodThisFiscalQuarter: "Quý này",
        periodThisFiscalYear: "Năm nay",
        periodFirstSixMonths: "6 tháng đầu năm",
        periodLastSixMonths: "6 tháng cuối năm",
        month1: "Tháng 1",
        month2: "Tháng 2",
        month3: "Tháng 3",
        month4: "Tháng 4",
        month5: "Tháng 5",
        month6: "Tháng 6",
        month7: "Tháng 7",
        month8: "Tháng 8",
        month9: "Tháng 9",
        month10: "Tháng 10",
        month11: "Tháng 11",
        month12: "Tháng 12",
        fiscalQuarter1: "Quý I",
        fiscalQuarter2: "Quý II",
        fiscalQuarter3: "Quý III",
        fiscalQuarter4: "Quý IV",
        periodLastWeek: "Tuần trước",
        periodLastMonth: "Tháng trước",
        periodLastFiscalQuarter: "Quý trước",
        periodLastFiscalYear: "Năm trước",
        vatInvoiceForm: "Hóa đơn giá trị gia tăng",
        salesInvoiceForm: "Hóa đơn bán hàng",
        electronicTicketForm: "Tem, vé thẻ điện tử",
        choosePeriod: "Chọn kỳ",
        exportExcel: "Kết xuất Excel",
        invoiceProcessingTitle: "Thống kê hóa đơn cần xử lý",
        invoiceProcessingDescription: "Hóa đơn ĐANG GỬI, CHỜ KÝ, ĐÃ KÝ (Trong 1 tháng gần nhất)",
        sending: "ĐANG GỬI",
        waitingSignature: "CHỜ KÝ",
        signed: "ĐÃ KÝ",
        updatedAt: "Cập nhật lúc {{date}}",
        invoiceListTitle: "Danh sách hóa đơn",
        invoiceListDescription: "Quản lý lập, phát hành và xử lý hóa đơn",
        errorNoticeTitle: "Thông báo HĐ sai sót",
        errorNoticeDescription: "Thông báo hóa đơn điện tử có sai sót đến cơ quan thuế theo mẫu 04/SS-HĐĐT",
        quickCreateTitle: "Lập hóa đơn nhanh",
        creationDate: "Ngày khởi tạo",
        sendingCount: "Số lượng ĐANG GỬI",
        waitingSignatureCount: "Số lượng CHỜ KÝ",
        signedCount: "Số lượng ĐÃ KÝ",
        quickAccess: "Truy cập nhanh",
        createInvoice: "Lập hóa đơn",
        certificatesTitle: "Chứng thư số đăng ký",
        changeCertificate: "Thay đổi chứng thư số trên tờ khai",
        certificateIssuer: "Tổ chức cấp chứng thư",
        certificateSerial: "Serial chứng thư",
        validFrom: "Ngày có hiệu lực",
        expirationDate: "Ngày hết hạn",
        certificateStatus: "Trạng thái",
        valid: "Còn hạn",
        expiringSoon: "Sắp hết hạn",
        expired: "Hết hạn",
        used: "Dùng",
        remaining: "còn lại",
        pluginSignFailed: "Ký điện tử không thành công",
        pluginCheckSteps: "Hãy kiểm tra các trường hợp dưới đây để khắc phục vấn đề của bạn",
        pluginNotInstalled: "Bạn chưa cài đặt công cụ M-INVOICE Plugin",
        pluginInstallToContinue: "Hãy cài đặt M-INVOICE Plugin để tiếp tục.",
        downloadInstaller: "Tải bộ cài",
        installGuide: "Xem hướng dẫn cài đặt",
        pluginInstalled: "Bạn đã cài đặt công cụ M-INVOICE Plugin",
        openPluginBeforeSigning: "Hãy mở công cụ M-INVOICE Plugin trước khi ký điện tử",
        openPlugin: "Mở M-INVOICE Plugin",
      },
      error: {
        generic: "Có lỗi xảy ra. Vui lòng kiểm tra lại nghiệp vụ",
        network: "Không thể kết nối đến hệ thống. Vui lòng thử lại sau.",
      },
      templatePreview: {
        electronicInvoiceTemplate: "Mẫu hóa đơn điện tử",
        convertedInvoiceTemplate: "Mẫu hóa đơn chuyển đổi",
        preview: "Xem trước",
        template: "Mẫu hóa đơn",
        zoomIn: "Phóng to",
        zoomOut: "Thu nhỏ",
        fitToScreen: "Vừa màn hình",
        alignByTitle: "Căn theo tiêu đề",
        alignByLongestTitle: "Căn theo tiêu đề dài nhất",
        alignByLongestTitleColon: "Căn theo tiêu đề dài nhất bao gồm dấu :",
        alignBuyerSeller: "Người mua người bán căn theo tiêu đề dài nhất bao gồm dấu :",
        width: "Độ rộng",
        addField: "Thêm trường",
        removeField: "Xóa trường",
        bold: "In đậm",
        italic: "In nghiêng",
        underline: "Gạch chân",
        letterSpacing: "Khoảng cách chữ",
        chooseField: "Chọn trường hiển thị",
        editContentHint: "Chọn một trong các nhóm thông tin trên hóa đơn để chỉnh sửa nội dung",
        noGeneralConfig: "Bạn chưa chọn cấu hình ở tab Thông tin chung!",
      },
    },
  },
  en: {
    translation: {
      common: {
        appName: "M-Invoice",
        language: "Language",
        vietnamese: "Vietnamese",
        english: "English",
        chinese: "Chinese",
        japanese: "Japanese",
        korean: "Korean",
        tokenUsb: "USB token",
        tokenFileCa: "FILE CA",
        tokenServiceEasyCa: "EASYCA service",
        tokenServiceNcca: "NCCA service",
        tokenServiceIca: "I-CA service",
        tokenServiceIntrustCa: "Intrust-CA service",
        close: "Close",
        cancel: "Cancel",
        save: "Save",
        update: "Update",
        updateInvoiceNumber: "Update invoice number",
        qrPaymentNotRegistered: "mQR payment is not registered",
        startRow: "Start from row",
        enterTaxCode: "Enter tax code to search",
        searchMultipleTaxCodes: "Search multiple tax codes",
        exportSearchResults: "Export search results to Excel",
        transaction: "transaction",
        compensateTransaction: "Compensate transaction",
        qrCodePayment: "QR Code payment",
        groupTransactions: "Group transactions",
        cancelReason: "Cancellation reason",
        missing: "missing",
        create: "Create",
        edit: "Edit",
        detail: "Details",
        delete: "Delete",
        confirm: "Confirm",
        restoreTemplate: "Restore initial template",
        restoreTemplateQuestion: "Are you sure you want to restore this invoice template?",
        consentConfirmTitle: "Confirm terms consent",
        consentRequiredQuestion: "The beneficiary bank account must consent to sharing balance changes before it can be saved. Do you want to continue?",
        consentCheckFailed: "Consent check failed",
        consentLinkMissing: "No consent link is available",
        equals: "Equals",
        notEquals: "Not equal",
        contains: "Contains",
        startsWith: "Starts with",
        endsWith: "Ends with",
        containsList: "Contains list",
        notContains: "Does not contain",
        emptyValue: "Empty",
        nonEmptyValue: "Not empty",
        greaterThan: "Greater than",
        greaterThanOrEqual: "Greater than or equal",
        lessThan: "Less than",
        lessThanOrEqual: "Less than or equal",
        reject: "No",
        yes: "Yes",
        no: "No",
        back: "Back",
        search: "Search",
        filter: "Filter",
        clear: "Clear filters",
        reset: "Reset",
        refresh: "Refresh",
        export: "Export",
        import: "Import",
        download: "Download",
        upload: "Upload",
        copy: "Copy",
        importExcel: "Import from Excel",
        exportExcel: "Export to Excel",
        fileRequired: "Please select a file.",
        chooseFile: "Choose a file",
        downloadTemplate: "Download template",
        receiveFile: "Receive file",
        more: "More",
        actions: "Actions",
        functions: "Functions",
        statement: "Statement",
        symbol: "Symbol",
        invoiceNo: "Invoice number",
        invoiceDate: "Invoice date",
        today: "Today",
        yesterday: "Yesterday",
        status: "Status",
        receive: "Apply",
        all: "- All -",
        currentPageReport: "{first} - {last} of {totalRecords} records",
        templatePrintRows: "Template print rows",
        viewInvoiceTemplate: "View invoice template",
        printConvertedInvoice: "Print converted invoice",
        configuration: "Configuration",
        languageCustomization: "Language customization",
        bilingualVietnameseEnglish: "Bilingual (Vietnamese - English)",
        signCustomization: "Signing customization",
        signImmediately: "Sign invoice and send immediately to the tax authority",
        signSummaryAtPeriodEnd: "Sign invoice and send the period-end summary",
        colorCustomization: "Color customization",
        fontCustomization: "Font customization",
        buyerCustomization: "Buyer customization",
        underlineBuyerValue: "Underline buyer value",
        tableCustomization: "Table customization",
        tableRowBorders: "Table has row borders",
        columnSymbolRows: "Set column symbol row count",
        blankRows: "Blank rows",
        multiPageInvoiceRows: "Rows for multi-page invoices",
        signatureLabelCustomization: "Signature label customization",
        headSignature: "Head signature",
        emailInvoice: "Email invoice",
        htmlFormat: "HTML format",
        logoFileSizeExceeded: "The logo file must not exceed 100KB",
        imageFileRequired: "The file must be an image",
        logoDimensionExceeded: "The logo dimensions exceed the limit. Maximum: {{width}}x{{height}}px",
        imageReadFailed: "The image file could not be read",
        borderFileSizeExceeded: "The uploaded file must not exceed 300KB",
        borderDimensionExceeded: "The border dimensions exceed the recommended limit: {{pageSize}}: {{width}} x {{height}}",
        backgroundFileSizeExceeded: "The background file must not exceed 200KB",
        backgroundDimensionExceeded: "The background dimensions exceed the limit. Maximum: {{width}}x{{height}}px",
        useQrCode: "Use QR code",
        sizeCustomization: "Size customization",
        useLogo: "Use logo",
        chooseLogoFromComputer: "Choose from computer; maximum 100KB",
        maxDimension: "Maximum size: ({{dimension}})",
        useBackground: "Use background",
        chooseImageFromComputer: "Choose image from computer",
        chooseBackgroundFromLibrary: "Choose background image from library",
        chooseBackgroundFromComputer: "Choose from computer; maximum 200KB",
        opacity: "Opacity",
        useBorder: "Use border",
        chooseBorderFromComputer: "Choose from computer; maximum 300KB",
        maxPageDimension: "Maximum {{pageSize}} size: ({{width}}x{{height}})",
        pendingApproval: "Pending approval",
        waitingSignature: "Waiting for signature",
        signed: "Signed",
        sending: "Sending",
        signing: "Signing",
        invoiceListType: "Invoice list type",
        taxAuthoritySendStatus: "Tax authority send status",
        invoiceListTemplateSymbol: "Invoice list template symbol",
        adjustmentReplacementDate: "Adjustment/replacement invoice date",
        buyerLegalName: "Buyer legal name",
        linkedInvoiceListEditBlocked: "An invoice list linked to an invoice cannot be edited.",
        linkedInvoiceListDeleteBlocked: "An invoice list linked to an invoice cannot be deleted.",
        invoiceListPrintSelectionRequired: "Select an invoice list before viewing/printing",
        invoiceListPrintPreview: "View/print invoice list",
        invoiceList: "Invoice list",
        createInvoice: "Create invoice",
        createdBy: "Created by",
        discountInvoiceList: "Adjustment invoice",
        understood: "Understood",
        businessLocationDeclarationGuide: "Business location declaration guide",
        step: "Step {{number}}:",
        declareBusinessLocations: "Declare the business location list →",
        assignBusinessLocationToSymbol: "Assign a business location to the invoice symbol →",
        invoiceSymbolManagement: "Invoice symbol management",
        dateRangeSameMonthRequired: "Select From date and To date within the same month.",
        toDateBeforeFromDate: "The To date cannot be earlier than the From date.",
        selectAtLeastOneInvoice: "Select at least one invoice.",
        selectedInvoicesSameMonthRequired: "Selected invoices must be in the same month.",
        selectedInvoicesSameBuyerRequired: "Selected invoices must have the same buyer legal name/buyer name.",
        selectInvoiceForList: "Select invoices for the invoice list",
        statementList: "Statement list",
        month: "Month",
        year: "Year",
        createInvoiceList: "Create invoice list",
        // Bổ sung bản dịch cho lựa chọn trong/ngoài khu phi thuế quan.
        inside: "Inside",
        outside: "Outside",
        // Bổ sung bản dịch cho tiêu đề xử lý nhiều hóa đơn trong namespace common.
        multipleInvoiceReplacement: "Replace multiple invoices",
        multipleInvoiceAdjustment: "Adjust multiple invoices",
        createMultipleReplacementInvoice: "Create multiple replacement invoice",
        createMultipleAdjustmentInvoice: "Create multiple adjustment invoice",
        printStatement: "Print statement",
        logoBackground: "Logo - Background",
        detailCustomization: "Detail customization",
        saveInfo: "Save information",
        noData: "No data",
        productServiceName: "Goods and services name",
        vatRate: "VAT rate",
        taxAmount: "VAT amount",
        otherAmount: "Other amount",
        totalAfterTax: "Total after tax",
        serialNumberShort: "No.",
        invoiceNumber: "Invoice number",
        invoiceSymbol: "Symbol",
        invoiceNature: "Invoice nature",
        beforeReplacementInfo: "Information before replacement",
        beforeAdjustmentInfo: "Information before adjustment",
        afterReplacementInfo: "Information after replacement",
        afterAdjustmentInfo: "Information after adjustment (Enter the correct invoice information used to calculate the difference)",
        difference: "Difference",
        invoiceListSelectionLimit: "Each invoice list can contain at most {{count}} invoices.",
        invoiceListItemsLoadFailed: "Failed to load invoices in the invoice list!",
        invoiceListLoadFailed: "Failed to load invoice list information!",
        invoiceInfoLoadFailed: "Failed to load invoice information!",
        invoiceListCreated: "Invoice list created successfully!",
        invoiceListUpdated: "Invoice list updated successfully!",
        invoiceListTitle: "Invoice list",
        invoiceListViewTitle: "View invoice list",
        invoiceListSymbol: "Invoice list symbol",
        buyerNameRequired: "Enter either the buyer legal name or buyer name",
        invoiceListItemsRequired: "The invoice list cannot be empty",
        saveAndCreateInvoice: "Save and create invoice",
        deleteInvoiceRowWithShortcut: "Delete row (F8)",
        deleteNoDifferenceRows: "Delete all rows without differences",
        consumerBuyer: "Sold to consumer",
        cityPrefix: "City",
        provincePrefix: "Province",
        taxCodeSearchV2Failed: "Failed to search the tax code (V2).",
        taxCodeSearchFailed: "Failed to search the tax code.",
        paymentTotalMismatch: "Payment total does not match pre-tax amount plus tax.",
        paymentUnitPriceMismatch: "Payment total does not match quantity multiplied by VAT-inclusive unit price.",
        saveAndPrint: "Save and view/print",
        saveAndContinue: "Save and create another",
        exportForBusiness: "Issue to a business",
        signTimeWarningNonCompliant: "The following invoices do not comply with the above rule.",
        continueSignQuestion: "Do you want to continue signing and sending?",
        signTimeWarningLegalRule: "Under Clause 7 of the \"Invoice content\" Appendix to Decree 254/2026/ND-CP, invoice data must be signed and sent to the tax authority no later than the next working day after the invoice date.",
        signTimeWarningInvoiceDetails: "The invoice being signed has date {{date}}, symbol {{symbol}}, and number {{number}} and does not comply with this rule. Do you want to continue signing and sending it?",
        discountSignTimeWarningLegalRule: "Under Point c, Clause 7 and Point b, Clause 14, Article 1 of Decree 254/2026/ND-CP, invoice data must be signed and sent to the tax authority no later than the next working day after the invoice date.",
        itemListFieldRequired: "Item list: {{field}} is required",
        itemListEmpty: "The item list is empty",
        invoiceAmountMismatch: "Item {{product}} on line {{line}} has a quantity × unit price different from the amount; difference: {{difference}}",
        invoicePreTaxMismatch: "Detail pre-tax total {{detail}} differs from the header pre-tax total {{header}}; difference: {{difference}}",
        invoiceTotalMismatch: "Pre-tax total {{beforeTax}} + tax total {{tax}} differs from payment total {{total}}; difference: {{difference}}",
        commercialDiscountLegalNotice: "Under Point b, Clause 5, Article 10 of Circular 91/2026/TT-BTC: when a commercial discount is based on quantity or revenue, an adjustment invoice must be issued with an invoice list containing the invoices, amounts, and adjusted tax. The list must be retained by the organization and presented when requested by the tax authority or another competent state agency.",
        commercialDiscountStepsTitle: "Creating a commercial discount invoice has two steps:",
        commercialDiscountStepOne: "Step 1: Create an invoice list containing invoices that meet the discount program conditions.",
        commercialDiscountStepTwo: "Step 2: Create an adjustment invoice linked to the invoice list number and date.",
        commercialDiscountLineNote: "(The line item is goods/services and the total amount is positive.)",
        invoiceSaveBlockedSummary: "Unable to save",
        saveFailed: "Could not save the information. Please try again.",
        businessLocationRequiredBeforeSave: "Declare and assign a business location to the invoice symbol (Categories → Business locations) before saving.",
        frameEngineRequiredForVehicle: "Frame number and engine number are required for special goods in the car or motorcycle vehicle category.",
        vehiclePlateRequiredForTransport: "Vehicle plate number is required for special goods in the transportation service category.",
        senderInfoRequiredForDigitalTransport: "Sender name, sender address, sender tax code, and sender citizen ID are required for special goods in the digital platform transportation service category.",
        invalidInvoiceIdForSigning: "No valid invoice ID was found for signing.",
        invoiceListAlreadyCreated: "You cannot create the invoice because the invoice list has already been created.",
        cancelInvoiceSelectionRestriction: "You can only cancel successfully submitted invoices in Original or Explanation status.",
        afterConfirmation: "After confirmation, the system will:",
        updateInvoiceListStatus: "Update the status of invoices in the invoice list.",
        invoiceListLockedAfterConfirm: "The invoice list cannot be edited or deleted.",
        deleteMultipleInvoiceToEditList: "To edit or delete the invoice list later, delete the multiple adjustment/replacement invoice to restore the status of invoices in the list.",
        saveInvoiceQuestion: "Are you sure you want to save this invoice?",
        citizenDataNotFound: "Citizen ID data was not found.",
        citizenSearchFailed: "Failed to search the citizen ID.",
        taxCodeNotFound: "Tax code data was not found.",
        taxCodeV2NotFound: "Tax code data (V2) was not found.",
        taxCodeFormatInvalid: "Invalid code. Please check again.",
        supportChatCaption: "M-invoice Support",
        supportChatTagline: "We are always ready to help. We usually respond within 5 minutes",
        supportChatGreeting: "Please provide complete information so M-invoice can support you better :wave:",
        statementNumber: "Statement number",
        todayDate: "Today, date",
        seller: "Party A (Seller)",
        buyer: "Party B (Buyer)",
        address: "Address",
        phone: "Phone number",
        representative: "Representative",
        position: "Position",
        parties: "The parties include:",
        cancelled: "cancellation",
        replacement: "replacement",
        adjustment: "adjustment",
        reason: "Reason",
        statementCreate: "Create statement",
        statementCreated: "Statement created",
        statementTitle: "{{action}} invoice statement",
        statementToday: "Today, on {{day}}/{{month}}/{{year}}, the parties include:",
        statementCancelSentence: "The parties agree to make this statement to revoke and cancel the invoice with form number {{form}}, symbol {{serial}}, number {{number}}, dated {{date}}, in accordance with regulations.",
        statementMultipleSentence: "The parties agree to make this statement to confirm the error and issue an {{action}} invoice for multiple incorrect invoices, accompanied by a list with number {{listNumber}} and date {{listDate}}, in accordance with regulations.",
        statementSingleSentence: "The parties agree to make this statement to confirm the error and issue an {{action}} invoice for the invoice with form number {{form}}, symbol {{serial}}, number {{number}}, dated {{date}}, in accordance with regulations.",
        statementCommitment: "We certify that all information declared above is accurate. If there is any error, we accept responsibility before the law.",
        statementActionCommitment: "We undertake full responsibility for the {{action}} of this invoice.",
        republicTitle: "SOCIALIST REPUBLIC OF VIETNAM",
        nationalMotto: "Independence - Freedom - Happiness",
        householdTaxOrCitizenId: "Household owner tax ID/Citizen ID",
        lawBasisDecree123: "Pursuant to Decree 123/2020/ND-CP dated October 19, 2020 of the Government on invoices and documents.",
        lawBasisDecree70: "Pursuant to Decree 70/2025/ND-CP dated March 20, 2025 of the Government amending and supplementing a number of provisions of Decree 123/2020/ND-CP dated October 19, 2020 of the Government on invoices and documents.",
        lawBasisCircular32: "Pursuant to Circular 32/2025/TT-BTC dated May 31, 2025 of the Ministry of Finance guiding the implementation of Decree 123/2020/ND-CP dated October 19, 2020 of the Government on invoices and documents, and Decree 70/2025/ND-CP dated March 20, 2025 amending and supplementing a number of provisions of Decree 123/2020/ND-CP.",
        lawBasisDecree254: "Pursuant to Decree 254/2026/ND-CP dated June 30, 2026 of the Government detailing a number of articles and measures for organizing and guiding the implementation of the Law on Tax Administration No. 108/2025/QH15 on electronic invoices and electronic documents.",
        lawBasisCircular91: "Pursuant to Circular 91/2026/TT-BTC dated June 30, 2026 of the Ministry of Finance providing for a number of articles of the Law on Tax Administration No. 108/2025/QH15 and Decree 254/2026/ND-CP of the Government detailing a number of articles and measures for organizing and guiding the implementation of the Law on Tax Administration on electronic invoices and electronic documents.",
        lawBasisAgreement: "Pursuant to the agreement between the parties.",
        logo: "Logo",
        businessRegistrationInfo: "Business registration no. {{number}}, issued by {{authority}} on {{date}}",
        branch: "BRANCH",
        copyright: "Copyright © 2025 {{company}}. All rights reserved.",
        attachment: "Attachment",
        printInvoice: "Print invoice",
        emailStatementForSignature: "Email the statement to the buyer for signature",
        registerAdjustmentInvoice: "Create adjustment invoice",
        registerReplacementInvoice: "Create replacement invoice",
        selectSymbol: "Select symbol",
        saveAndSign: "Save & sign",
        sendForSignature: "Send invoice to buyer for signature",
        representativeSeller: "Party A representative",
        representativeBuyer: "Party B representative",
        digitalSignature: "(Digital signature, electronic signature)",
        signatureValid: "Signature valid",
        signedBy: "Signed by:",
        signedDate: "Signed date:",
        addLine: "Add row",
        deleteLine: "Delete row",
        copyLine: "Copy row",
        insertLine: "Insert row",
        chooseProduct: "Select goods",
        receiveExcelDetail: "Import detail from Excel",
        selectReplacementProduct: "Select replacement goods",
        itemCode: "Item code",
        code: "Code",
        itemName: "Item name",
        quantity: "Quantity",
        unitPrice: "Unit price",
        amount: "Amount",
        totalRecords: "Total {{count}} records",
        printView: "View/print",
        sendEmail: "Send email",
        downloadInvoicePdf: "Download invoice PDF",
        bulkSign: "Sign invoices in bulk",
        relatedStatement: "Related statement",
        invoiceHistory: "Invoice history",
        senderEmail: "Sender email",
        alias: "Alias",
        customerEmail: "Customer email",
        subject: "Subject",
        enterCustomerEmail: "Enter customer email",
        emailFallback: "If left empty, the system will use the email already entered on the invoice",
        emailSeparator: "Separate email addresses with commas (,)",
        reviewEmail: "Review the full email content",
        paymentNotification: "Payment notification",
        paymentHistory: "Payment history",
        transactionId: "Transaction ID",
        paidAmount: "Paid amount",
        paymentTime: "Payment time",
        paymentStatus: "Payment status",
        content: "Content",
        field: "Field",
        uploadPdf: "Upload PDF file",
        attachStatement: "Attach statement",
        fromDate: "From date",
        toDate: "To date",
        buyerName: "Seller/buyer name",
        taxAuthorityCode: "Tax authority code",
        selectInvoice: "Select invoice",
        invoicePaymentHistory: "Invoice payment history",
        qrPaymentHistory: "QR Code payment history",
        invoiceNoPayment: "No QR payment transaction has been recorded for this invoice",
        qrNoPayment: "No QR payment transaction has been recorded",
        pump: "Pump",
        store: "store",
        time: "time",
        notificationType: "Notification type",
        notificationNo: "Notification number",
        taxAuthorityNotificationNo: "Tax authority notification number",
        taxAuthorityNotificationDate: "Tax authority notification date",
        taxAuthorityReceiving: "Receiving tax authority",
        taxpayerName: "Taxpayer name",
        placeOfCreation: "Place of creation",
        appliedInvoiceType: "Applicable invoice type",
        noticeProperty: "Notice property",
        taxAuthorityIssuedCode: "Tax authority code",
        wrongInvoiceDeclaration: "Declare incorrect invoice information",
        oldSymbol: "Previous symbol",
        newSymbol: "New symbol",
        changeInvoiceSerial: "Change invoice symbol",
        receiveExcel: "Import Excel",
        downloadXml: "Download XML",
        declarationType: "Declaration type",
        contactEmail: "Contact email",
        contactPerson: "Contact person",
        contactAddress: "Contact address",
        contactPhone: "Contact phone",
        lookupCode: "Lookup code",
        sourceData: "Data source",
        qrCreatedAmount: "QR creation amount",
        paidTotal: "Total paid amount",
        qrCreationTime: "QR creation time",
        qrPaymentTime: "QR payment time",
        lastModificationTime: "Last update time",
        selectDataSource: "Please select at least one data source",
        selectQrCreationPeriod: "Please select the QR creation period",
        noticeFromTaxpayer: "Notice from taxpayer",
        noticeFromTaxAuthority: "Notice from taxpayer based on a tax authority notice",
        invoiceTypeN123: "Electronic invoice under Decrees 123, 70 and 254",
        verifiedInvoiceQd1209: "Authenticated invoice under Decision 1209",
        invoiceN51: "Invoice under Decree 51",
        preprintedInvoiceN123: "Preprinted invoice under Decree 123",
        manualInvoiceHint: "Select an existing invoice or add a row to manually enter an invoice from another provider or under Circular 32",
        invoicesForErrorNotice: "Invoices to be reported to the tax authority:",
        signErrorNotice: "Sign and send 04/SS-HĐĐT",
        restoreErrorNoticeStatusQuestion: "Do you really want to restore the notice to Waiting for signature and resend it to the tax authority?",
        requestCode: "Invoice/pump log code",
        bankTransactionCode: "Bank transaction code",
        invoiceInfoNotFound: "Invoice information was not found",
        pumpLogInfoNotFound: "Pump log information was not found",
        paymentFull: "Fully paid",
        paymentShort: "Underpaid",
        paymentExcess: "Overpaid",
        todayShort: "Today",
        daysUnit: "days",
        yearUnit: "year",
        days7: "7 days",
        days30: "30 days",
        days90: "90 days",
        year1: "1 year",
        customOption: "Custom",
        paymentPendingStatus: "Payment in progress",
        paymentErrorStatus: "Payment failed",
        paymentSuccessStatus: "Payment successful",
        errorDescription: "Error description",
        declarationDate: "Declaration date",
        submissionStatus: "Tax authority submission status",
        taxAuthorityFeedback: "Tax authority feedback",
        sender: "Sender",
        declarationRegister: "Register",
        declarationChange: "Change",
        notSubmitted: "Not submitted",
        submitted: "Submitted",
        declarationSigned: "Signed",
        received: "Received",
        notReceived: "Not received",
        accepted: "Accepted",
        notAccepted: "Not accepted",
        explanation: "Explanation",
        discontinued: "Discontinued",
        nextStep: "Next step",
        nextStepVerifyAtTaxAuthority: "Verify information directly at the tax authority",
        nextStepVerifyBiometric: "Verify biometric information",
        nextStepVerifyOtp: "Verify information by OTP",
        nextStepCreateNewDeclaration: "Create a new declaration",
        nextStepExplainRisk: "Risk explanation guide",
        nextStepCompleted: "Completed",
        nextStepSignAndSend: "Please sign and send to the tax authority",
        nextStepWaitForResponse: "Waiting for a response from the tax authority",
        nextStepPreliminaryChecking: "The tax authority is conducting a preliminary review of the declaration",
        taxAuthorityFeedbackPending: "No response yet",
        viewNextStepGuidance: "View the information verification guide",
        cloneRejectedDeclaration: "Create a new declaration from the rejected declaration",
        declarationGuidanceLoadFailed: "Unable to load the guide. Please try again later.",
        declarationCloneLoadFailed: "Unable to load the rejected declaration. Please try again later.",
        invoiceForm: "Invoice form",
        requiredFieldsMessage: "Please complete all required fields",
        taxAuthorityConnectionFailed: "Unable to connect to the tax authority. Please save a draft or try again later.",
        decree123Text: "Under Decree No. 123/2020/ND-CP dated October 19, 2020 of the Government, we/I are/am eligible to use electronic invoices. We/I register/change the information registered with the tax authority regarding the use of electronic invoices as follows:",
        decree254Text: "Under Decree No. 254/2026/ND-CP dated June 30, 2026 of the Government, we/I are/am eligible to use electronic invoices. We/I register/change the information registered with the tax authority regarding the use of electronic invoices as follows:",
        acceptanceTime: "Acceptance time",
        acceptanceFile: "Tax authority PDF or XML file",
        uploadAcceptanceFile: "Upload acceptance file",
        declarationTransferHistory: "Declaration transfer history",
        declarationFormTitle: "Declaration",
        declarationFormSubtitle: "Register/Change information for electronic invoice use",
        declarationRegisterNew: "New registration",
        declarationChangeInfo: "Change information",
        managedTaxAuthority: "Managing tax authority",
        legalRepresentativeName: "Legal representative name",
        passportLabel: "Passport",
        dateOfBirth: "Date of birth",
        gender: "Gender",
        female: "Female",
        male: "Male",
        legalRepresentativeNotice: "Legal representative information used for biometric authentication in the tax authority software system",
        acceptedDeclarationNotice: "After the declaration is accepted, the tax authority will send important electronic invoice notifications to this email/phone number/address.",
        invoiceFormSection: "1. Invoice form:",
        invoiceDataSendingSection: "2. Electronic invoice data submission method:",
        skipIfNotApplicable: "Skip this section if none of the following cases applies to you.",
        codedInvoiceWithoutServiceFeeCase: "a. Using coded electronic invoices without a service fee under Clause 1, Article 14 of the Decree:",
        noCodeInvoiceCase: "b. Using electronic invoices without a tax authority code:",
        dataTransferMethodSection: "3. Electronic invoice data transfer method:",
        invoiceTypeUseSection: "4. Invoice types used",
        certificateUseSection: "5. Digital certificates used",
        serviceProviderSection: "6. Service provider organization",
        receivingUnitSection: "7. Receiving unit information",
        dependentUnitSection: "8. Dependent accounting unit information requiring lookup access",
        suspensionRequestSection: "9. Request to suspend the use of electronic invoices",
        invoiceWithTaxCode: "Coded by the tax authority",
        invoiceWithCashRegister: "Coded by the tax authority (created from a cash register)",
        invoiceWithoutTaxCode: "Not coded by the tax authority",
        difficultAreaBusiness: "Small and medium enterprises, cooperatives, households, and individual businesses in areas with difficult or especially difficult socio-economic conditions.",
        otherSmallBusiness: "Other small and medium enterprises proposed by the provincial People's Committee to the Ministry of Finance, excluding businesses operating in economic zones, industrial parks, and high-tech parks.",
        publicAssetAuthority: "The tax authority or agency assigned to organize and process public assets under public asset management and use regulations",
        viaInvoiceProvider: "Through an electronic invoice service provider (Point b2, Clause 3, Article 22 of the Decree).",
        directToTaxAuthority: "Transfer electronic invoice data directly to the tax authority (Point b1, Clause 3, Article 22 of the Decree).",
        fullInvoiceContent: "Transfer the complete content of each invoice.",
        summaryInvoiceData: "Transfer according to the electronic invoice data summary (Point a1, Clause 3, Article 22 of the Decree).",
        vatInvoice: "VAT invoice",
        salesInvoice: "Sales invoice",
        publicAssetInvoice: "Public asset sales invoice",
        nationalReserveInvoice: "National reserve goods sales invoice",
        otherInvoiceTypes: "Other invoice types",
        managedDocumentsAsInvoice: "Documents printed, issued, used, and managed as invoices",
        integratedVatReceipt: "VAT invoice integrated with tax, fee, and charge collection receipt",
        integratedSalesReceipt: "Sales invoice integrated with tax, fee, and charge collection receipt",
        commercialInvoice: "Commercial invoice",
        legacyOtherInvoiceTypes: "Other invoice types: stamps, tickets, and electronic cards",
        legacyManagedDocumentsAsInvoice: "Documents printed, issued, used, and managed as invoices: internal warehouse dispatch and transport notes, and consignment warehouse dispatch notes",
        tableIndex: "No.",
        effectiveDate: "Effective date",
        unitNameLabel: "Unit name",
        dependentUnitName: "Dependent accounting unit name",
        permissionStartDate: "Lookup access start date",
        permissionEndDate: "Lookup access end date",
        receivingUnitName: "Receiving unit name",
        serviceStartDate: "Service start date",
        serviceEndDate: "Service end date",
        serviceProviderName: "Service provider name",
        invoiceTypeName: "Invoice type name",
        integratedTemplateSymbol: "Integrated invoice template symbol",
        integratedInvoiceSymbol: "Integrated invoice symbol",
        integratedOrganization: "Organization receiving or providing invoice integration",
        integratedOrganizationTaxCode: "Tax code of organization receiving or providing invoice integration",
        integrationPurpose: "Integration purpose",
        providerSolutionTaxCode: "Tax code of electronic invoice solution provider",
        certificateSerialShort: "Certificate serial number",
        invoiceServiceProvider: "Invoice service provider name",
        suspensionStartDate: "Suspension start date",
        suspensionEndDate: "Suspension end date",
        deleteLabel: "Delete",
        restoreDeclarationStatusQuestion: "Do you really want to restore the registration declaration to Waiting for signature and resend it to the tax authority?",
        receivedTime: "Received time",
        taxAuthorityReceivedAndCheckingMessage: "The tax authority received the message and is checking the data",
        statusError: "Error",
        unknownMessage: "Unknown error",
        taxAuthorityReceivedDeclaration: "Tax authority received declaration",
        taxAuthorityApprovedDeclaration: "Tax authority approved declaration",
        declarationExplanation: "Declaration explanation",
        taxAuthorityCheckedData: "Tax authority checked data",
        taxAuthorityGrantedInvoiceCode: "Tax authority granted invoice code",
        taxAuthorityApprovedErrorNotice: "Tax authority approved error notice",
        taxAuthorityReceivedMessage: "Tax authority received the message",
        taxAuthorityApprovedDiscontinuation: "Tax authority approved discontinuation",
        pdf: "PDF",
        xml: "XML",
        updateTaxAuthorityStatus: "Update invoice status from tax authority",
        businessOperation: "Operations",
        viewAllInvoices: "View all invoices",
        addDiscountInvoice: "Add discount invoice",
        replace: "Replace",
        multipleReplace: "Replace multiple invoices",
        multipleAdjust: "Adjust multiple invoices",
        adjust: "Adjust",
        replaceOtherSystem: "Replace invoice from another system",
        adjustOtherSystem: "Adjust invoice from another system",
        multipleInvoiceDialogHeader: "Create {{title}} invoice for multiple invoices",
        multipleInvoiceLegalNotice: "Pursuant to Point b.2, Clause 1, Article 10 of Circular 91/2026/TT-BTC: If, during a month, the seller incorrectly issues multiple invoices for the same buyer with the same buyer information, item name, unit price, quantity, or tax rate, the seller may issue one adjustment or replacement invoice for those incorrect electronic invoices in the same month and attach a list of the incorrect electronic invoices using Form No. 01/BK-ĐCTT.",
        multipleInvoiceInstruction: "Creating {{actionName}} invoices for multiple invoices has 2 steps:",
        multipleInvoiceStep1: "Step 1: Create a list of incorrect invoices to {{title}}",
        multipleInvoiceStep2: "Step 2: Create an {{actionName}} invoice linked to the list number and date",
        askCreateInvoiceList: "Do you want to create an attached invoice list?",
        createInvoiceSkipList: "Create invoice and skip invoice list",
        createInvoiceWithList: "Create attached invoice list",
        invoiceCreationDate: "Invoice date",
        paymentType: "Payment method",
        storeName: "Store name",
        pumpCode: "Pump code",
        customerCode: "Customer code",
        entityName: "Entity name",
        buyerContact: "Buyer",
        citizenId: "Citizen ID",
        identityCard: "Identity card",
        budgetUnitCode: "Budget unit code",
        buyerCode: "Customer code",
        vehiclePlate: "Vehicle plate",
        buyerDisplayName: "Buyer name",
        provinceCode: "Province code",
        wardCode: "Ward code",
        passport: "Passport number",
        productType: "Select product type",
        totalPayment: "Total payment",
        liters: "Liters",
        unitPriceInclVat: "Unit price (VAT included)",
        totalBeforeTax: "Total before tax",
        totalTax: "Total tax",
        amountInWords: "Total amount in words",
        oilInvoice: "Petroleum invoice",
        guideNote: "Note",
        sellerTaxCode: "Seller tax code",
        buyerTaxCode: "Buyer tax code",
        invoiceListNo: "Invoice list number",
        invoiceListDate: "Invoice list date",
        sellerName: "Seller name",
        buyerAddress: "Buyer address",
        sellerAddress: "Seller address",
        generalInfo: "General information",
        sellerInfo: "Seller information",
        buyerInfo: "Buyer information",
        relatedInvoiceInfo: "Related invoice",
        otherInfo: "Other information",
        grandTotal: "Grand total",
        preview: "Preview",
        confirmCreateInvoiceWithList: "Confirm invoice creation with invoice list",
        reviewInvoiceList: "Review invoice list",
        confirmation: "Confirm",
        checkInvoiceAndList: "Please carefully review the invoice and invoice list before confirming.",
        discountedInvoiceListTitle: "Invoices discounted by revenue",
        discountInvoiceAttachmentTitle: "Discount invoice attachment list",
        commercialDiscountInvoice: "Create commercial discount invoice",
        syncFromSigningTool: "Sync from signing tool",
        syncInvoice: "Sync invoices",
        taxPayerCodeShort: "Seller tax code",
        currentInvoiceStatus: "Current invoice status",
        taxAuthorityInvoiceStatus: "Tax authority invoice status",
        queryTaxAuthority: "Check with tax authority",
        taxAuthorityFeatureRestriction: "This function only applies to invoices with tax authority submission status: Sending, Successful, or Error",
        statusMatches: "Invoice status matches.",
        statusChanged: "Invoice status has changed!",
        original: "Original",
        statusCancelled: "Cancelled",
        statusWaitingApproval: "Waiting for approval",
        statusWaitingSignature: "Waiting for signature",
        statusSigning: "Signing",
        statusSigned: "Signed",
        statusSending: "Sending",
        statusSuccessful: "Successful",
        statusFailed: "Error",
        statusAdjustment: "Adjustment",
        statusReplacement: "Replacement",
        statusExplanation: "Explanation",
        statusAdjusted: "Adjusted",
        statusReplaced: "Replaced",
        itemGoodsService: "Goods and services",
        itemPromotion: "Promotion",
        itemCommercialDiscount: "Commercial discount",
        itemDescription: "Description note",
        itemSpecialGoods: "Special goods",
        beingCancelled: "Cancelled",
        beingAdjusted: "Adjusted",
        beingReplaced: "Replaced",
        restoreStatus: "Restore status",
        paymentCompleted: "Invoice has been paid",
        paymentCompletedWithNumber: "Invoice {{serial}} number {{number}} has been paid",
        paymentPending: "Invoice payment pending",
        unitCode: "Unit code",
        unitName: "Unit name",
        salePrice: "Sale price",
        bulkTaxChange: "Change tax rate in bulk",
        lookupAccount: "Create invoice lookup account",
        createLookupUser: "Create lookup user",
        customerAccountCreated: "Account created",
        customerName: "Customer name",
        emailSeparatorPlaceholder: "Separate emails with , or ;",
        searchCccdNotFound: "No citizen ID data found.",
        searchCccdError: "Error searching citizen ID.",
        searchTaxDataNotFound: "No data found",
        searchTaxDataError: "Error searching tax code.",
        searchTaxDataV2Error: "Error searching tax code (V2).",
        electronicSocialInsurance: "Electronic social insurance",
        invoiceRiskManagement: "mSMI invoice risk management",
        electronicContract: "Electronic contracts",
        serviceTerms: "Accept service terms",
        mqrTerms: "Accept MQR terms",
        applyNewTaxRate: "Apply new tax rate",
        changeTaxRate: "Change tax rate",
        convert: "Convert",
        editor: "Modified by",
        calculationMethod: "Calculation method",
        saveAndExportDiscountInvoice: "Save and export discount invoice",
        addInvoice: "Add invoice",
        deleteInvoiceRow: "Delete invoice row",
        discountedInvoiceHint: "Click \"Add invoice\" to add invoices to the discount invoice list",
        currencyUnit: "Currency unit",
        exchangeRate: "Exchange rate",
        taxAuthorityShortCode: "Tax authority code",
        fillRequiredInfo: "Please fill in all required information",
        invoiceNotSelected: "No invoice selected",
        discount: "Discount",
        multipleInvoices: "Multiple invoices",
        paid: "Paid",
        unpaid: "Unpaid",
        invoiceSelectionRequired: "Select an invoice before continuing",
        printInvoiceSelectionRequired: "Select an invoice before viewing/printing",
        signInvoiceSelectionRequired: "Select an invoice before signing",
        emailInvoiceSelectionRequired: "Select an invoice before sending email",
        onlyWaitingSignature: "This action is only available for invoices waiting for signature",
        invalidReplaceStatus: "Only successfully submitted invoices in Original or Replacement status can be replaced",
        invalidAdjustStatus: "Only successfully submitted invoices in Original or Adjusted status can be adjusted",
        invalidDeleteStatus: "You cannot delete signed, submitted, successful, or failed invoices",
        signTimeWarningTitle: "Warning: invoice is being signed outside the permitted time",
        continueSign: "Yes, continue signing",
        restoreInvoiceStatusQuestion: "Do you really want to restore the invoice status to Waiting for signature and resend it to the tax authority?",
        retrieveSuccessMessageQuestion: "Do you really want to retrieve the success message?",
        restoreSuccess: "Status restored successfully",
        retrieveSuccess: "Retrieved successfully",
        reloadSuccess: "Reloaded successfully",
        execute: "Execute",
        check: "Check",
        transactionInfo: "Transaction information",
        invoiceTransferHistory: "Invoice transfer history",
        invoiceEmailHistory: "Email sending history",
        checkEmailHistory: "Check email sending history",
        sentDate: "Sent date",
        sentStatus: "Sending status",
        viewed: "Viewed",
        notViewed: "Not viewed",
        emailRecipientPlaceholder: "Enter recipient email before sending",
        emailRequired: "Email address is required",
        emailInvalidAtIndex: "Email {{index}} is invalid",
        invoiceHeader: "Invoice",
        invoiceTypeApplied: "Applicable invoice type",
        noticeType: "Notice type",
        noticeNumber: "Notice number",
        noticeDate: "Notice date",
        taxAuthority: "Tax authority",
        taxPayer: "Taxpayer",
        creationPlace: "Place of creation",
        invoiceReason: "Reason for error",
        sampleNumber: "Form number",
        invoiceProperty: "Invoice property",
        statementHistory: "Statement history",
        columnName: "Column name",
        columnWidth: "Width (px)",
        total: "Total",
        restoreDefault: "Restore default",
        view: "View",
        print: "Print",
        select: "Select",
        choose: "Choose",
        loading: "Loading...",
        empty: "No data",
        noResults: "No results found",
        success: "Success",
        error: "An error occurred",
        requestError: "An error occurred. Please check the operation and try again",
        updated: "Data has been updated!",
        invalidData: "Invalid data. Please check again",
        sequenceNumber: "No.",
        description: "Description",
        taxCode: "Tax code",
        user: "User",
        profile: "Profile",
        notifications: "Notifications",
        digitalTransformationNotice: "Please read Digital Transformation publication 04",
        guide: "Guide",
        changePassword: "Change password",
        logout: "Log out",
        home: "Home",
        mst: "Tax code",
        accept: "Confirm",
        rejectAction: "Reject",
        requiredField: "{{field}} is required",
        selectField: "Please select {{field}}",
        fileDownloadFailed: "Download failed!",
        errorCode: "An error occurred [CODE {{code}}]",
        continueSaving: "Do you want to continue saving?",
        minutes: "minutes",
        currentPassword: "Current password",
        pinCode: "PIN",
        certificatePassword: "Certificate password",
        applicationId: "Application ID",
        uploadCertificateFile: "Upload certificate file",
        validCertificateFileFormat: "Valid formats are .p12 or .fpx files",
        signingServerSetup: "Configure connection to signing server",
        certificateConnectionInfo: "Connection information provided by the certificate provider",
        addCertificate: "Add certificate",
        editCertificate: "Edit certificate",
        deleteCertificate: "Delete certificate",
        changeCertificatePassword: "Change password",
        defaultSign: "Default signing",
        cancelNoticeTypeTaxpayer: "Cancellation/explanation notice from taxpayer",
        cancelNoticeTypeTaxAuthority: "Cancellation/explanation notice based on tax authority notice",
        taxAuthorityNoticeHint: "Note: To submit an invoice error notice, update the correct managing tax authority code",
        here: "here",
        sendErrorNoticeQuestion: "Do you want to send the invoice error notice to the tax authority under form 04/SS-HDDT now?",
        signSS04: "Sign and send 04/SS-HDDT",
        sendLater: "No, send later",
        invoiceListInvalid: "Invalid invoice list",
        wrongInvoiceReasonRequired: "The error reason for invoice {{number}} is required.",
        certificateDataInvalid: "Invalid data",
        selectCertificateRequired: "Please select a certificate",
        usedCertificateCannotDelete: "Certificates in use cannot be deleted",
        unsupportedCertificatePasswordChange: "This certificate type does not support password changes",
        fees: "Fees",
        otherInformation: "Other information",
        nonTaxableDeduction: "Non-taxable deduction",
        otherDeduction: "Other deduction",
        specialInvoice: "Special invoice",
        variableName: "Variable name",
        labelWidth: "Label width",
        valueWidth: "Value width",
        maxLength: "Maximum length",
        decimalPlaces: "Decimal places",
        editable: "Editable",
        multipleFormula: "Multiple formulas",
        group: "Group",
        requiredInput: "Required",
        excelFormula: "Excel formula",
        excelColumnTitle: "Excel column title",
        calculationOrder: "Calculation order",
        excelValue: "Excel value",
        xmlGroup: "XML group",
        sort: "Sort",
        cancelRecordQuestion: "Are you sure you want to cancel this record?",
        cancelRecord: "Confirm cancellation",
        deleteRecordQuestion: "Are you sure you want to delete this record?",
        deleteData: "Confirm deletion",
        signAndSendQuestion: "Are you sure you want to sign and send to the tax authority?",
        signAndSend: "Sign and send",
        signedStatementWarning: "This statement has been signed. This action will invalidate the previous digital signature.",
        notice: "Notice",
        restorePermissionQuestion: "Are you sure you want to restore full data permissions?",
        restorePermission: "Restore permissions",
        taxAuthorityCodeQuestion: "Are you sure you want to retrieve the tax authority code for invoices that were sent and returned an error?",
        getTaxAuthorityCode: "Retrieve tax authority code",
        changeTaxQuestion: "Are you sure you want to apply the tax rate to all selected items?",
        changeTax: "Confirm tax rate change",
        updateSellerInfoQuestion: "Are you sure you want to update the seller information on invoices using the declared company information?",
        updateSellerInfo: "Update seller information",
        machineInvoiceWarning: "Under current regulations, an incorrect cash-register e-invoice must be replaced. Do you want to continue adjusting this invoice?",
        registeredAssetInvoiceAdjustmentWarning: "Under Circular 91/2026/TT-BTC, an invoice for the sale of assets requiring registration of ownership or use may only be replaced. Do you want to switch to creating a replacement invoice?",
        replaceInvoice: "Replace invoice",
        continueAdjustment: "Continue adjustment",
        warning: "Warning",
        permissionQuestion: "The new account will use all invoice symbols, digital certificates and invoice viewing permissions of other accounts. Do you want to configure detailed permissions?",
        products: "Products",
        purchases: "Purchases",
        registerAgent: "Register as an agent",
        sign: "Digital sign",
        socialDemo: "Demo",
        settings: "Settings",
        displayScale: "Display size",
        theme2022: "IAM Software theme - 2022",
        theme2021: "IAM Software theme - 2021",
        certificateNotConfigured: "No digital certificate is registered or you do not have permission to use one.",
        selectCertificate: "Select digital certificate",
        certificateProvider: "Certificate provider",
        certificateOwner: "Owner",
        certificateType: "Type",
        tokenIssuer: "Name of the organization certifying/issuing/recognizing the digital or electronic signature",
        tokenSerial: "Certificate serial number",
        tokenRegistrationForm: "Registration type",
        tokenFormNew: "New registration",
        tokenFormRenew: "Renewal",
        tokenFormDiscontinued: "Discontinued",
        add: "Add",
        pauseInvoiceGuideTitle: "Request to suspend the use of electronic invoices",
        pauseInvoiceGuideIntro: "Declare the information for suspending the use of electronic invoices when:",
        pauseInvoiceGuideReason: "The business temporarily suspends operations, dissolves, or is required to do so by the tax authority",
        note: "Note",
        pauseInvoiceGuideDateRule: "Start and end dates of the suspension:",
        pauseInvoiceGuideDateRequired: "Both fields are required",
        pauseInvoiceGuideDateAfterDeclaration: "The suspension start date must be later than the declaration date",
        pauseInvoiceGuideDateOrder: "The suspension start date must be earlier than the suspension end date",
        pauseInvoiceGuideMultipleProviders: "If different electronic invoice issuance software is used, the business must declare complete information for all service providers related to the suspension registration.",
        pauseInvoiceGuideSpecificCertificate: "Declare a certificate serial number only when suspension is required for one or more specific certificates. Leave this field empty to suspend all certificates.",
        pluginUpdate: "Update M-INVOICE Plugin",
        pluginDownload: "Download installer",
        pluginVersionRequirement: "Signing multiple adjustment/replacement invoices with an attached list requires M-INVOICE Plugin version {{version}} or later. Update the plugin and sign again.",
        jobNotFound: "Job not found",
        resumeSuccess: "Job resumed successfully",
        retryError: "An error occurred. Please try again",
        exportErrorTitle: "Export error",
        exportErrorMessage: "The report could not be created due to a system error.",
        errorDetails: "Error details:",
        copiedError: "Error copied",
        exportProgress: "Exporting data",
        exportSuccess: "Export completed successfully",
        exportFailed: "Export failed",
        records: "records",
        exportRunningMessage: "Data export is in progress. Please wait.",
        currentlyExported: "Currently exported",
        filesInZip: "{{count}} files in file.zip",
        viewDetails: "View details",
        continue: "Continue",
        exportSuccessMessage: "Data export completed successfully",
        templateCode: "Template code",
        templateName: "Template name",
        invoiceType: "Invoice type",
        invoiceTemplate: "Invoice template",
        financialYearTemplateTitle: "CREATE INVOICE TEMPLATE BY FISCAL YEAR",
        copyInvoiceTemplate: "Copy invoice template",
        financialYearTemplateNotice: "Under Decree 123/2020/ND-CP and Circular 78/2021/TT-BTC, invoice symbols are assigned by year and invoice numbering restarts at 1 from January 1 or the date electronic invoice use begins. Select the symbols to use and click Copy invoice template to move them to the next year.",
        paperSize: "Paper size",
        paperOrientation: "Paper orientation",
        charactersPerLine: "Characters per line",
        caseConversion: "Case conversion",
        linesPerPage: "Lines per page",
        blankLines: "Blank lines",
        showSequence: "Show sequence",
        htmlFile: "HTML file",
        imageFile: "Image file",
        image: "Image",
        creator: "Creator",
        createdDate: "Created date",
        companyType: "Company type",
        normal: "Normal",
        petroleum: "Petroleum",
        jewelry: "Jewelry",
        airline: "Airline ticket",
        vehicleSales: "Vehicle sales",
        vehicleSalesNd254: "Vehicle sales NĐ 254",
        transportation: "Transportation service",
        digitalTransportation: "Digital platform transportation service",
        previewFiles: "View template file and image",
        notificationManagement: "Notification management",
        notificationTitle: "Title",
        effectiveFrom: "Effective from",
        effectiveTo: "Effective to",
        active: "Active",
        priority: "Priority",
        errorHelp: "Error handling guide",
        messageType: "Message type",
        messageCode: "Message code",
        errorCodeLabel: "Error code",
        errorReason: "Error reason",
        resolution: "Resolution",
        recommendation: "M-Invoice recommendation",
        recoverPassword: "Recover password",
        recoverByEmail: "Enter your tax code and email to recover your password",
        recoverByToken: "Insert the USB Token and install the signing plugin to recover your password",
        confirmPassword: "Confirm password",
        newPassword: "New password",
        passwordMismatch: "The passwords do not match",
        fieldFormatInvalid: "{{field}} has an invalid format",
      },
      declarationGuidance: {
        authDirectTitle: "Guide to direct verification at the tax authority",
        authDirectSubject: "The legal representative is a foreigner who is not eligible for biometric verification on the eTax Mobile application, or the case requires direct verification by the tax authority.",
        authDirectDeadline: "During the working day or no later than the next working day after receiving the request for direct verification.",
        authDirectDocumentId: "Original citizen ID card or passport.",
        authDirectDocumentPortrait: "Photocopy of the portrait photo.",
        authDirectDocumentNotice: "Printed notice or declaration awaiting verification on the system, if available.",
        authDirectSteps: "The taxpayer visits the tax authority directly managing the enterprise, presents the original citizen ID card or passport and portrait photo, and completes biometric verification as required by the tax authority.",
        authBiometricTitle: "Biometric verification guide - eTax Mobile",
        authBiometricSubjectFirst: "Cases registering for electronic invoice use for the first time, or",
        authBiometricSubjectSecond: "Changes where the legal representative's information is updated.",
        authBiometricDeadline: "During the working day or no later than the next working day after receiving the request for biometric verification.",
        authOtpTitle: "OTP verification guide - eTax Mobile",
        authOtpSubject: "Cases changing electronic invoice information such as taxpayer information, signing certificate, managing tax authority, invoice form, electronic invoice data submission method, or invoice type without changing the legal representative's information.",
        authOtpDeadline: "During the working day or no later than the next working day after receiving the request for OTP verification.",
        mobileSteps: "Open the eTax Mobile application and follow the verification instructions",
        explanationTitle: "Risky invoice explanation guide",
        explanationSubjectFirst: "The enterprise changes its legal representative, and the new representative's citizen ID/VNeID data is inconsistent or has a tax debt or tax violation history at a former enterprise.",
        explanationSubjectSecond: "The enterprise changes its head office to a virtual address, a residential building where business is not permitted, or an address matching an absconded enterprise.",
        explanationSubjectThird: "A newly established or recently reactivated enterprise in trading, wholesale, or logistics has nominal capital or insufficient warehouse facilities.",
        explanationDeadline: "During the working day or no later than the next working day after receiving the request for an explanation.",
        explanationStepFirst: "Check the detailed notice from the tax authority to identify the reason for the explanation and the risk code.",
        explanationStepSecond: "Prepare supporting documents such as citizen ID, business registration certificate, lease contract, and office photos.",
        explanationStepThird: "Prepare an explanation letter and submit it with the supporting documents online through eTax or directly to the tax authority.",
        commonNote: "After verification, the tax authority will continue checking the taxpayer information and respond if additional information is required.",
        qrUnavailable: "QR code could not be loaded",
        qrAlt: "QR code to download eTax Mobile from {{storeName}}",
        openStore: "Open {{storeName}} to download eTax Mobile",
        fallbackTitle: "Guide",
        close: "Close guide",
        subject: "Person responsible",
        deadline: "Time limit",
        documents: "Required documents",
        method: "How to proceed",
        openGuide: "HERE",
        qrCaption: "Scan to download the eTax Mobile application",
      },
      auth: {
        username: "Username",
        password: "Password",
        rememberMe: "Remember me",
        login: "Log in",
        forgotPassword: "Forgot password?",
        registerPrompt: "Don't have an account?",
        register: "Register",
        loginTitle: "Log in",
        forgotPasswordTitle: "Forgot password",
        email: "Email",
        send: "Send",
        resetPassword: "Reset password",
        forgotPasswordSuccess: "Your password reset request has been sent.",
        forgotPasswordSuccessEmail: "Check your email to continue.",
        forgotPasswordSuccessToken: "Check your USB Token to continue.",
        recoverByEmailSuccess: "A new password has been sent to your email. Use it to log in.",
        recoverByTokenSuccess: "Your password has been changed. Use the new password to log in.",
        backToLogin: "Back to log in",
        signStatementTitle: "Confirm statement signing",
      },
      menu: {
        invoice: "Invoices",
        issue: "Issuance",
        history: "Transmission history",
        errors: "Error handling",
        reports: "Reports",
        catalog: "Catalog",
        system: "System",
        configuration: "Configuration",
        languageCustomization: "Language customization",
        bilingualVietnameseEnglish: "Bilingual (Vietnamese - English)",
        signCustomization: "Signing customization",
        signImmediately: "Sign invoice and send immediately to the tax authority",
        signSummaryAtPeriodEnd: "Sign invoice and send the period-end summary",
        colorCustomization: "Color customization",
        fontCustomization: "Font customization",
        buyerCustomization: "Buyer customization",
        underlineBuyerValue: "Underline buyer value",
        tableCustomization: "Table customization",
        tableRowBorders: "Table has row borders",
        columnSymbolRows: "Set column symbol row count",
        blankRows: "Blank rows",
        multiPageInvoiceRows: "Rows for multi-page invoices",
        signatureLabelCustomization: "Signature label customization",
        headSignature: "Head signature",
        emailInvoice: "Email invoice",
        htmlFormat: "HTML format",
        invoiceType: "Invoice type",
        templatePrintRows: "Template print rows",
        creator: "Created by",
        active: "In use",
        viewInvoiceTemplate: "View invoice template",
        copyInvoiceTemplate: "Copy invoice template",
        printConvertedInvoice: "Print converted invoice",
        logoBackground: "Logo - Background",
        detailCustomization: "Detail customization",
        saveInfo: "Save information",
        logoFileSizeExceeded: "The logo file must not exceed 100KB",
        imageFileRequired: "The file must be an image",
        logoDimensionExceeded: "The logo dimensions exceed the limit. Maximum: {{width}}x{{height}}px",
        imageReadFailed: "The image file could not be read",
        borderFileSizeExceeded: "The uploaded file must not exceed 300KB",
        borderDimensionExceeded: "The border dimensions exceed the recommended limit: {{pageSize}}: {{width}} x {{height}}",
        backgroundFileSizeExceeded: "The background file must not exceed 200KB",
        backgroundDimensionExceeded: "The background dimensions exceed the limit. Maximum: {{width}}x{{height}}px",
        useQrCode: "Use QR code",
        sizeCustomization: "Size customization",
        useLogo: "Use logo",
        chooseLogoFromComputer: "Choose from computer; maximum 100KB",
        maxDimension: "Maximum size: ({{dimension}})",
        useBackground: "Use background",
        chooseImageFromComputer: "Choose image from computer",
        chooseBackgroundFromLibrary: "Choose background image from library",
        chooseBackgroundFromComputer: "Choose from computer; maximum 200KB",
        opacity: "Opacity",
        useBorder: "Use border",
        chooseBorderFromComputer: "Choose from computer; maximum 300KB",
        maxPageDimension: "Maximum {{pageSize}} size: ({{width}}x{{height}})",
        issueRegistration: "Issue registration",
        declaration123: "Register/change declaration ND123/2020",
        declaration70: "Register/change declaration ND70/2025-ND254/2026",
        outputInvoice: "Output invoices",
        errorNotification: "Invoice error notices",
        invoiceReplacement: "Replace invoice",
        invoiceAdjustment: "Adjust invoice",
        invoiceCancellation: "Cancel invoice",
        otherInvoiceReplacement: "Replace invoice from another system",
        otherInvoiceAdjustment: "Adjust invoice from another system",
        multipleInvoiceReplacement: "Replace multiple invoices",
        multipleInvoiceAdjustment: "Adjust multiple invoices",
        electronicInvoiceN123: "Electronic invoice under Decree 123",
        authenticatedInvoiceQD1209: "Authenticated invoice under Decision 1209",
        invoiceN51: "Invoice under Decree 51",
        preprintedInvoiceN123: "Preprinted invoice under Decree 123",
        commercialDiscountInvoiceTypeName: "commercial discount invoice with attached list",
        inside: "Inside",
        outside: "Outside",
        invoiceList: "Invoice list",
        invoiceDiscountList: "Discount invoice list",
        declaration: "Registration declaration",
        paymentHistory: "QRCode payment history",
        usageReport: "Invoice usage report",
        invoiceSummaryReport: "Invoice summary report",
        invoiceDetailReport: "Invoice detail report",
        pmktReport: "Received from accounting software report",
        plReport: "PL101/2023/QH15 report",
        salesReport: "Outgoing invoice list report (PL01)",
        petrolReport: "Petroleum tax report",
        summary01Report: "Create invoice summary form 01/TH-HĐĐT",
        mstStatus: "Tax code status check",
        bank: "Bank",
        businessLocation: "Business location",
        petrolManagement: "Petroleum management",
        petrolStore: "Petroleum store",
        petrolProduct: "Petroleum product",
        pump: "Pump",
        integratedDevices: "Integrated device catalog",
        petrolTransactions: "Petroleum transactions",
        petrolInvoiceConfig: "Petroleum invoice configuration",
        companyManagement: "Company management",
        companyInfo: "Company information",
        license: "License",
        userManagement: "User management",
        digitalCertificateRegistration: "Digital certificate registration",
        systemParameterDeclaration: "System parameter declaration",
        invoiceConfiguration: "Invoice configuration",
        valueReplacement: "Replacement values",
        defaultValue: "Default values",
        invoiceTemplateManagement: "Invoice template administration",
      },
      validation: {
        required: "{{field}} is required",
        multiInvoiceCashRegisterRestricted: "The tax authority only allows {{actionName}} multiple coded and non-coded invoices",
        multiInvoiceRegisteredAssetRestricted: "The tax authority does not yet support this operation for vehicle purchase and sale invoices",
        invalid: "{{field}} is invalid",
        businessLocationCodeLengthHouseholdOrBranch: "The business location code for a household business/business branch must not exceed 5 characters",
        businessLocationCodeLengthPetrolBusiness: "The business location code for a petroleum business enterprise must not exceed 14 characters",
        monthRange: "Month must be between 1 and 12",
        quarterRange: "Quarter must be between 1 and 4",
        yearFormat: "Year must be a four-digit integer",
        fromDateInvalid: "From-date condition is invalid",
        toDateInvalid: "To-date condition is invalid",
        dateRangeOrder: "From date must be earlier than or equal to the to date",
        dateRangeRequired: "From date and to date are required.",
        operatorRequired: "Operator for {{field}} is required.",
        invoiceStatusConditionInvalid: "Invoice creation status condition is invalid.",
        selectTransaction: "No transaction selected.",
        invoiceAlreadyCreated: "The record already has an invoice and cannot be created again",
        invoiceCreationFailed: "Invoice creation failed for the record; it cannot be created again",
        invoiceCancelledCannotCreate: "The record is cancelled and cannot be invoiced",
        noData: "No data found.",
        containsCreatedInvoice: "The selection contains records with invoices; please review it",
        containsUncreatedInvoice: "The selection contains records without invoices; please review it",
        selectMultipleTransactions: "Select more than one record before grouping invoice logs",
        cancelledCannotEdit: "A cancelled transaction cannot be edited.",
        previousVolumeInvalid: "The previous pumped volume is invalid.",
        positiveDifferenceOnly: "Select only transactions with a positive difference.",
        alreadyCompensated: "This transaction has already been compensated.",
        cannotCancelInvoiced: "An invoiced transaction cannot be cancelled.",
        alreadyCancelled: "This transaction is already cancelled.",
        createInvoiceQuestion: "Do you want to create invoices for these records?",
        groupTransactionQuestion: "Do you want to group the selected transactions?",
        updateInvoiceNumberQuestion: "Confirm updating invoice numbers for {{count}} transactions",
        compensateTransactionQuestion: "Confirm compensating {{count}} selected transactions",
        selectDevice: "Select a device before editing",
        selectProduct: "Select a product before editing",
        selectProductForTaxChange: "Select a product before changing the tax rate",
        selectCustomer: "No customer selected",
        chooseStore: "Please select a store",
        enterSecurityCode: "Please enter the security code",
        pecoDeviceIdMissing: "No valid DeviceId was found for the selected store in DOI_GIA_TU_PECO.",
        pecoPriceUpdateFailed: "Could not send the price update request to the PECO cabinet.",
        taxStatusNotFound: "Tax information not found",
        codeChars: "Only letters, numbers, hyphens (-) and underscores (_) are allowed.",
        taxCodeInvalid: "The tax code is incorrect",
        emailInvalid: "Invalid email",
        passwordRequired: "Password is required",
        wrongInvoiceDenominatorRange: "The invoice form number must be between 1 and 6",
        wrongInvoiceRelatedSerialLength: "The related invoice symbol must have a valid length.",
        wrongInvoiceFormChar: "The invoice form character is invalid",
        wrongInvoiceYearChar: "The symbol year characters are invalid",
        wrongInvoiceTypeChar: "The invoice type character is invalid",
        wrongInvoiceDenominatorLength: "The related invoice form number has an invalid length.",
        wrongInvoiceFirstTypeChars: "The first two invoice type characters are invalid",
        wrongInvoiceKindChars: "The four invoice type characters are invalid",
        wrongInvoiceCopiesChar: "The copies character is invalid",
        wrongInvoiceSeparator: "The separator character in the symbol is invalid",
        wrongInvoiceIssueSequence: "The three issuance sequence characters are invalid",
        wrongInvoiceSerialLength: "The invoice symbol has an invalid length.",
        wrongInvoiceSerialPrefix: "The first two characters are invalid",
        wrongInvoiceSerialYear: "The issuance year characters are invalid",
        wrongInvoiceSerialType: "The invoice type character is invalid",
        relatedInvoiceDateCannotBeFuture: "The related invoice date cannot be later than today",
        wrongInvoiceLine: "Line {{line}}: {{message}}",
      },
      invoice: {
        electronicInvoiceSolution: "Electronic invoicing solution",
        invoice: "Invoice",
        printInvoice: "Print invoice",
        downloadPdf: "Download PDF",
        signToTaxAuthority: "Sign and send to tax authority",
        printSwitch: "Print converted invoice",
        invoiceNumber: "Invoice number",
        invoiceSymbol: "Invoice symbol",
        seller: "Seller",
        buyer: "Buyer",
        lineItems: "Goods and services",
        payment: "Payment",
        signAndSend: "Sign and send to tax authority",
      },
      catalog: {
        unit: "Unit",
        product: "Goods and services",
        customer: "Customer",
        currency: "Currency",
        paymentMethod: "Payment method",
        taxRate: "Tax rate",
        businessLocation: "Business location",
        businessLocationType: "Business type",
        businessLocationTypeHouseholdOrBranch: "Household business/Business branch",
        businessLocationTypePetrolBusiness: "Petroleum business enterprise",
        businessLocationCode: "Business location code",
        businessLocationName: "Business location name",
        businessLocationAddress: "Business location address",
        businessLocationHint: "Please declare a business location for this invoice series",
        petrolStoreCode: "Store code",
        petrolStoreName: "Store name",
        petrolStoreAddress: "Store address",
        priceUpdateLink: "Fuel price update link",
        priceUpdateResult: "Price update result",
        oldPrice: "Old price",
        newUnitPrice: "New unit price",
        iotPriceUpdateStatus: "Price update status on the IoT system",
        priceChangeHistory: "Price change history",
        pumpNozzleCode: "Pump code",
        fuel: "Fuel",
        fuelCodeAtPump: "Pump fuel code",
        fuelAtPump: "Fuel at pump",
        pumpSeries: "Pump series",
        measuringColumnType: "Measuring column type",
        modelApproval: "Model approval",
        maintenance: "Maintenance",
        effectiveTime: "Effective time",
        expiryTime: "Expiry time",
        chooseStore: "Select store",
        securityCode: "Security code",
        newPrice: "New price",
        pecoPriceChange: "Change fuel price on PECO cabinet",
        confirmPumpPriceUpdate: "Are you sure you want to update the price on the pumps?",
        deviceCode: "Device code",
        deviceName: "Device name",
        integrationSymbol: "Symbol",
        integrationType: "Integration type",
        paymentSpeaker: "Payment speaker",
        taxCode: "Tax rate code",
        currencyCode: "Currency code",
        currencyName: "Currency name",
        quantityDecimals: "Quantity decimal places",
        unitPriceDecimals: "Unit price decimal places",
        totalDecimals: "Total decimal places",
        taxDetailDecimals: "Detailed tax decimal places",
        taxAmountDecimals: "Total tax decimal places",
        readCurrency: "Read currency",
        readDecimal: "Read decimal number",
        integratedDeviceCatalog: "Integrated device catalog",
        createInvoiceFromTransactions: "Create invoices from petroleum transactions",
        productCode: "Product code",
        productName: "Product name",
        listedPrice: "Listed price",
        listedPriceWithVat: "Listed price (VAT included)",
        invoicePrice: "Invoice selling price",
        mobileUsage: "Use on mobile application",
        priceList: "Price list",
        order: "Order",
        paymentCode: "Code",
        paymentName: "Name",
        paymentMaximumValue: "Maximum value",
        emailTemplate: "Email template",
        emailSubject: "Subject",
        emailUsage: "In use",
        emailBusinessType: "Business type",
        emailSendInvoice: "Send invoice",
        emailSendConfirmation: "Send confirmation",
        emailSendAccount: "Send account",
        emailErrorNotice: "Error notice",
        emailPaymentReminder: "Payment reminder",
        paymentProductType: "Product type",
        beneficiaryBank: "Beneficiary bank",
        accountNumber: "Account number",
        accountName: "Account name",
        primaryBeneficiaryAccount: "Primary beneficiary account",
        saleDateTime: "Sale date and time",
        storeCode: "Store code",
        pumpCode: "Pump code",
        pumpActionCode: "Pump transaction code",
        pumpStartTime: "Pump start time",
        pumpedTotal: "Total pumped volume",
        salesStaffCode: "Sales staff code",
        previousPumpedTotal: "Previous pumped volume",
        petrolTransactionList: "Petroleum transaction list",
        qrCodePaymentLabel: "QR Code payment",
        errorName: "Error name",
        integrationKey: "Integration key",
        reportType: "Report type",
        detailTransactionReport: "Detailed transaction report",
        summaryTransactionReport: "Summary transaction report",
        store: "Store",
        pump: "Pump",
        staffCode: "Staff code",
        invoiceCreationStatus: "Invoice creation status",
        invoiceCreationStatusShort: "Invoice creation status",
        customerTaxCode: "Customer tax code",
        customerPhone: "Customer phone number",
        notCreated: "Not created",
        created: "Created",
        createError: "Creation error",
        cancelled: "Cancelled",
        unpaid: "Unpaid",
        paid: "Paid",
      },
      system: {
        company: "Company",
        companyName: "Company name",
        serial: "Serial",
        licenseQuantity: "License quantity",
        product: "Product",
        issueDate: "Issue date",
        startDate: "Start date",
        expiryDate: "Expiry date",
        permissionGroupName: "Permission group name",
        users: "Users",
        permissionGroups: "Permission groups",
        digitalCertificate: "Digital certificate",
        systemParameters: "System parameters",
        emailServer: "Email server configuration",
        formulaType: "Calculation method",
        formula: "Formula",
        addFormula: "Add formula",
        formulaConfig: "Formula configuration",
        selectCalculation: "Select calculation method",
        dataArea: "Data area",
        numericValues: "Numeric values",
        operation: "Operation",
        value: "Value",
        resetFormula: "Reset",
        testFormula: "Test formula",
        calculate: "Calculate",
        invalidFormula: "Invalid formula",
        testFormulaHeader: "Test formula",
        permissionDialog: "Permissions",
        accessOtherUserDocuments: "View documents of other users",
        editOtherUserDocuments: "Edit documents of other users",
        deleteOtherUserDocuments: "Delete documents of other users",
        signingMethod: "Signing method",
        signSummary: "Sign with summary",
        signNowTaxAuthority: "Sign to tax authority now",
        identityCode: "Tax authority code",
        province: "Province",
        bankAccount: "Bank account",
        bankName: "Bank",
        paymentIntegrationCode: "Payment integration code",
        legalRepresentativeSection: "LEGAL REPRESENTATIVE INFORMATION",
        legalRepresentative: "Legal representative",
        legalRepresentativePhone: "Legal representative phone",
        useCitizenId: "Household business uses citizen ID instead of seller tax code",
        contactSection: "CONTACT INFORMATION",
        taxAuthoritySection: "TAX AUTHORITY AND INVOICE LOOKUP INFORMATION",
        provincialTaxAuthority: "Provincial tax authority",
        managingTaxAuthority: "Managing tax authority",
        agentInfo: "Agent information",
        changeHistory: "Change history",
        modifiedBy: "Modified by",
        modifiedDate: "Modified date",
        data: "Data",
        viewChangeHistory: "View change history",
        changeHistoryInfo: "Information change history",
        dataPermission: "Data-based permissions",
        fullDataPermission: "Full data permissions",
        resetDefaultPermission: "Reset default permissions",
        permissions: "Permissions",
        helpUrl: "Help URL",
        default: "Default",
        petrolSyncConfigTitle: "Create petrol invoices from transaction logs",
        invoiceResyncTime: "Invoice resynchronization time",
        condition: "Condition",
        syncType: "Synchronization type",
        startTime: "Start time",
        endTime: "End time",
        defaultEndTime: "23:59:59 (Default)",
        fieldName: "Field name",
        creationTime: "Invoice creation time",
        autoSignConditionTitle: "Conditions",
        autoSignEndTimeBeforeStart: "The end time cannot be earlier than the start time.",
        autoSignConditionIncomplete: "Complete the field, condition, and value for each used row.",
        autoSignCreationTimeInvalid: "Invoice creation time must use HH:mm:ss from 00:00:00 to 23:59:59.",
        autoSignInvoiceDateInvalid: "Invoice date must be Today or Yesterday.",
        autoSignTimeOverlap: "This time range overlaps another auto-sign job for the same symbol.",
        takeLogRecords: "Number of log records retrieved per scan",
        scanConditionRequired: "Please enter the data scan condition",
        emailMttConfigTitle: "Configuration for sending signed cash-register invoice notifications",
        notificationEmail: "Notification recipient email",
        notificationResendTime: "Notification resend/signing retry time",
        feature: "Feature",
        autoSignInvoice: "Automatically sign invoice",
        sendNotificationEmail: "Send notification email",
        signAgainTime: "Sign invoice again after",
        resendNotificationTime: "Resend notification after",
        emailSeparatorHint: "Separate emails with comma (,) or semicolon (;)",
        conditionLabel: "Condition:",
        certificateCondition: "The customer has registered a FILE or Service digital certificate in the software",
        invoiceStatusCondition: "The invoice is waiting for signature and has an invoice date",
        emailServerConfig: "Email server configuration",
        alias: "Alias",
        displayAddress: "Display address",
        smtpHost: "SMTP host",
        smtpPort: "SMTP port",
        sslAuthentication: "SSL authentication",
        defaultLogin: "Default login",
        invoiceConfig: "Invoice configuration",
        configCode: "Configuration code",
        invoiceType: "Invoice type",
        configCodeRequired: "Configuration code is required",
        invoiceTypeRequired: "Invoice type is required",
        exit: "Exit",
      },
      report: {
        report: "Report",
        filters: "Filters",
        summary: "Summary",
        day: "Day",
        month: "Month",
        quarter: "Quarter",
        submissionCount: "Submission count",
        firstSubmission: "First submission",
        supplementarySubmission: "Supplementary submission",
        dataPeriod: "Data period",
        monthOrQuarter: "Month/Quarter",
        year: "Year",
        summaryNumber: "Summary number",
        supplementCount: "Supplement count",
        currencyUnit: "Currency",
        createdBy: "Created by",
        signDateTime: "Signing date and time",
        summaryDetails: "Summary details",
        summaryTransferHistory: "Transfer history",
        summaryLookup: "Select invoices for summary",
        summaryLimitNotice: "To ensure the payload size when sending data to the tax authority, select no more than 2,000 invoices in one summary",
        summaryCreateTitle: "Create invoice data summary",
        summaryFindInvoices: "Find invoices to add to the summary",
        summaryInvoiceSelectionLegend: "{{action}} invoices to add to the summary",
        summaryUpdateAction: "Update",
        summarySupplementAction: "Supplement",
        summaryInvoiceSerialPlaceholder: "Select invoice symbol",
        goodsType: "Goods type",
        otherGoods: "Other",
        flightGoods: "Air transportation",
        currencyCode: "Currency code",
        multipleTax: "Use multiple tax rates in one invoice",
        invoiceNumberShort: "Number",
        summaryPeriodPlaceholder: "Month or quarter",
        accountingSoftware: "Accounting software",
        productNameWithService: "Goods and services name",
        amountBeforeTax: "Amount before tax",
        vatRateByRegulation: "VAT rate by regulation",
        vatRateAfterReduction: "VAT rate after 20% reduction",
        vatReductionAmount: "VAT reduction amount",
        petrolStoreCode: "Petrol station code",
        pumpColumnCount: "Pump column count",
        quantitySold: "Quantity sold",
        issuedInvoiceQuantity: "Issued invoice quantity",
        petrolRevenue: "Petroleum product sales revenue",
        totalCount: "Total",
        retailCustomerCount: "Including: Retail customers",
        successfulInvoiceStatus: "Successfully sent invoice status",
        successfulInvoiceCount: "Total successfully sent invoices",
        failedInvoiceCount: "Total unsuccessfully sent invoices",
        usedInvoiceCount: "Total used invoices",
        totalAfterTax: "Amount after tax",
        signDate: "Signing date",
        totalOtherDeductions: "Other deductions",
        exchangeRate: "Exchange rate",
        totalFee: "Total fee",
        relatedInvoiceType: "Related invoice type",
        relatedInvoiceTemplateNumber: "Related invoice template number",
        relatedInvoiceSymbol: "Related invoice symbol",
        relatedInvoiceNumber: "Related invoice number",
        adjustmentPeriodType: "Adjustment data period type",
        adjustmentPeriod: "Adjustment data period",
        summaryStatusOrigin: "Original",
        summaryStatusRefused: "Cancelled",
        summaryStatusAdjusting: "Adjusting",
        summaryStatusReplacing: "Replacing",
        summaryStatusExplaining: "Explaining",
        summaryStatusAdjusted: "Adjusted",
        summaryStatusReplaced: "Replaced",
        summaryStatusError: "Summary error",
        summaryStatusNotifying: "Notification",
        summaryCreated: "Summary created successfully",
        summaryUpdated: "Summary updated successfully",
        summarySupplemented: "Summary supplemented successfully",
        summaryExcelUploaded: "Excel file uploaded successfully",
        summarySigned: "Summary signed successfully",
        summaryNotSelected: "No summary selected",
        summaryXmlUnavailable: "Unsigned summary has no XML",
        summaryDuplicateInvoice: "Invoice {{serial}} - {{number}} already exists",
        summaryDeleteBlocked: "A signed summary or a summary before the latest one cannot be deleted",
        summaryInvoiceTypeNd123: "Electronic invoice ND123",
        summaryInvoiceTypeQd1209: "Verified invoice QD1209",
        summaryInvoiceTypeNd51: "Invoice under Decree 51",
        summaryPaperInvoiceNd51: "Paper invoice under Decree 51",
        summary01Placeholder: "This function is temporarily hidden",
        periodToday: "Today",
        periodThisWeek: "This week",
        periodThisMonth: "This month",
        periodThisFiscalQuarter: "This quarter",
        periodThisFiscalYear: "This year",
        periodFirstSixMonths: "First six months",
        periodLastSixMonths: "Last six months",
        month1: "January",
        month2: "February",
        month3: "March",
        month4: "April",
        month5: "May",
        month6: "June",
        month7: "July",
        month8: "August",
        month9: "September",
        month10: "October",
        month11: "November",
        month12: "December",
        fiscalQuarter1: "Quarter I",
        fiscalQuarter2: "Quarter II",
        fiscalQuarter3: "Quarter III",
        fiscalQuarter4: "Quarter IV",
        periodLastWeek: "Last week",
        periodLastMonth: "Last month",
        periodLastFiscalQuarter: "Last quarter",
        periodLastFiscalYear: "Last year",
        vatInvoiceForm: "Value-added tax invoice",
        salesInvoiceForm: "Sales invoice",
        electronicTicketForm: "Electronic ticket/stamp/card",
        choosePeriod: "Select period",
        exportExcel: "Export Excel",
        invoiceProcessingTitle: "Invoices requiring action",
        invoiceProcessingDescription: "SENDING, WAITING FOR SIGNATURE, SIGNED (within the last month)",
        sending: "SENDING",
        waitingSignature: "WAITING FOR SIGNATURE",
        signed: "SIGNED",
        updatedAt: "Updated at {{date}}",
        invoiceListTitle: "Invoice list",
        invoiceListDescription: "Manage invoice creation, issuance, and processing",
        errorNoticeTitle: "Invoice error notice",
        errorNoticeDescription: "Notify the tax authority of incorrect electronic invoices using form 04/SS-HĐĐT",
        quickCreateTitle: "Quick invoice creation",
        creationDate: "Creation date",
        sendingCount: "SENDING quantity",
        waitingSignatureCount: "WAITING FOR SIGNATURE quantity",
        signedCount: "SIGNED quantity",
        quickAccess: "Quick access",
        createInvoice: "Create invoice",
        certificatesTitle: "Registered digital certificates",
        changeCertificate: "Change certificate on declaration",
        certificateIssuer: "Certificate issuer",
        certificateSerial: "Certificate serial",
        validFrom: "Valid from",
        expirationDate: "Expiration date",
        certificateStatus: "Status",
        valid: "Valid",
        expiringSoon: "Expiring soon",
        expired: "Expired",
        used: "Used",
        remaining: "remaining",
        pluginSignFailed: "Electronic signing failed",
        pluginCheckSteps: "Check the following cases to resolve the issue",
        pluginNotInstalled: "M-INVOICE Plugin is not installed",
        pluginInstallToContinue: "Install M-INVOICE Plugin to continue.",
        downloadInstaller: "Download installer",
        installGuide: "View installation guide",
        pluginInstalled: "M-INVOICE Plugin is installed",
        openPluginBeforeSigning: "Open M-INVOICE Plugin before signing electronically",
        openPlugin: "Open M-INVOICE Plugin",
      },
      error: {
        generic: "An error occurred. Please check the operation and try again",
        network: "Unable to connect to the system. Please try again later.",
      },
      templatePreview: {
        electronicInvoiceTemplate: "Electronic invoice template",
        convertedInvoiceTemplate: "Converted invoice template",
        preview: "Preview",
        template: "Invoice template",
        zoomIn: "Zoom in",
        zoomOut: "Zoom out",
        fitToScreen: "Fit to screen",
        alignByTitle: "Align to title",
        alignByLongestTitle: "Align to longest title",
        alignByLongestTitleColon: "Align to longest title including :",
        alignBuyerSeller: "Align buyer and seller to longest title including :",
        width: "Width",
        addField: "Add field",
        removeField: "Remove field",
        bold: "Bold",
        italic: "Italic",
        underline: "Underline",
        letterSpacing: "Letter spacing",
        chooseField: "Select display field",
        editContentHint: "Select an invoice information group to edit its content",
        noGeneralConfig: "No configuration has been selected in the General information tab.",
      },
    },
  },
  zh: {
    translation: {
      common: {
        appName: "M-Invoice",
        language: "语言",
        vietnamese: "越南语",
        english: "英语",
        chinese: "中文",
        japanese: "日语",
        korean: "韩语",
        tokenUsb: "USB令牌",
        tokenFileCa: "FILE CA",
        tokenServiceEasyCa: "EASYCA服务",
        tokenServiceNcca: "NCCA服务",
        tokenServiceIca: "I-CA服务",
        tokenServiceIntrustCa: "Intrust-CA服务",
        close: "关闭",
        cancel: "取消",
        save: "保存",
        update: "更新",
        create: "新建",
        edit: "编辑",
        detail: "详情",
        delete: "删除",
        confirm: "确认",
        reject: "否",
        yes: "是",
        no: "否",
        back: "返回",
        search: "搜索",
        filter: "筛选",
        clear: "清除筛选",
        reset: "重置",
        refresh: "刷新",
        export: "导出",
        import: "导入",
        download: "下载",
        upload: "上传",
        copy: "复制",
        importExcel: "从Excel导入",
        exportExcel: "导出到Excel",
        fileRequired: "请选择文件。",
        chooseFile: "选择文件",
        downloadTemplate: "下载模板",
        receiveFile: "接收文件",
        more: "更多",
        actions: "操作",
        functions: "功能",
        statement: "协议",
        symbol: "符号",
        invoiceNo: "发票号码",
        invoiceDate: "发票日期",
        today: "今天",
        yesterday: "昨天",
        status: "状态",
        receive: "应用",
        all: "- 全部 -",
        currentPageReport: "第 {first} - {last} 条，共 {totalRecords} 条",
        configuration: "配置",
        languageCustomization: "语言设置",
        bilingualVietnameseEnglish: "越南语-英语双语",
        signCustomization: "签名设置",
        signImmediately: "立即签署发票并发送至税务机关",
        signSummaryAtPeriodEnd: "期末签署发票并发送汇总表",
        colorCustomization: "颜色设置",
        fontCustomization: "字体设置",
        buyerCustomization: "购买方设置",
        tableCustomization: "表格设置",
        tableRowBorders: "表格显示行边框",
        blankRows: "空白行",
        emailInvoice: "发送发票邮件",
        pendingApproval: "等待批准",
        waitingSignature: "等待签名",
        signed: "已签名",
        sending: "发送中",
        signing: "签名中",
        invoiceListType: "清单类型",
        taxAuthoritySendStatus: "税务机关发送状态",
        invoiceListTemplateSymbol: "清单模板符号",
        adjustmentReplacementDate: "调整/替换发票日期",
        buyerLegalName: "购买方名称",
        invoiceListPrintSelectionRequired: "请先选择清单后再查看/打印",
        invoiceListPrintPreview: "查看/打印清单",
        invoiceList: "清单",
        createInvoice: "创建发票",
        createdBy: "创建人",
        discountInvoiceList: "调整发票",
        understood: "知道了",
        step: "步骤{{number}}：",
        month: "月",
        year: "年",
        statementList: "清单",
        createInvoiceList: "创建清单",
        // Bổ sung bản dịch cho lựa chọn trong/ngoài khu phi thuế quan.
        inside: "内部",
        outside: "外部",
        // Bổ sung bản dịch cho tiêu đề xử lý nhiều hóa đơn trong namespace common.
        multipleInvoiceReplacement: "替换多张发票",
        multipleInvoiceAdjustment: "调整多张发票",
        createMultipleReplacementInvoice: "创建多张替换发票",
        createMultipleAdjustmentInvoice: "创建多张调整发票",
        printStatement: "打印协议",
        logoBackground: "标志-背景",
        detailCustomization: "明细设置",
        saveInfo: "保存信息",
        noData: "暂无数据",
        productServiceName: "商品及服务名称",
        vatRate: "增值税税率",
        taxAmount: "增值税额",
        otherAmount: "其他金额",
        totalAfterTax: "含税金额",
        serialNumberShort: "序号",
        invoiceNumber: "发票号码",
        invoiceSymbol: "发票符号",
        invoiceNature: "发票性质",
        beforeReplacementInfo: "替换前信息",
        beforeAdjustmentInfo: "调整前信息",
        afterReplacementInfo: "替换后信息",
        afterAdjustmentInfo: "调整后信息（请输入正确的发票信息，用于计算差额）",
        difference: "差额",
        invoiceListSelectionLimit: "每张清单最多可包含{{count}}张发票。",
        invoiceListItemsLoadFailed: "清单发票加载失败！",
        invoiceListLoadFailed: "清单信息加载失败！",
        invoiceInfoLoadFailed: "发票信息加载失败！",
        invoiceListCreated: "清单创建成功！",
        invoiceListUpdated: "清单更新成功！",
        invoiceListTitle: "清单",
        invoiceListViewTitle: "查看清单",
        invoiceListSymbol: "清单符号",
        buyerNameRequired: "请输入购买方名称或购买方姓名",
        invoiceListItemsRequired: "清单不能为空",
        saveAndCreateInvoice: "保存并创建发票",
        deleteInvoiceRowWithShortcut: "删除行（F8）",
        deleteNoDifferenceRows: "删除所有无差额行",
        consumerBuyer: "消费者",
        cityPrefix: "城市",
        provincePrefix: "省",
        saveAndPrint: "保存并查看/打印",
        saveAndContinue: "保存并继续创建",
        continueSignQuestion: "是否继续签署并发送？",
        itemListFieldRequired: "商品明细：{{field}}为必填项",
        itemListEmpty: "商品明细为空",
        saveFailed: "信息保存失败，请重试。",
        afterConfirmation: "确认后，系统将：",
        saveInvoiceQuestion: "确定要保存此发票吗？",
        supportChatCaption: "M-invoice客服",
        supportChatTagline: "我们随时为您提供帮助，通常在5分钟内回复",
        supportChatGreeting: "请填写完整信息，以便M-invoice更好地为您服务 :wave:",
        statementNumber: "协议编号",
        todayDate: "今天，日期",
        seller: "甲方（销售方）",
        buyer: "乙方（购买方）",
        address: "地址",
        phone: "电话",
        representative: "代表",
        position: "职务",
        parties: "双方包括：",
        cancelled: "取消",
        replacement: "替换",
        adjustment: "调整",
        statusAdjustment: "调整",
        statusReplacement: "替换",
        statusAdjusted: "已调整",
        statusReplaced: "已替换",
        reason: "原因",
        statementCreate: "创建协议",
        statementCreated: "协议已创建",
        statementTitle: "{{action}}发票协议",
        statementToday: "今天，即{{day}}/{{month}}/{{year}}，双方包括：",
        republicTitle: "越南社会主义共和国",
        nationalMotto: "独立-自由-幸福",
        householdTaxOrCitizenId: "个体户税号/公民身份证号",
        logo: "标志",
        attachment: "附件",
        printInvoice: "打印发票",
        saveAndSign: "保存并签名",
        sendForSignature: "发送发票给购买方签名",
        representativeSeller: "甲方代表",
        representativeBuyer: "乙方代表",
        digitalSignature: "（数字签名、电子签名）",
        signatureValid: "签名有效",
        signedBy: "签名人：",
        signedDate: "签名日期：",
        addLine: "新增行",
        deleteLine: "删除行",
        copyLine: "复制行",
        insertLine: "插入行",
        chooseProduct: "选择商品",
        receiveExcelDetail: "从Excel导入明细",
        selectReplacementProduct: "选择需要替换的商品",
        itemCode: "商品编码",
        code: "编码",
        itemName: "商品名称",
        quantity: "数量",
        unitPrice: "单价",
        amount: "金额",
        totalRecords: "共{{count}}条记录",
        printView: "查看/打印",
        sendEmail: "发送邮件",
        downloadInvoicePdf: "下载发票PDF",
        bulkSign: "批量签署发票",
        relatedStatement: "相关协议",
        invoiceHistory: "发票历史",
        senderEmail: "发件人邮箱",
        customerEmail: "客户邮箱",
        subject: "主题",
        enterCustomerEmail: "请输入客户邮箱",
        reviewEmail: "查看完整邮件内容",
        paymentNotification: "付款通知",
        paymentHistory: "付款历史",
        transactionId: "交易编号",
        paidAmount: "已付金额",
        paymentTime: "付款时间",
        paymentStatus: "付款状态",
        content: "内容",
        field: "字段",
        uploadPdf: "上传PDF文件",
        attachStatement: "附加协议",
        fromDate: "开始日期",
        toDate: "结束日期",
        buyerName: "销售方/购买方名称",
        taxAuthorityCode: "税务机关编码",
        selectInvoice: "选择发票",
        invoicePaymentHistory: "发票付款历史",
        qrPaymentHistory: "二维码付款历史",
        error: "错误",
        registeredAssetInvoiceAdjustmentWarning: "根据第91/2026/TT-BTC号通知，销售需要登记所有权或使用权的资产时，只能开具替换发票。是否切换为开具替换发票？",
        replaceInvoice: "替换发票",
        continueAdjustment: "继续调整",
        warning: "警告",
      },
      declarationGuidance: {
        authDirectTitle: "在税务机关直接验证指南",
        authDirectSubject: "法定代表人为不符合在eTax Mobile应用上进行生物识别验证条件的外国人，或税务机关要求直接验证的特殊情况。",
        authDirectDeadline: "在收到直接验证通知后的工作日内，最迟不超过下一个工作日完成。",
        authDirectDocumentId: "公民身份证或护照原件。",
        authDirectDocumentPortrait: "肖像照片复印件。",
        authDirectDocumentNotice: "系统中等待验证的通知或申报打印件（如有）。",
        authDirectSteps: "纳税人前往直接管理企业的税务机关，出示公民身份证或护照原件及肖像照片，并按税务机关要求完成生物识别验证。",
        authBiometricTitle: "生物识别验证指南 - eTax Mobile",
        authBiometricSubjectFirst: "首次登记使用电子发票，或",
        authBiometricSubjectSecond: "变更法定代表人信息的情况。",
        authBiometricDeadline: "在收到生物识别验证通知后的工作日内，最迟不超过下一个工作日完成。",
        authOtpTitle: "OTP验证指南 - eTax Mobile",
        authOtpSubject: "变更纳税人信息、申报或发票签名数字证书、主管税务机关、发票形式、电子发票数据提交方式或发票类型等电子发票信息，但不变更法定代表人信息的情况。",
        authOtpDeadline: "在收到OTP验证通知后的工作日内，最迟不超过下一个工作日完成。",
        mobileSteps: "打开eTax Mobile应用并按照指南完成验证",
        explanationTitle: "高风险发票说明指南",
        explanationSubjectFirst: "企业变更法定代表人，新代表人的公民身份证/VNeID数据不一致，或在原企业有欠税、税务违规记录。",
        explanationSubjectSecond: "企业将总部变更至虚拟地址、禁止经营的住宅楼，或与逃逸企业相同的地址。",
        explanationSubjectThird: "新成立或重新营业的贸易、批发、物流企业存在虚假注册资本或缺少仓储设施。",
        explanationDeadline: "在收到说明通知后的工作日内，最迟不超过下一个工作日完成。",
        explanationStepFirst: "查看税务机关的详细通知，确认需要说明的原因和风险代码。",
        explanationStepSecond: "准备证明材料，例如公民身份证、企业登记证、办公室租赁合同和办公地点照片。",
        explanationStepThird: "准备说明公文，并通过eTax在线提交或直接向税务机关提交相关材料。",
        commonNote: "验证后，税务机关将继续检查纳税人信息，并在需要补充资料时进行回复。",
        qrUnavailable: "无法加载二维码",
        qrAlt: "在{{storeName}}下载eTax Mobile的二维码",
        openStore: "打开{{storeName}}下载eTax Mobile",
        fallbackTitle: "指南",
        close: "关闭指南",
        subject: "执行对象",
        deadline: "执行时间",
        documents: "准备材料",
        method: "执行方式",
        openGuide: "此处",
        qrCaption: "扫描下载eTax Mobile应用",
      },
      auth: {
        username: "用户名",
        password: "密码",
        rememberMe: "记住我",
        login: "登录",
        forgotPassword: "忘记密码？",
        registerPrompt: "还没有账户？",
        register: "注册",
        loginTitle: "登录",
        forgotPasswordTitle: "忘记密码",
        email: "邮箱",
        send: "发送",
        resetPassword: "重置密码",
        forgotPasswordSuccess: "密码重置请求已发送。",
        forgotPasswordSuccessEmail: "请查看邮箱后继续。",
        forgotPasswordSuccessToken: "请检查USB令牌后继续。",
        recoverByEmailSuccess: "新密码已发送至您的邮箱，请使用新密码登录。",
        recoverByTokenSuccess: "密码已更改，请使用新密码登录。",
        backToLogin: "返回登录",
        signStatementTitle: "确认协议签名",
      },
      menu: {
        invoice: "发票",
        issue: "开具",
        history: "传输历史",
        errors: "错误处理",
        reports: "报表",
        catalog: "目录",
        system: "系统",
        configuration: "配置",
        languageCustomization: "语言设置",
        issueRegistration: "开具登记",
        declaration123: "登记/变更申报NĐ123/2020",
        declaration70: "登记/变更申报NĐ70/2025-NĐ254/2026",
        outputInvoice: "销项发票",
        errorNotification: "发票错误通知",
        invoiceReplacement: "替换发票",
        invoiceAdjustment: "调整发票",
        invoiceCancellation: "取消发票",
        otherInvoiceReplacement: "替换其他系统中的发票",
        otherInvoiceAdjustment: "调整其他系统中的发票",
        multipleInvoiceReplacement: "替换多张发票",
        multipleInvoiceAdjustment: "调整多张发票",
        invoiceList: "发票清单",
        invoiceDiscountList: "折扣发票清单",
        declaration: "登记申报",
        paymentHistory: "二维码付款历史",
        usageReport: "发票使用情况报表",
        invoiceSummaryReport: "发票汇总报表",
        invoiceDetailReport: "发票明细报表",
        pmktReport: "会计软件接收报表",
        plReport: "PL101/2023/QH15报表",
        salesReport: "销项发票清单报表（PL01）",
        petrolReport: "石油税务报表",
        summary01Report: "创建发票汇总表01/TH-HĐĐT",
        mstStatus: "税号状态检查",
        bank: "银行",
        businessLocation: "经营地点",
        petrolManagement: "石油管理",
        petrolStore: "加油站",
        petrolProduct: "石油产品",
        pump: "加油机",
        integratedDevices: "集成设备目录",
        petrolTransactions: "石油交易",
        petrolInvoiceConfig: "石油发票配置",
        companyManagement: "企业管理",
        companyInfo: "企业信息",
        license: "许可证",
        userManagement: "用户管理",
        digitalCertificateRegistration: "数字证书登记",
        systemParameterDeclaration: "系统参数申报",
        invoiceConfiguration: "发票配置",
        valueReplacement: "替换值",
        defaultValue: "默认值",
        invoiceTemplateManagement: "发票模板管理",
      },
      validation: {
        required: "{{field}}为必填项",
        multiInvoiceCashRegisterRestricted: "税务机关仅允许{{actionName}}多张有代码和无代码发票",
        multiInvoiceRegisteredAssetRestricted: "税务机关尚不支持车辆购销发票的此项业务",
        invalid: "{{field}}无效",
        businessLocationCodeLengthHouseholdOrBranch: "经营地点代码（个体经营/经营分支机构）不得超过5个字符",
        businessLocationCodeLengthPetrolBusiness: "经营地点代码（石油经营企业）不得超过14个字符",
        monthRange: "月份必须在1至12之间",
        quarterRange: "季度必须在1至4之间",
        yearFormat: "年份必须为四位整数",
        fromDateInvalid: "开始日期条件无效",
        toDateInvalid: "结束日期条件无效",
        dateRangeOrder: "开始日期必须早于或等于结束日期",
        dateRangeRequired: "开始日期和结束日期为必填项。",
        operatorRequired: "{{field}}的操作符为必填项。",
        invoiceStatusConditionInvalid: "发票创建状态条件无效。",
        selectTransaction: "未选择交易。",
        invoiceAlreadyCreated: "该记录已有发票，不能重复创建",
        invoiceCreationFailed: "该记录创建发票失败，不能再次创建",
        invoiceCancelledCannotCreate: "该记录已取消，不能创建发票",
        noData: "未找到数据。",
        containsCreatedInvoice: "所选记录中包含已有发票的记录，请检查",
        containsUncreatedInvoice: "所选记录中包含尚未创建发票的记录，请检查",
        selectMultipleTransactions: "请先选择多条记录，再合并交易日志",
        cancelledCannotEdit: "已取消的交易不能编辑。",
        positiveDifferenceOnly: "只能选择差额为正的交易。",
        alreadyCompensated: "该交易已经补偿。",
        cannotCancelInvoiced: "已开具发票的交易不能取消。",
        alreadyCancelled: "该交易已经取消。",
        createInvoiceQuestion: "是否为这些记录创建发票？",
        groupTransactionQuestion: "是否合并所选交易？",
        updateInvoiceNumberQuestion: "确认更新{{count}}笔交易的发票号码",
        selectDevice: "请先选择设备再编辑",
        selectProduct: "请先选择商品再编辑",
        selectProductForTaxChange: "请先选择商品再更改税率",
        selectCustomer: "未选择客户",
        chooseStore: "请选择门店",
        enterSecurityCode: "请输入安全码",
        pecoDeviceIdMissing: "在 DOI_GIA_TU_PECO 配置中未找到所选门店的有效 DeviceId。",
        pecoPriceUpdateFailed: "无法向 PECO 柜发送价格更新请求。",
        taxStatusNotFound: "未找到税务信息",
        codeChars: "仅允许使用字母、数字、连字符（-）和下划线（_）。",
        taxCodeInvalid: "税号错误",
        emailInvalid: "邮箱无效",
        passwordRequired: "密码为必填项",
        relatedInvoiceDateCannotBeFuture: "关联发票日期不能晚于今天",
        wrongInvoiceLine: "第{{line}}行：{{message}}",
      },
      invoice: {
        electronicInvoiceSolution: "电子发票解决方案",
        invoice: "发票",
        printInvoice: "打印发票",
        downloadPdf: "下载PDF",
        signToTaxAuthority: "签署并发送至税务机关",
        printSwitch: "打印转换发票",
        invoiceNumber: "发票号码",
        invoiceSymbol: "发票符号",
        seller: "销售方",
        buyer: "购买方",
        lineItems: "商品及服务",
        payment: "付款",
        signAndSend: "签署并发送至税务机关",
      },
      catalog: {
        unit: "单位",
        product: "商品及服务",
        customer: "客户",
        currency: "货币",
        paymentMethod: "付款方式",
        taxRate: "税率",
        businessLocation: "经营地点",
        businessLocationType: "经营类型",
        businessLocationTypeHouseholdOrBranch: "个体经营/经营分支机构",
        businessLocationTypePetrolBusiness: "石油经营企业",
        businessLocationCode: "经营地点编码",
        businessLocationName: "经营地点名称",
        businessLocationAddress: "经营地点地址",
        businessLocationHint: "请为此发票代码声明经营地点",
        petrolStoreCode: "门店编码",
        petrolStoreName: "门店名称",
        petrolStoreAddress: "门店地址",
        oldPrice: "旧价格",
        newUnitPrice: "新单价",
        priceChangeHistory: "价格调整历史",
        pumpNozzleCode: "加油机编码",
        fuel: "燃油",
        fuelCodeAtPump: "加油机燃油编码",
        fuelAtPump: "加油机燃油",
        pumpSeries: "加油机序列号",
        effectiveTime: "生效时间",
        expiryTime: "失效时间",
        chooseStore: "选择门店",
        securityCode: "安全码",
        newPrice: "新价格",
        deviceCode: "设备编码",
        deviceName: "设备名称",
        integrationSymbol: "符号",
        integrationType: "集成类型",
        currencyCode: "货币代码",
        currencyName: "货币名称",
        integratedDeviceCatalog: "集成设备目录",
        productCode: "商品编码",
        productName: "商品名称",
        listedPrice: "标价",
        listedPriceWithVat: "含增值税标价",
        invoicePrice: "发票销售价",
        priceList: "价格表",
        paymentCode: "付款代码",
        paymentName: "付款名称",
        emailTemplate: "邮件模板",
        emailSubject: "主题",
        emailUsage: "使用中",
        beneficiaryBank: "受益银行",
        accountNumber: "账号",
        accountName: "账户名称",
        saleDateTime: "销售日期时间",
        storeCode: "门店编码",
        pumpCode: "加油机编码",
        petrolTransactionList: "石油交易清单",
        qrCodePaymentLabel: "二维码付款",
        errorName: "错误名称",
        integrationKey: "集成密钥",
        reportType: "报表类型",
        detailTransactionReport: "交易明细报表",
        summaryTransactionReport: "交易汇总报表",
        store: "门店",
        pump: "加油机",
        staffCode: "员工编码",
        invoiceCreationStatus: "发票创建状态",
        invoiceCreationStatusShort: "发票创建状态",
        customerTaxCode: "客户税号",
        customerPhone: "客户电话号码",
        notCreated: "未创建",
        created: "已创建",
        createError: "创建错误",
        cancelled: "已取消",
        unpaid: "未付款",
        paid: "已付款",
      },
      system: {
        company: "企业",
        companyName: "企业名称",
        serial: "序列号",
        licenseQuantity: "许可证数量",
        product: "产品",
        issueDate: "签发日期",
        startDate: "开始日期",
        expiryDate: "到期日期",
        permissionGroupName: "权限组名称",
        users: "用户",
        permissionGroups: "权限组",
        digitalCertificate: "数字证书",
        systemParameters: "系统参数",
        emailServer: "邮件服务器配置",
        formulaType: "计算方式",
        formula: "公式",
        addFormula: "添加公式",
        formulaConfig: "公式配置",
        selectCalculation: "选择计算方式",
        dataArea: "数据区域",
        numericValues: "数值",
        operation: "操作",
        value: "值",
        resetFormula: "重置",
        testFormula: "测试公式",
        calculate: "计算",
        invalidFormula: "公式无效",
        testFormulaHeader: "测试公式",
        permissionDialog: "权限",
        signingMethod: "签名方式",
        signSummary: "使用汇总表签名",
        signNowTaxAuthority: "立即签名发送至税务机关",
        identityCode: "税务机关编码",
        province: "省",
        bankAccount: "银行账号",
        bankName: "银行",
        legalRepresentative: "法定代表人",
        legalRepresentativePhone: "法定代表人电话",
        contactSection: "联系信息",
        changeHistory: "变更历史",
        modifiedBy: "修改人",
        modifiedDate: "修改日期",
        data: "数据",
        viewChangeHistory: "查看变更历史",
        permissions: "权限",
        default: "默认",
        condition: "条件",
        syncType: "同步类型",
        startTime: "开始时间",
        endTime: "结束时间",
        defaultEndTime: "23:59:59（默认）",
        fieldName: "字段名称",
        creationTime: "发票创建时间",
        autoSignConditionTitle: "条件",
        autoSignEndTimeBeforeStart: "结束时间不能早于开始时间。",
        autoSignConditionIncomplete: "请完整填写已使用行的字段、条件和值。",
        autoSignCreationTimeInvalid: "发票创建时间须使用 HH:mm:ss 格式，范围为 00:00:00 至 23:59:59。",
        autoSignInvoiceDateInvalid: "发票日期只能选择今天或昨天。",
        autoSignTimeOverlap: "该时间范围与同一发票代码的其他自动签名任务重叠。",
        emailServerConfig: "邮件服务器配置",
        alias: "别名",
        displayAddress: "显示地址",
        smtpHost: "SMTP主机",
        smtpPort: "SMTP端口",
        sslAuthentication: "SSL身份验证",
        defaultLogin: "默认登录",
        invoiceConfig: "发票配置",
        configCode: "配置代码",
        invoiceType: "发票类型",
        exit: "退出",
      },
      report: {
        report: "报表",
        filters: "筛选条件",
        summary: "汇总表",
        day: "日",
        month: "月",
        quarter: "季度",
        submissionCount: "提交次数",
        firstSubmission: "首次提交",
        supplementarySubmission: "补充提交",
        dataPeriod: "数据期间",
        monthOrQuarter: "月或季度",
        year: "年",
        summaryNumber: "汇总表编号",
        supplementCount: "补充次数",
        currencyUnit: "货币单位",
        createdBy: "创建人",
        signDateTime: "签名日期时间",
        summaryDetails: "汇总表明细",
        summaryTransferHistory: "传输历史",
        summaryLookup: "选择加入汇总表的发票",
        summaryUpdateAction: "更新",
        summarySupplementAction: "补充",
        summaryInvoiceSerialPlaceholder: "选择发票符号",
        goodsType: "商品类型",
        otherGoods: "其他",
        flightGoods: "航空运输",
        currencyCode: "货币代码",
        multipleTax: "一张发票使用多种税率",
        invoiceNumberShort: "号码",
        summaryPeriodPlaceholder: "月或季度",
        accountingSoftware: "会计软件",
        productNameWithService: "商品及服务名称",
        amountBeforeTax: "未税金额",
        vatRateByRegulation: "按规定适用的增值税税率",
        vatRateAfterReduction: "减免20%后的增值税税率",
        vatReductionAmount: "减免的增值税额",
        petrolStoreCode: "加油站编号",
        pumpColumnCount: "加油机列数",
        quantitySold: "销售数量",
        issuedInvoiceQuantity: "已开具发票数量",
        petrolRevenue: "石油产品销售收入",
        totalCount: "总数",
        retailCustomerCount: "其中：零售客户",
        successfulInvoiceStatus: "发票发送成功状态",
        successfulInvoiceCount: "成功发送的发票总数",
        failedInvoiceCount: "发送失败的发票总数",
        usedInvoiceCount: "已使用发票总数",
        totalAfterTax: "含税金额",
        signDate: "签名日期",
        relatedInvoiceType: "关联发票类型",
        relatedInvoiceTemplateNumber: "关联发票模板编号",
        relatedInvoiceSymbol: "关联发票符号",
        relatedInvoiceNumber: "关联发票号码",
        adjustmentPeriodType: "调整数据期间类型",
        adjustmentPeriod: "调整数据期间",
        summaryStatusOrigin: "原始",
        summaryStatusRefused: "已取消",
        summaryStatusAdjusting: "调整中",
        summaryStatusReplacing: "替换中",
        summaryStatusExplaining: "说明中",
        summaryStatusAdjusted: "已调整",
        summaryStatusReplaced: "已替换",
        summaryStatusError: "汇总错误",
        summaryStatusNotifying: "通知中",
        summaryCreated: "汇总表创建成功",
        summaryUpdated: "汇总表更新成功",
        summarySupplemented: "汇总表补充成功",
        summaryExcelUploaded: "Excel文件上传成功",
        summarySigned: "汇总表签名成功",
        summaryNotSelected: "未选择汇总表",
        summaryXmlUnavailable: "未签名汇总表没有XML文件",
        summary01Placeholder: "此功能暂时隐藏",
        periodToday: "今天",
        periodThisWeek: "本周",
        periodThisMonth: "本月",
        periodThisFiscalQuarter: "本季度",
        periodThisFiscalYear: "本财年",
        periodFirstSixMonths: "前六个月",
        periodLastSixMonths: "后六个月",
        month1: "一月",
        month2: "二月",
        month3: "三月",
        month4: "四月",
        month5: "五月",
        month6: "六月",
        month7: "七月",
        month8: "八月",
        month9: "九月",
        month10: "十月",
        month11: "十一月",
        month12: "十二月",
        fiscalQuarter1: "第一季度",
        fiscalQuarter2: "第二季度",
        fiscalQuarter3: "第三季度",
        fiscalQuarter4: "第四季度",
        periodLastWeek: "上周",
        periodLastMonth: "上月",
        periodLastFiscalQuarter: "上季度",
        periodLastFiscalYear: "上财年",
        vatInvoiceForm: "增值税发票",
        salesInvoiceForm: "销售发票",
        electronicTicketForm: "电子票/卡",
        choosePeriod: "选择期间",
        exportExcel: "导出Excel",
        invoiceProcessingTitle: "待处理发票",
        invoiceProcessingDescription: "发送中、等待签名、已签名（最近一个月）",
        sending: "发送中",
        waitingSignature: "等待签名",
        signed: "已签名",
        invoiceListTitle: "发票清单",
        invoiceListDescription: "管理发票创建、开具和处理",
        errorNoticeTitle: "发票错误通知",
        quickCreateTitle: "快速创建发票",
        creationDate: "创建日期",
        quickAccess: "快速访问",
        createInvoice: "创建发票",
        certificatesTitle: "已登记的数字证书",
        changeCertificate: "更改申报中的证书",
        certificateIssuer: "证书颁发者",
        certificateSerial: "证书序列号",
        validFrom: "生效日期",
        expirationDate: "到期日期",
        certificateStatus: "状态",
        valid: "有效",
        expiringSoon: "即将到期",
        expired: "已过期",
        used: "已使用",
        remaining: "剩余",
        pluginSignFailed: "电子签名失败",
        pluginCheckSteps: "请检查以下情况以解决问题",
        pluginNotInstalled: "尚未安装M-INVOICE Plugin",
        pluginInstallToContinue: "请安装M-INVOICE Plugin后继续。",
        downloadInstaller: "下载安装包",
        installGuide: "查看安装指南",
        pluginInstalled: "已安装M-INVOICE Plugin",
        openPluginBeforeSigning: "请在电子签名前打开M-INVOICE Plugin",
        openPlugin: "打开M-INVOICE Plugin",
      },
      error: {
        generic: "发生错误，请检查操作后重试",
        network: "无法连接系统，请稍后重试。",
      },
      templatePreview: {
        electronicInvoiceTemplate: "电子发票模板",
        convertedInvoiceTemplate: "转换发票模板",
        preview: "预览",
        template: "发票模板",
        zoomIn: "放大",
        zoomOut: "缩小",
        fitToScreen: "适合屏幕",
        alignByTitle: "按标题对齐",
        alignByLongestTitle: "按最长标题对齐",
        alignByLongestTitleColon: "按包含冒号的最长标题对齐",
        alignBuyerSeller: "购买方和销售方按包含冒号的最长标题对齐",
        width: "宽度",
        addField: "添加字段",
        removeField: "删除字段",
        bold: "粗体",
        italic: "斜体",
        underline: "下划线",
        letterSpacing: "字间距",
        chooseField: "选择显示字段",
        editContentHint: "选择发票信息组以编辑其内容",
        noGeneralConfig: "尚未在基本信息页签中选择配置。",
      },
    },
  },
} as const;

const chineseAdditionalTranslation = {
  common: {
    provinceCode: "省代码",
    wardCode: "乡代码",
    updateInvoiceNumber: "更新发票号码",
    qrPaymentNotRegistered: "尚未登记mQR付款",
    startRow: "起始行",
    enterTaxCode: "输入要查询的税号",
    searchMultipleTaxCodes: "查询多个税号",
    exportSearchResults: "将查询结果导出到Excel",
    transaction: "交易",
    compensateTransaction: "补偿交易",
    qrCodePayment: "二维码付款",
    groupTransactions: "合并交易",
    cancelReason: "取消原因",
    missing: "缺少",
    restoreTemplate: "恢复初始模板",
    restoreTemplateQuestion: "确定要恢复此发票模板吗？",
    consentConfirmTitle: "确认同意条款",
    consentRequiredQuestion: "保存前，受益银行账户必须同意共享余额变动。是否继续？",
    consentCheckFailed: "同意检查失败",
    consentLinkMissing: "没有可用的同意链接",
    equals: "等于",
    notEquals: "不等于",
    contains: "包含",
    startsWith: "开始于",
    endsWith: "结束于",
    containsList: "包含列表",
    notContains: "不包含",
    emptyValue: "为空",
    nonEmptyValue: "不为空",
    greaterThan: "大于",
    greaterThanOrEqual: "大于或等于",
    lessThan: "小于",
    lessThanOrEqual: "小于或等于",
    templatePrintRows: "模板打印行数",
    viewInvoiceTemplate: "查看发票模板",
    printConvertedInvoice: "打印转换发票",
    underlineBuyerValue: "购买方值加下划线",
    columnSymbolRows: "设置列符号行数",
    multiPageInvoiceRows: "多页发票行数",
    signatureLabelCustomization: "签名标签设置",
    headSignature: "负责人签名",
    htmlFormat: "HTML格式",
    logoFileSizeExceeded: "标志文件不能超过100KB",
    imageFileRequired: "文件必须是图片格式",
    logoDimensionExceeded: "标志尺寸超过限制。最大尺寸：{{width}}x{{height}}px",
    imageReadFailed: "无法读取图片文件",
    borderFileSizeExceeded: "上传文件不能超过300KB",
    borderDimensionExceeded: "边框尺寸超过建议限制：{{pageSize}}：{{width}} x {{height}}",
    backgroundFileSizeExceeded: "背景尺寸不能超过200KB",
    backgroundDimensionExceeded: "背景尺寸超过限制。最大尺寸：{{width}}x{{height}}px",
    useQrCode: "使用二维码",
    sizeCustomization: "尺寸设置",
    useLogo: "使用标志",
    chooseLogoFromComputer: "从电脑选择；最大100KB",
    maxDimension: "最大尺寸：（{{dimension}}）",
    useBackground: "使用背景",
    chooseImageFromComputer: "从电脑选择图片",
    chooseBackgroundFromLibrary: "从图库选择背景图片",
    chooseBackgroundFromComputer: "从电脑选择；最大200KB",
    opacity: "不透明度",
    useBorder: "使用边框",
    chooseBorderFromComputer: "从电脑选择；最大300KB",
    maxPageDimension: "{{pageSize}}最大尺寸：（{{width}}x{{height}}）",
    linkedInvoiceListEditBlocked: "已关联发票的清单不能编辑。",
    linkedInvoiceListDeleteBlocked: "已关联发票的清单不能删除。",
    businessLocationDeclarationGuide: "经营地点申报指南",
    declareBusinessLocations: "申报经营地点清单 →",
    assignBusinessLocationToSymbol: "将经营地点分配给发票符号 →",
    invoiceSymbolManagement: "发票符号管理",
    dateRangeSameMonthRequired: "请选择同一个月内的开始日期和结束日期。",
    toDateBeforeFromDate: "结束日期不能早于开始日期。",
    selectAtLeastOneInvoice: "请至少选择一张发票。",
    selectedInvoicesSameMonthRequired: "所选发票必须属于同一个月。",
    selectedInvoicesSameBuyerRequired: "所选发票必须具有相同的购买方法定名称/购买方姓名。",
    selectInvoiceForList: "选择发票加入清单",
    taxCodeSearchV2Failed: "税号查询失败（V2）。",
    taxCodeSearchFailed: "税号查询失败。",
    paymentTotalMismatch: "付款总额与未税金额加税额不一致。",
    paymentUnitPriceMismatch: "付款总额与数量乘以含增值税单价不一致。",
    exportForBusiness: "开具给企业",
    signTimeWarningNonCompliant: "以下发票不符合上述规定。",
    signTimeWarningLegalRule: "根据《发票内容》附录及第254/2026/NĐ-CP号法令第7条，发票数据最迟应在发票日期后的下一个工作日签署并发送至税务机关。",
    signTimeWarningInvoiceDetails: "正在签署的发票日期为{{date}}，符号为{{symbol}}，号码为{{number}}，不符合该规定。是否继续签署并发送？",
    discountSignTimeWarningLegalRule: "根据第254/2026/NĐ-CP号法令第1条第7款c项和第14款b项，发票数据最迟应在发票日期后的下一个工作日签署并发送至税务机关。",
    invoiceAmountMismatch: "第{{line}}行商品{{product}}的数量×单价与金额不一致；差额：{{difference}}",
    invoicePreTaxMismatch: "明细未税总额{{detail}}与表头未税总额{{header}}不一致；差额：{{difference}}",
    invoiceTotalMismatch: "未税总额{{beforeTax}}加税额{{tax}}与付款总额{{total}}不一致；差额：{{difference}}",
    commercialDiscountLegalNotice: "根据第91/2026/TT-BTC号通知第10条第5款b项，商业折扣按数量或收入确定时，必须附带包含发票、金额和调整税额的发票清单开具调整发票。清单应由单位保存，并在税务机关或其他有权国家机关要求时提供。",
    commercialDiscountStepsTitle: "创建商业折扣发票分为两步：",
    commercialDiscountStepOne: "第一步：创建包含符合折扣计划条件的发票清单。",
    commercialDiscountStepTwo: "第二步：创建与清单编号和日期关联的调整发票。",
    commercialDiscountLineNote: "（明细行性质为商品/服务，金额为正数。）",
    invoiceSaveBlockedSummary: "无法保存",
    businessLocationRequiredBeforeSave: "保存前请在（目录→经营地点）中申报并将经营地点分配给发票符号。",
    frameEngineRequiredForVehicle: "汽车或摩托车类别的特殊商品必须填写车架号和发动机号。",
    vehiclePlateRequiredForTransport: "运输服务类别的特殊商品必须填写车牌号。",
    senderInfoRequiredForDigitalTransport: "数字平台运输服务类别的特殊商品必须填写发货人姓名、地址、税号和公民身份证号。",
    invalidInvoiceIdForSigning: "未找到可签署的有效发票ID。",
    invoiceListAlreadyCreated: "清单已创建，不能再次创建发票。",
    cancelInvoiceSelectionRestriction: "只能取消已成功提交且处于原始或说明状态的发票。",
    updateInvoiceListStatus: "更新清单中发票的状态。",
    invoiceListLockedAfterConfirm: "清单不能编辑或删除。",
    deleteMultipleInvoiceToEditList: "如需以后编辑或删除清单，请删除多张调整/替换发票，以恢复清单中发票的状态。",
    citizenDataNotFound: "未找到公民身份证数据。",
    citizenSearchFailed: "公民身份证查询失败。",
    taxCodeNotFound: "未找到税号数据。",
    taxCodeV2NotFound: "未找到税号数据（V2）。",
    taxCodeFormatInvalid: "编码无效，请检查。",
    statementCancelSentence: "双方同意根据规定制作本协议，以撤回并取消表号{{form}}、符号{{serial}}、号码{{number}}、日期为{{date}}的发票。",
    statementMultipleSentence: "双方同意根据规定制作本协议，以确认错误并为多张错误发票开具{{action}}发票，同时附上编号为{{listNumber}}、日期为{{listDate}}的清单。",
    statementSingleSentence: "双方同意根据规定制作本协议，以确认错误并为表号{{form}}、符号{{serial}}、号码{{number}}、日期为{{date}}的发票开具{{action}}发票。",
    statementCommitment: "我们保证上述申报信息真实准确。如有任何错误，我们愿依法承担责任。",
    statementActionCommitment: "我们对该发票的{{action}}承担全部责任。",
    lawBasisDecree123: "依据政府于2020年10月19日发布的关于发票和凭证的第123/2020/NĐ-CP号法令。",
    lawBasisDecree70: "依据政府于2025年3月20日发布的修改、补充第123/2020/NĐ-CP号法令部分条款的第70/2025/NĐ-CP号法令。",
    lawBasisCircular32: "依据财政部于2025年5月31日发布的第32/2025/TT-BTC号通知，指导实施关于发票和凭证的第123/2020/NĐ-CP号法令及修改、补充该法令部分条款的第70/2025/NĐ-CP号法令。",
    lawBasisDecree254: "依据政府于2026年6月30日发布的第254/2026/NĐ-CP号法令，详细规定税收管理法第108/2025/QH15号关于电子发票和电子凭证的若干条款及实施措施。",
    lawBasisCircular91: "依据财政部于2026年6月30日发布的第91/2026/TT-BTC号通知，规定税收管理法第108/2025/QH15号及政府第254/2026/NĐ-CP号法令关于电子发票和电子凭证的若干条款及实施措施。",
    lawBasisAgreement: "依据双方之间的协议。",
    businessRegistrationInfo: "企业登记号{{number}}，由{{authority}}于{{date}}签发",
    branch: "分支机构",
    copyright: "版权所有©2025 {{company}}。保留所有权利。",
    emailStatementForSignature: "将协议通过邮件发送给购买方签名",
    registerAdjustmentInvoice: "创建调整发票",
    registerReplacementInvoice: "创建替换发票",
    selectSymbol: "选择符号",
    alias: "别名",
    emailFallback: "如果留空，系统将使用发票中已填写的邮箱",
    emailSeparator: "使用逗号（,）分隔邮箱地址",
    invoiceNoPayment: "此发票尚无二维码付款交易记录",
    qrNoPayment: "尚无二维码付款交易记录",
    pump: "加油机",
    store: "门店",
    time: "时间",
    notificationType: "通知类型",
    notificationNo: "通知编号",
    taxAuthorityNotificationNo: "税务机关通知编号",
    taxAuthorityNotificationDate: "税务机关通知日期",
    taxAuthorityReceiving: "接收税务机关",
    taxpayerName: "纳税人名称",
    placeOfCreation: "创建地点",
    appliedInvoiceType: "适用发票类型",
    noticeProperty: "通知性质",
    taxAuthorityIssuedCode: "税务机关编码",
    wrongInvoiceDeclaration: "申报错误发票信息",
    oldSymbol: "原符号",
    newSymbol: "新符号",
    changeInvoiceSerial: "更改发票符号",
    receiveExcel: "导入Excel",
    downloadXml: "下载XML",
    declarationType: "申报类型",
    contactEmail: "联系邮箱",
    contactPerson: "联系人",
    contactAddress: "联系地址",
    contactPhone: "联系电话",
    lookupCode: "查询码",
    sourceData: "数据来源",
    qrCreatedAmount: "二维码创建金额",
    paidTotal: "已付款总额",
    qrCreationTime: "二维码创建时间",
    qrPaymentTime: "二维码付款时间",
    lastModificationTime: "最后更新时间",
    selectDataSource: "请至少选择一个数据来源",
    selectQrCreationPeriod: "请选择二维码创建期间",
    noticeFromTaxpayer: "纳税人通知",
    noticeFromTaxAuthority: "根据税务机关通知发出的纳税人通知",
    invoiceTypeN123: "第123、70和254号法令规定的电子发票",
    verifiedInvoiceQd1209: "第1209号决定规定的验证发票",
    invoiceN51: "第51号法令规定的发票",
    preprintedInvoiceN123: "第123号法令规定的印制发票",
    manualInvoiceHint: "选择已有发票，或添加行手动录入其他供应商或第32号通知规定的发票",
    invoicesForErrorNotice: "需要向税务机关申报的发票：",
    signErrorNotice: "签署并发送04/SS-HĐĐT",
    restoreErrorNoticeStatusQuestion: "确定要将通知恢复为等待签名状态并重新发送至税务机关吗？",
    requestCode: "发票/加油日志编码",
    bankTransactionCode: "银行交易编码",
    invoiceInfoNotFound: "未找到发票信息",
    pumpLogInfoNotFound: "未找到加油日志信息",
    paymentFull: "已足额付款",
    paymentShort: "付款不足",
    paymentExcess: "超额付款",
    todayShort: "今天",
    daysUnit: "天",
    yearUnit: "年",
    days7: "7天",
    days30: "30天",
    days90: "90天",
    year1: "1年",
    customOption: "自定义",
    paymentPendingStatus: "付款处理中",
    paymentErrorStatus: "付款失败",
    paymentSuccessStatus: "付款成功",
    errorDescription: "错误描述",
    declarationDate: "申报日期",
    submissionStatus: "税务机关提交状态",
    taxAuthorityFeedback: "税务机关反馈",
    sender: "发送方",
    declarationRegister: "登记",
    declarationChange: "变更",
    notSubmitted: "未提交",
    submitted: "已提交",
    declarationSigned: "已签名",
    received: "已接收",
    notReceived: "未接收",
    accepted: "已接受",
    notAccepted: "未接受",
    explanation: "说明",
    discontinued: "已停用",
    nextStep: "下一步",
    nextStepVerifyAtTaxAuthority: "在税务机关直接验证信息",
    nextStepVerifyBiometric: "验证生物识别信息",
    nextStepVerifyOtp: "通过OTP验证信息",
    nextStepCreateNewDeclaration: "创建新申报",
    nextStepExplainRisk: "风险说明指南",
    nextStepCompleted: "已完成",
    nextStepSignAndSend: "请签名并发送至税务机关",
    nextStepWaitForResponse: "等待税务机关回复",
    nextStepPreliminaryChecking: "税务机关正在对申报进行初步检查",
    taxAuthorityFeedbackPending: "尚未回复",
    viewNextStepGuidance: "查看信息验证指南",
    cloneRejectedDeclaration: "根据被拒申报创建新申报",
    declarationGuidanceLoadFailed: "无法加载指南，请稍后重试。",
    declarationCloneLoadFailed: "无法加载被拒申报，请稍后重试。",
    invoiceForm: "发票形式",
    requiredFieldsMessage: "请填写所有必填字段",
    taxAuthorityConnectionFailed: "暂时无法连接税务机关，请保存草稿或稍后重试。",
    decree123Text: "根据政府2020年10月19日颁布的第123/2020/NĐ-CP号法令，我们/我属于电子发票使用对象。我们/我向税务机关登记或变更电子发票使用信息如下：",
    decree254Text: "根据政府2026年6月30日颁布的第254/2026/NĐ-CP号法令，我们/我属于电子发票使用对象。我们/我向税务机关登记或变更电子发票使用信息如下：",
    acceptanceTime: "接受时间",
    acceptanceFile: "税务机关PDF或XML文件",
    uploadAcceptanceFile: "上传接受文件",
    declarationTransferHistory: "申报传输历史",
    declarationFormTitle: "申报",
    declarationFormSubtitle: "登记/变更电子发票使用信息",
    declarationRegisterNew: "新登记",
    declarationChangeInfo: "变更信息",
    managedTaxAuthority: "主管税务机关",
    legalRepresentativeName: "法定代表人姓名",
    passportLabel: "护照",
    dateOfBirth: "出生日期",
    gender: "性别",
    female: "女",
    male: "男",
    legalRepresentativeNotice: "法定代表人信息用于税务机关软件系统中的生物识别认证",
    acceptedDeclarationNotice: "申报被接受后，税务机关将向此邮箱/电话号码/地址发送重要的电子发票通知。",
    invoiceFormSection: "1. 发票形式：",
    invoiceDataSendingSection: "2. 电子发票数据提交方式：",
    skipIfNotApplicable: "如不适用以下任何情况，请跳过此部分。",
    codedInvoiceWithoutServiceFeeCase: "a. 根据法令第14条第1款使用免服务费的有代码电子发票：",
    noCodeInvoiceCase: "b. 使用无税务机关代码的电子发票：",
    dataTransferMethodSection: "3. 电子发票数据传输方式：",
    invoiceTypeUseSection: "4. 使用的发票类型",
    certificateUseSection: "5. 使用的数字证书",
    serviceProviderSection: "6. 服务提供机构",
    receivingUnitSection: "7. 接收单位信息",
    dependentUnitSection: "8. 需要查询权限的附属会计单位信息",
    suspensionRequestSection: "9. 暂停使用电子发票申请",
    invoiceWithTaxCode: "税务机关赋码",
    invoiceWithCashRegister: "税务机关赋码（由收银机创建）",
    invoiceWithoutTaxCode: "税务机关不赋码",
    difficultAreaBusiness: "在社会经济条件困难或特别困难地区经营的中小企业、合作社、家庭和个体企业。",
    otherSmallBusiness: "省人民委员会向财政部推荐的其他中小企业，不包括在经济区、工业园区和高科技园区经营的企业。",
    publicAssetAuthority: "根据公共资产管理和使用规定负责组织和处理公共资产的税务机关或机构",
    viaInvoiceProvider: "通过电子发票服务提供商传输（法令第22条第3款b2项）。",
    directToTaxAuthority: "直接向税务机关传输电子发票数据（法令第22条第3款b1项）。",
    fullInvoiceContent: "传输每张发票的完整内容。",
    summaryInvoiceData: "按照电子发票数据汇总表传输（法令第22条第3款a1项）。",
    vatInvoice: "增值税发票",
    salesInvoice: "销售发票",
    publicAssetInvoice: "公共资产销售发票",
    nationalReserveInvoice: "国家储备商品销售发票",
    otherInvoiceTypes: "其他发票类型",
    managedDocumentsAsInvoice: "作为发票打印、开具、使用和管理的凭证",
    integratedVatReceipt: "与税费征收收据合并的增值税发票",
    integratedSalesReceipt: "与税费征收收据合并的销售发票",
    commercialInvoice: "商业发票",
    legacyOtherInvoiceTypes: "其他发票类型：印花、票据和电子卡",
    legacyManagedDocumentsAsInvoice: "作为发票打印、开具、使用和管理的凭证：内部仓库出库单、运输单和寄售仓库出库单",
    retrieveSuccessMessageQuestion: "确定要重新获取成功消息吗？",
    restoreSuccess: "状态恢复成功",
    retrieveSuccess: "获取成功",
    reloadSuccess: "重新加载成功",
    execute: "执行",
    check: "检查",
    transactionInfo: "交易信息",
    invoiceTransferHistory: "发票传输历史",
    invoiceEmailHistory: "邮件发送历史",
    checkEmailHistory: "检查邮件发送历史",
    sentDate: "发送日期",
    sentStatus: "发送状态",
    viewed: "已查看",
    notViewed: "未查看",
    emailRecipientPlaceholder: "发送前请输入收件人邮箱",
    emailRequired: "邮箱地址为必填项",
    emailInvalidAtIndex: "第{{index}}个邮箱无效",
    invoiceHeader: "发票",
    invoiceTypeApplied: "适用发票类型",
    noticeType: "通知类型",
    noticeNumber: "通知编号",
    noticeDate: "通知日期",
    taxAuthority: "税务机关",
    taxPayer: "纳税人",
    creationPlace: "创建地点",
    invoiceReason: "错误原因",
    sampleNumber: "表号",
    invoiceProperty: "发票性质",
    statementHistory: "协议历史",
    columnName: "列名",
    columnWidth: "宽度（px）",
    total: "总计",
    restoreDefault: "恢复默认",
    view: "查看",
    print: "打印",
    select: "选择",
    choose: "选择",
    loading: "加载中……",
    empty: "暂无数据",
    noResults: "未找到结果",
    success: "成功",
    requestError: "发生错误，请检查操作后重试",
    updated: "数据已更新！",
    invalidData: "数据无效，请重新检查",
    sequenceNumber: "序号",
    description: "描述",
    taxCode: "税号",
    user: "用户",
    profile: "账户",
    notifications: "通知",
    digitalTransformationNotice: "请阅读数字化转型出版物04",
    guide: "指南",
    changePassword: "修改密码",
    logout: "退出登录",
    home: "首页",
    mst: "税号",
    accept: "确认",
    rejectAction: "拒绝",
    requiredField: "{{field}}为必填项",
    selectField: "请选择{{field}}",
    fileDownloadFailed: "下载失败！",
    errorCode: "发生错误［代码{{code}}］",
    continueSaving: "是否继续保存？",
    minutes: "分钟",
    currentPassword: "当前密码",
    pinCode: "PIN码",
    certificatePassword: "证书密码",
    applicationId: "应用ID",
    uploadCertificateFile: "上传证书文件",
    validCertificateFileFormat: "有效格式为.p12或.fpx文件",
    signingServerSetup: "配置与签名服务器的连接",
    certificateConnectionInfo: "证书提供商提供的连接信息",
    addCertificate: "添加证书",
    editCertificate: "编辑证书",
    deleteCertificate: "删除证书",
    changeCertificatePassword: "修改密码",
    defaultSign: "默认签名",
    cancelNoticeTypeTaxpayer: "纳税人取消/说明通知",
    cancelNoticeTypeTaxAuthority: "根据税务机关通知发出的纳税人取消/说明通知",
    taxAuthorityNoticeHint: "注意：要提交发票错误通知，请更新正确的主管税务机关编码",
    here: "此处",
    sendErrorNoticeQuestion: "是否立即按照04/SS-HĐĐT表向税务机关发送发票错误通知？",
    signSS04: "签署并发送04/SS-HĐĐT",
    sendLater: "否，稍后发送",
    invoiceListInvalid: "发票清单无效",
    wrongInvoiceReasonRequired: "发票{{number}}的错误原因为必填项。",
    certificateDataInvalid: "数据无效",
    selectCertificateRequired: "请选择证书",
    usedCertificateCannotDelete: "正在使用的证书不能删除",
    unsupportedCertificatePasswordChange: "此证书类型不支持修改密码",
    fees: "费用",
    otherInformation: "其他信息",
    nonTaxableDeduction: "不征税扣减",
    otherDeduction: "其他扣减",
    specialInvoice: "特殊发票",
    variableName: "变量名",
    labelWidth: "标签宽度",
    valueWidth: "值宽度",
    maxLength: "最大长度",
    decimalPlaces: "小数位数",
    editable: "可编辑",
    multipleFormula: "多个公式",
    group: "组",
    requiredInput: "必填",
    excelFormula: "Excel公式",
    excelColumnTitle: "Excel列标题",
    calculationOrder: "计算顺序",
    excelValue: "Excel值",
    xmlGroup: "XML组",
    sort: "排序",
    cancelRecordQuestion: "确定要取消此记录吗？",
    cancelRecord: "确认取消",
    deleteRecordQuestion: "确定要删除此记录吗？",
    deleteData: "确认删除",
    signAndSendQuestion: "确定要签署并发送至税务机关吗？",
    signAndSend: "签署并发送",
    signedStatementWarning: "此协议已签名。此操作将使之前的数字签名失效。",
    notice: "通知",
    restorePermissionQuestion: "确定要恢复全部数据权限吗？",
    restorePermission: "恢复权限",
    taxAuthorityCodeQuestion: "确定要获取已发送且返回错误的发票税务机关编码吗？",
    getTaxAuthorityCode: "获取税务机关编码",
    changeTaxQuestion: "确定要将税率应用于所有选中商品吗？",
    changeTax: "确认更改税率",
    updateSellerInfoQuestion: "确定要根据已申报的企业信息更新发票上的销售方信息吗？",
    updateSellerInfo: "更新销售方信息",
    machineInvoiceWarning: "根据现行规定，错误的收银机电子发票必须替换。是否继续调整此发票？",
    permissionQuestion: "新账户将使用其他账户的全部发票符号、数字证书和发票查看权限。是否配置详细权限？",
    products: "产品",
    purchases: "采购",
    registerAgent: "登记代理",
    sign: "电子签名",
    socialDemo: "演示",
    settings: "设置",
    displayScale: "显示大小",
    theme2022: "IAM Software主题-2022",
    theme2021: "IAM Software主题-2021",
    certificateNotConfigured: "尚未登记数字证书，或没有使用数字证书的权限。",
    selectCertificate: "选择数字证书",
    certificateProvider: "证书提供商",
    certificateOwner: "所有者",
    certificateType: "类型",
    tokenIssuer: "认证、签发或认可数字签名/电子签名的组织名称",
    tokenSerial: "证书序列号",
    tokenRegistrationForm: "登记类型",
    tokenFormNew: "新登记",
    tokenFormRenew: "续期",
    tokenFormDiscontinued: "已停用",
    add: "添加",
    pauseInvoiceGuideTitle: "暂停使用电子发票申请",
    pauseInvoiceGuideIntro: "在以下情况下申报暂停使用电子发票的信息：",
    pauseInvoiceGuideReason: "企业暂时停业、解散，或税务机关要求暂停",
    note: "备注",
    pauseInvoiceGuideDateRule: "暂停使用的开始和结束日期：",
    pauseInvoiceGuideDateRequired: "两项均为必填项",
    pauseInvoiceGuideDateAfterDeclaration: "暂停开始日期必须晚于申报日期",
    pauseInvoiceGuideDateOrder: "暂停开始日期必须早于暂停结束日期",
    pauseInvoiceGuideMultipleProviders: "如使用不同的电子发票开具软件，企业必须申报与暂停登记相关的所有服务提供商的完整信息。",
    pauseInvoiceGuideSpecificCertificate: "仅在需要暂停一个或多个特定证书时申报证书序列号。留空则暂停所有证书。",
    pluginUpdate: "更新M-INVOICE Plugin",
    pluginDownload: "下载安装包",
    pluginVersionRequirement: "签署附清单的多张调整/替换发票需要M-INVOICE Plugin {{version}}或更高版本。请更新插件后重新签名。",
    jobNotFound: "未找到任务",
    resumeSuccess: "任务恢复成功",
    retryError: "发生错误，请重试",
    exportErrorTitle: "导出错误",
    exportErrorMessage: "由于系统错误，无法创建报表。",
    errorDetails: "错误详情：",
    copiedError: "错误已复制",
    exportProgress: "正在导出数据",
    exportSuccess: "导出成功",
    exportFailed: "导出失败",
    records: "条记录",
    exportRunningMessage: "数据正在导出，请稍候。",
    currentlyExported: "当前已导出",
    filesInZip: "file.zip中有{{count}}个文件",
    viewDetails: "查看详情",
    continue: "继续",
    exportSuccessMessage: "数据导出成功",
    templateCode: "模板代码",
    templateName: "模板名称",
    invoiceType: "发票类型",
    invoiceTemplate: "发票模板",
    financialYearTemplateTitle: "按财年创建发票模板",
    copyInvoiceTemplate: "复制发票模板",
    financialYearTemplateNotice: "根据第123/2020/NĐ-CP号法令和第78/2021/TT-BTC号通知，发票符号按年份分配，发票编号从1月1日或开始使用电子发票之日起重新从1开始。请选择要使用的符号，然后点击“复制发票模板”将其移至下一年度。",
    paperSize: "纸张大小",
    paperOrientation: "纸张方向",
    charactersPerLine: "每行字符数",
    caseConversion: "大小写转换",
    linesPerPage: "每页行数",
    blankLines: "空白行",
    showSequence: "显示序号",
    htmlFile: "HTML文件",
    imageFile: "图片文件",
    image: "图片",
    creator: "创建人",
    createdDate: "创建日期",
    companyType: "企业类型",
    normal: "普通",
    petroleum: "石油",
    jewelry: "珠宝",
    airline: "机票",
    vehicleSales: "车辆销售",
    vehicleSalesNd254: "车辆销售 NĐ 254",
    transportation: "运输服务",
    digitalTransportation: "数字平台运输服务",
    previewFiles: "查看模板文件和图片",
    notificationManagement: "通知管理",
    notificationTitle: "标题",
    effectiveFrom: "生效日期",
    effectiveTo: "失效日期",
    active: "启用",
    priority: "优先级",
    errorHelp: "错误处理指南",
    messageType: "消息类型",
    messageCode: "消息代码",
    errorCodeLabel: "错误代码",
    errorReason: "错误原因",
    resolution: "处理方式",
    recommendation: "M-Invoice建议",
    recoverPassword: "找回密码",
    recoverByEmail: "输入税号和邮箱以找回密码",
    recoverByToken: "插入USB令牌并安装签名插件以找回密码",
    confirmPassword: "确认密码",
    newPassword: "新密码",
    passwordMismatch: "两次输入的密码不一致",
    tableIndex: "序号",
    effectiveDate: "生效日期",
    unitNameLabel: "单位名称",
    dependentUnitName: "附属单位名称",
    permissionStartDate: "查询权限开始日期",
    permissionEndDate: "查询权限结束日期",
    receivingUnitName: "接收单位名称",
    serviceStartDate: "服务开始日期",
    serviceEndDate: "服务结束日期",
    serviceProviderName: "服务提供商名称",
    invoiceTypeName: "发票类型名称",
    integratedTemplateSymbol: "集成发票模板符号",
    integratedInvoiceSymbol: "集成发票符号",
    integratedOrganization: "接收或提供发票集成的机构",
    integratedOrganizationTaxCode: "接收或提供发票集成机构的税号",
    integrationPurpose: "集成目的",
    providerSolutionTaxCode: "电子发票解决方案提供商税号",
    certificateSerialShort: "证书序列号",
    invoiceServiceProvider: "发票服务提供商名称",
    suspensionStartDate: "暂停开始日期",
    suspensionEndDate: "暂停结束日期",
    deleteLabel: "删除",
    restoreDeclarationStatusQuestion: "确定要将登记申报恢复为等待签名状态并重新发送至税务机关吗？",
    receivedTime: "接收时间",
    taxAuthorityReceivedAndCheckingMessage: "税务机关已接收消息，正在检查数据",
    statusError: "错误",
    unknownMessage: "未知错误",
    taxAuthorityReceivedDeclaration: "税务机关已接收申报",
    taxAuthorityApprovedDeclaration: "税务机关已批准申报",
    declarationExplanation: "申报说明",
    taxAuthorityCheckedData: "税务机关已检查数据",
    taxAuthorityGrantedInvoiceCode: "税务机关已授予发票编码",
    taxAuthorityApprovedErrorNotice: "税务机关已批准错误通知",
    taxAuthorityReceivedMessage: "税务机关已接收消息",
    taxAuthorityApprovedDiscontinuation: "税务机关已批准停用",
    updateTaxAuthorityStatus: "从税务机关更新发票状态",
    businessOperation: "业务操作",
    viewAllInvoices: "查看所有发票",
    addDiscountInvoice: "添加折扣发票",
    replace: "替换",
    multipleReplace: "替换多张发票",
    multipleAdjust: "调整多张发票",
    adjust: "调整",
    replaceOtherSystem: "替换其他系统中的发票",
    adjustOtherSystem: "调整其他系统中的发票",
    multipleInvoiceDialogHeader: "为多张发票创建{{title}}发票",
    multipleInvoiceLegalNotice: "根据第91/2026/TT-BTC号通知第10条第1款b.2项：如果销售方在同一个月内为同一购买方开具的多张发票存在相同的购买方信息、商品名称、单价、数量或税率错误，销售方可以在同月为这些错误电子发票开具一张调整或替换发票，并按照01/BK-ĐCTT表附上错误电子发票清单。",
    multipleInvoiceInstruction: "为多张发票创建{{actionName}}发票分为两步：",
    multipleInvoiceStep1: "第一步：创建错误发票清单以{{title}}",
    multipleInvoiceStep2: "第二步：创建与清单编号和日期关联的{{actionName}}发票",
    askCreateInvoiceList: "是否创建附加发票清单？",
    createInvoiceSkipList: "创建发票并跳过清单",
    createInvoiceWithList: "创建附加发票清单",
    invoiceCreationDate: "发票日期",
    paymentType: "付款方式",
    storeName: "门店名称",
    pumpCode: "加油机代码",
    customerCode: "客户代码",
    entityName: "单位名称",
    buyerContact: "购买方",
    citizenId: "公民身份证号",
    identityCard: "身份证",
    budgetUnitCode: "预算单位代码",
    buyerCode: "客户代码",
    vehiclePlate: "车牌号",
    buyerDisplayName: "购买方姓名",
    passport: "护照号码",
    productType: "选择商品类型",
    totalPayment: "付款总额",
    liters: "升",
    unitPriceInclVat: "单价（含增值税）",
    totalBeforeTax: "未税总额",
    totalTax: "税额总计",
    amountInWords: "金额大写",
    oilInvoice: "石油发票",
    guideNote: "备注",
    sellerTaxCode: "销售方税号",
    buyerTaxCode: "购买方税号",
    invoiceListNo: "清单编号",
    invoiceListDate: "清单日期",
    sellerName: "销售方名称",
    buyerAddress: "购买方地址",
    sellerAddress: "销售方地址",
    generalInfo: "基本信息",
    sellerInfo: "销售方信息",
    buyerInfo: "购买方信息",
    relatedInvoiceInfo: "关联发票信息",
    otherInfo: "其他信息",
    grandTotal: "总计",
    preview: "预览",
    confirmCreateInvoiceWithList: "确认使用发票清单创建发票",
    reviewInvoiceList: "查看发票清单",
    confirmation: "确认",
    checkInvoiceAndList: "确认前请仔细检查发票和发票清单。",
    discountedInvoiceListTitle: "按收入折扣的发票",
    discountInvoiceAttachmentTitle: "折扣发票附加清单",
    commercialDiscountInvoice: "创建商业折扣发票",
    syncFromSigningTool: "从签名工具同步",
    syncInvoice: "同步发票",
    taxPayerCodeShort: "销售方税号",
    currentInvoiceStatus: "当前发票状态",
    taxAuthorityInvoiceStatus: "税务机关发票状态",
    queryTaxAuthority: "向税务机关查询",
    taxAuthorityFeatureRestriction: "此功能仅适用于税务机关提交状态为发送中、成功或错误的发票",
    statusMatches: "发票状态一致。",
    statusChanged: "发票状态已变更！",
    original: "原始",
    statusCancelled: "已取消",
    statusWaitingApproval: "等待批准",
    statusWaitingSignature: "等待签名",
    statusSigning: "签名中",
    statusSigned: "已签名",
    statusSending: "发送中",
    statusSuccessful: "成功",
    statusFailed: "错误",
    statusExplanation: "说明",
    itemGoodsService: "商品及服务",
    itemPromotion: "促销",
    itemCommercialDiscount: "商业折扣",
    itemDescription: "说明备注",
    itemSpecialGoods: "特殊商品",
    beingCancelled: "已取消",
    beingAdjusted: "已调整",
    beingReplaced: "已替换",
    restoreStatus: "恢复状态",
    paymentCompleted: "发票已付款",
    paymentCompletedWithNumber: "发票{{serial}}号码{{number}}已付款",
    paymentPending: "发票等待付款",
    unitCode: "单位代码",
    unitName: "单位名称",
    salePrice: "销售价",
    bulkTaxChange: "批量更改税率",
    lookupAccount: "创建发票查询账户",
    createLookupUser: "创建查询用户",
    customerAccountCreated: "账户已创建",
    customerName: "客户名称",
    emailSeparatorPlaceholder: "使用逗号（,）或分号（;）分隔邮箱",
    searchCccdNotFound: "未找到公民身份证数据。",
    searchCccdError: "公民身份证查询错误。",
    searchTaxDataNotFound: "未找到数据",
    searchTaxDataError: "税号查询错误。",
    searchTaxDataV2Error: "税号查询错误（V2）。",
    electronicSocialInsurance: "电子社会保险",
    invoiceRiskManagement: "mSMI发票风险管理",
    electronicContract: "电子合同",
    serviceTerms: "同意服务条款",
    mqrTerms: "同意MQR条款",
    applyNewTaxRate: "应用新税率",
    changeTaxRate: "更改税率",
    convert: "转换",
    editor: "修改人",
    calculationMethod: "计算方式",
    saveAndExportDiscountInvoice: "保存并导出折扣发票",
    addInvoice: "添加发票",
    deleteInvoiceRow: "删除发票行",
    discountedInvoiceHint: "点击“添加发票”将发票加入折扣发票清单",
    currencyUnit: "货币单位",
    exchangeRate: "汇率",
    taxAuthorityShortCode: "税务机关编码",
    fillRequiredInfo: "请填写所有必填信息",
    invoiceNotSelected: "未选择发票",
    discount: "折扣",
    multipleInvoices: "多张发票",
    paid: "已付款",
    unpaid: "未付款",
    invoiceSelectionRequired: "请先选择发票再继续",
    printInvoiceSelectionRequired: "请先选择发票再查看/打印",
    signInvoiceSelectionRequired: "请先选择发票再签名",
    emailInvoiceSelectionRequired: "请先选择发票再发送邮件",
    onlyWaitingSignature: "此操作仅适用于等待签名的发票",
    invalidReplaceStatus: "只能替换已成功提交且处于原始或替换状态的发票",
    invalidAdjustStatus: "只能调整已成功提交且处于原始或已调整状态的发票",
    invalidDeleteStatus: "不能删除已签名、已提交、成功或错误的发票",
    signTimeWarningTitle: "警告：发票签名时间超出允许范围",
    continueSign: "是，继续签名",
    restoreInvoiceStatusQuestion: "确定要将发票状态恢复为等待签名并重新发送至税务机关吗？",
    fieldFormatInvalid: "{{field}}格式无效",
  },
  menu: {
    bilingualVietnameseEnglish: "越南语-英语双语",
    signCustomization: "签名设置",
    signImmediately: "立即签署发票并发送至税务机关",
    signSummaryAtPeriodEnd: "期末签署发票并发送汇总表",
    colorCustomization: "颜色设置",
    fontCustomization: "字体设置",
    buyerCustomization: "购买方设置",
    underlineBuyerValue: "购买方值加下划线",
    tableCustomization: "表格设置",
    tableRowBorders: "表格显示行边框",
    columnSymbolRows: "设置列符号行数",
    blankRows: "空白行",
    multiPageInvoiceRows: "多页发票行数",
    signatureLabelCustomization: "签名标签设置",
    headSignature: "负责人签名",
    emailInvoice: "发送发票邮件",
    htmlFormat: "HTML格式",
    invoiceType: "发票类型",
    templatePrintRows: "模板打印行数",
    creator: "创建人",
    active: "使用中",
    viewInvoiceTemplate: "查看发票模板",
    copyInvoiceTemplate: "复制发票模板",
    printConvertedInvoice: "打印转换发票",
    logoBackground: "标志-背景",
    detailCustomization: "明细设置",
    saveInfo: "保存信息",
    logoFileSizeExceeded: "标志文件不能超过100KB",
    imageFileRequired: "文件必须是图片格式",
    logoDimensionExceeded: "标志尺寸超过限制。最大尺寸：{{width}}x{{height}}px",
    imageReadFailed: "无法读取图片文件",
    borderFileSizeExceeded: "上传文件不能超过300KB",
    borderDimensionExceeded: "边框尺寸超过建议限制：{{pageSize}}：{{width}} x {{height}}",
    backgroundFileSizeExceeded: "背景尺寸不能超过200KB",
    backgroundDimensionExceeded: "背景尺寸超过限制。最大尺寸：{{width}}x{{height}}px",
    useQrCode: "使用二维码",
    sizeCustomization: "尺寸设置",
    useLogo: "使用标志",
    chooseLogoFromComputer: "从电脑选择；最大100KB",
    maxDimension: "最大尺寸：（{{dimension}}）",
    useBackground: "使用背景",
    chooseImageFromComputer: "从电脑选择图片",
    chooseBackgroundFromLibrary: "从图库选择背景图片",
    chooseBackgroundFromComputer: "从电脑选择；最大200KB",
    opacity: "不透明度",
    useBorder: "使用边框",
    chooseBorderFromComputer: "从电脑选择；最大300KB",
    maxPageDimension: "{{pageSize}}最大尺寸：（{{width}}x{{height}}）",
    electronicInvoiceN123: "第123号法令规定的电子发票",
    authenticatedInvoiceQD1209: "第1209号决定规定的验证发票",
    invoiceN51: "第51号法令规定的发票",
    preprintedInvoiceN123: "第123号法令规定的印制发票",
    commercialDiscountInvoiceTypeName: "附清单的商业折扣发票",
    inside: "内部",
    outside: "外部",
  },
  validation: {
    previousVolumeInvalid: "上次加油总量无效。",
    compensateTransactionQuestion: "确认补偿所选的{{count}}笔交易",
    wrongInvoiceDenominatorRange: "发票表号必须在1至6之间",
    wrongInvoiceRelatedSerialLength: "关联发票符号长度无效。",
    wrongInvoiceFormChar: "发票形式字符无效",
    wrongInvoiceYearChar: "符号中的年份字符无效",
    wrongInvoiceTypeChar: "发票类型字符无效",
    wrongInvoiceDenominatorLength: "关联发票表号长度无效。",
    wrongInvoiceFirstTypeChars: "发票类型的前两个字符无效",
    wrongInvoiceKindChars: "发票类型的四个字符无效",
    wrongInvoiceCopiesChar: "联数字符无效",
    wrongInvoiceSeparator: "符号中的分隔字符无效",
    wrongInvoiceIssueSequence: "开具顺序的三个字符无效",
    wrongInvoiceSerialLength: "发票符号长度无效。",
    wrongInvoiceSerialPrefix: "前两个字符无效",
    wrongInvoiceSerialYear: "开具年份字符无效",
    wrongInvoiceSerialType: "发票类型字符无效",
  },
  catalog: {
    priceUpdateLink: "燃油价格更新链接",
    priceUpdateResult: "价格更新结果",
    iotPriceUpdateStatus: "IoT系统上的价格更新状态",
    measuringColumnType: "计量列类型",
    modelApproval: "型号审批",
    maintenance: "维护",
    pecoPriceChange: "更改PECO柜燃油价格",
    confirmPumpPriceUpdate: "确定要更新加油机价格吗？",
    paymentSpeaker: "付款音箱",
    taxCode: "税率代码",
    quantityDecimals: "数量小数位",
    unitPriceDecimals: "单价小数位",
    totalDecimals: "总额小数位",
    taxDetailDecimals: "明细税额小数位",
    taxAmountDecimals: "总税额小数位",
    readCurrency: "读取货币",
    readDecimal: "读取小数",
    createInvoiceFromTransactions: "根据石油交易创建发票",
    mobileUsage: "在移动应用中使用",
    order: "顺序",
    paymentMaximumValue: "最大值",
    emailBusinessType: "业务类型",
    emailSendInvoice: "发送发票",
    emailSendConfirmation: "发送确认",
    emailSendAccount: "发送账户",
    emailErrorNotice: "错误通知",
    emailPaymentReminder: "付款提醒",
    paymentProductType: "产品类型",
    primaryBeneficiaryAccount: "主要受益账户",
    pumpActionCode: "加油交易代码",
    pumpStartTime: "开始加油时间",
    pumpedTotal: "加油总量",
    salesStaffCode: "销售员工代码",
    previousPumpedTotal: "上次加油总量",
  },
  system: {
    accessOtherUserDocuments: "查看其他用户的凭证",
    editOtherUserDocuments: "编辑其他用户的凭证",
    deleteOtherUserDocuments: "删除其他用户的凭证",
    paymentIntegrationCode: "付款集成代码",
    legalRepresentativeSection: "法定代表人信息",
    useCitizenId: "个体户使用公民身份证号代替销售方税号",
    taxAuthoritySection: "税务机关及发票查询信息",
    provincialTaxAuthority: "省级税务机关",
    managingTaxAuthority: "主管税务机关",
    agentInfo: "代理信息",
    changeHistoryInfo: "信息变更历史",
    dataPermission: "基于数据的权限",
    fullDataPermission: "全部数据权限",
    resetDefaultPermission: "恢复默认权限",
    helpUrl: "帮助URL",
    petrolSyncConfigTitle: "根据交易日志创建石油发票",
    invoiceResyncTime: "发票重新同步时间",
    takeLogRecords: "每次扫描获取的日志记录数",
    scanConditionRequired: "请输入数据扫描条件",
    emailMttConfigTitle: "收银机已签名发票通知发送配置",
    notificationEmail: "通知接收邮箱",
    notificationResendTime: "通知重发/重新签名时间",
    feature: "功能",
    autoSignInvoice: "自动签署发票",
    sendNotificationEmail: "发送通知邮件",
    signAgainTime: "重新签署发票时间",
    resendNotificationTime: "重新发送通知时间",
    emailSeparatorHint: "使用逗号（,）或分号（;）分隔邮箱",
    conditionLabel: "条件：",
    certificateCondition: "客户已在软件中登记FILE或Service数字证书",
    invoiceStatusCondition: "发票等待签名且已填写发票日期",
    configCodeRequired: "配置代码为必填项",
    invoiceTypeRequired: "发票类型为必填项",
  },
  report: {
    summaryLimitNotice: "为确保向税务机关发送时的数据容量，每张汇总表最多选择2,000张发票",
    summaryCreateTitle: "创建发票数据汇总表",
    summaryFindInvoices: "查找要加入汇总表的发票",
    summaryInvoiceSelectionLegend: "{{action}}要加入汇总表的发票",
    totalOtherDeductions: "其他扣减总额",
    exchangeRate: "汇率",
    totalFee: "费用总额",
    summaryDuplicateInvoice: "发票{{serial}}-{{number}}已存在",
    summaryDeleteBlocked: "已签名的汇总表或早于最新汇总表的汇总表不能删除",
    summaryInvoiceTypeNd123: "NĐ123电子发票",
    summaryInvoiceTypeQd1209: "QĐ1209验证发票",
    summaryInvoiceTypeNd51: "第51号法令规定的发票",
    summaryPaperInvoiceNd51: "第51号法令规定的纸质发票",
    updatedAt: "更新于{{date}}",
    errorNoticeDescription: "使用04/SS-HĐĐT表向税务机关通知错误电子发票",
    sendingCount: "发送中数量",
    waitingSignatureCount: "等待签名数量",
    signedCount: "已签名数量",
  },
};

// Japanese and Korean are generated from the same English source resource as
// the existing locales.  The exact-value table handles the most frequently
// displayed UI phrases, while the domain dictionary covers the longer labels
// and messages without changing interpolation placeholders.
const japanesePhraseTranslations = {
  "M-Invoice": "M-Invoice",
  Language: "言語",
  "Tiếng Việt": "ベトナム語",
  English: "英語",
  Chinese: "中国語",
  Japanese: "日本語",
  Korean: "韓国語",
  "USB token": "USBトークン",
  "EASYCA service": "EASYCAサービス",
  "NCCA service": "NCCAサービス",
  "I-CA service": "I-CAサービス",
  "Intrust-CA service": "Intrust-CAサービス",
  "FILE CA": "FILE CA",
  Close: "閉じる",
  Cancel: "キャンセル",
  Save: "保存",
  Update: "更新",
  Create: "作成",
  Edit: "編集",
  Details: "詳細",
  Delete: "削除",
  Confirm: "確認",
  Back: "戻る",
  Search: "検索",
  Filter: "フィルター",
  "Clear filters": "フィルターをクリア",
  Reset: "リセット",
  Refresh: "更新",
  Export: "エクスポート",
  Import: "インポート",
  Download: "ダウンロード",
  Upload: "アップロード",
  Copy: "コピー",
  "Import from Excel": "Excelからインポート",
  "Export to Excel": "Excelへエクスポート",
  "Please select a file.": "ファイルを選択してください。",
  "Choose a file": "ファイルを選択",
  "Download template": "テンプレートをダウンロード",
  Actions: "操作",
  Functions: "機能",
  Statement: "議事録",
  Symbol: "記号",
  "Invoice number": "請求書番号",
  "Invoice date": "請求書日付",
  Status: "ステータス",
  Apply: "適用",
  "No data": "データなし",
  "Goods and services name": "商品・サービス名",
  "VAT rate": "VAT税率",
  "VAT amount": "VAT額",
  "Other amount": "その他の金額",
  "Total after tax": "税込合計",
  "Total payment": "支払合計",
  "Total before tax": "税抜合計",
  "Total tax": "税合計",
  "Grand total": "総合計",
  "Total amount in words": "合計金額（文字）",
  "Other deductions": "その他の控除",
  "Amount before tax": "税抜金額",
  "Total {{count}} records": "合計{{count}}件",
  "View/print": "表示・印刷",
  "Send email": "メール送信",
  "Download invoice PDF": "請求書PDFをダウンロード",
  "Sign invoices in bulk": "請求書を一括署名",
  "Invoice history": "請求書履歴",
  "Payment history": "支払い履歴",
  "Payment notification": "支払い通知",
  "Transaction ID": "取引ID",
  "Paid amount": "支払額",
  "Payment time": "支払い日時",
  "Payment status": "支払いステータス",
  Content: "内容",
  Field: "項目",
  "Upload PDF file": "PDFファイルをアップロード",
  "Attach statement": "議事録を添付",
  "From date": "開始日",
  "To date": "終了日",
  "Seller/buyer name": "販売者・購入者名",
  "Tax authority code": "税務当局コード",
  "Select invoice": "請求書を選択",
  "Invoice payment history": "請求書の支払い履歴",
  "No results found": "結果が見つかりません",
  "No available options": "選択肢がありません",
  "Rows per page": "1ページあたりの行数",
  "{{field}} is required": "{{field}}は必須です",
  "{{field}} is invalid": "{{field}}は無効です",
  "{first} - {last} of {totalRecords} records": "{first} - {last} 件 / 全 {totalRecords} 件",
  "M-Invoice recommendation": "M-Invoiceのおすすめ",
  "M-INVOICE Plugin is not installed": "M-INVOICE Pluginがインストールされていません",
  "M-INVOICE Plugin is installed": "M-INVOICE Pluginがインストールされています",
  "Open M-INVOICE Plugin": "M-INVOICE Pluginを開く",
  "Transmission history": "送受信履歴",
  "Error handling": "エラー処理",
  "Bilingual (Vietnamese - English)": "二言語（ベトナム語 - 英語）",
  "Sign invoice and send immediately to the tax authority": "請求書に署名して税務当局へすぐに送信",
  "Sign invoice and send the period-end summary": "請求書に署名して期末集計を送信",
  "Table has row borders": "表に行の境界線を表示",
  "Set column symbol row count": "記号列の行数を設定",
  "Rows for multi-page invoices": "複数ページ請求書の行数",
  "Head signature": "先頭署名",
  "HTML format": "HTML形式",
  "Copy invoice template": "請求書テンプレートをコピー",
  "Print converted invoice": "変換した請求書を印刷",
  "The logo file must not exceed 100KB": "ロゴファイルは100KBを超えてはいけません",
  "The file must be an image": "ファイルは画像である必要があります",
  "The logo dimensions exceed the limit. Maximum: {{width}}x{{height}}px": "ロゴのサイズが制限を超えています。最大：{{width}}x{{height}}px",
  "The image file could not be read": "画像ファイルを読み取れませんでした",
  "The uploaded file must not exceed 300KB": "アップロードするファイルは300KBを超えてはいけません",
  "The border dimensions exceed the recommended limit: {{pageSize}}: {{width}} x {{height}}": "枠線のサイズが推奨値を超えています：{{pageSize}}：{{width}} x {{height}}",
  "The background file must not exceed 200KB": "背景ファイルは200KBを超えてはいけません",
  "The background dimensions exceed the limit. Maximum: {{width}}x{{height}}px": "背景のサイズが制限を超えています。最大：{{width}}x{{height}}px",
  "Choose from computer; maximum 100KB": "パソコンから選択（最大100KB）",
  "Choose image from computer": "パソコンから画像を選択",
  "Choose background image from library": "ライブラリから背景画像を選択",
  "Choose from computer; maximum 200KB": "パソコンから選択（最大200KB）",
  "Choose from computer; maximum 300KB": "パソコンから選択（最大300KB）",
  "Output invoices": "請求書発行",
  "Invoice error notices": "請求書エラー通知",
  "Replace invoice from another system": "他システムの請求書を差し替え",
  "Adjust invoice from another system": "他システムの請求書を調整",
  "Electronic invoice under Decree 123": "政令123号に基づく電子請求書",
  "Authenticated invoice under Decision 1209": "決定1209号に基づく認証済み請求書",
  "Invoice under Decree 51": "政令51号に基づく請求書",
  "Preprinted invoice under Decree 123": "政令123号に基づく印刷済み請求書",
  "commercial discount invoice with attached list": "明細付き商業割引請求書",
  "QRCode payment history": "QRCode支払い履歴",
  "Invoice usage report": "請求書利用状況レポート",
  "Received from accounting software report": "会計ソフトから受信したレポート",
  "Outgoing invoice list report (PL01)": "売上請求書一覧レポート（PL01）",
  "Create invoice summary form 01/TH-HĐĐT": "請求書集計フォーム01/TH-HĐĐTを作成",
  "Petroleum management": "石油管理",
  "Integrated device catalog": "統合デバイスカタログ",
  "Company management": "会社管理",
  "User management": "ユーザー管理",
  "System parameter declaration": "システムパラメータ申告",
  "Invoice template administration": "請求書テンプレート管理",
  "Log in": "ログイン",
  "Back to log in": "ログインに戻る",
  "Don't have an account?": "アカウントをお持ちでない方",
  Register: "登録",
  "Check your USB Token to continue.": "続行するにはUSBトークンを確認してください。",
  "Confirm statement signing": "議事録署名の確認",
  "Language customization": "言語設定",
  "Signing customization": "署名設定",
  "Color customization": "色設定",
  "Font customization": "フォント設定",
  "Buyer customization": "購入者設定",
  "Underline buyer value": "購入者の値に下線",
  "Table customization": "表設定",
  "Signature label customization": "署名ラベル設定",
  "Invoice type": "請求書種別",
  "In use": "使用中",
  "Detail customization": "明細設定",
  "Save information": "情報を保存",
  "Use QR code": "QRコードを使用",
  "Size customization": "サイズ設定",
  "Use logo": "ロゴを使用",
  "Use background": "背景を使用",
  "Use border": "枠線を使用",
  "Issue registration": "発行登録",
  "Registration declaration": "登録申告",
  "Invoice list": "請求書一覧",
  "Discount invoice list": "割引請求書一覧",
  "Invoice summary report": "請求書集計レポート",
  "Invoice detail report": "請求書明細レポート",
  "Petroleum tax report": "石油税務レポート",
  "Company information": "会社情報",
  License: "ライセンス",
  "Digital certificate registration": "デジタル証明書登録",
  "Value replacement": "差し替え値",
  "Default values": "デフォルト値",
  "Statement list": "一覧",
  "QR Code payment": "QRコード決済",
  "Error name": "エラー名",
  "Integration key": "連携キー",
  "Invoice creation status": "請求書作成ステータス",
  "Customer tax code": "顧客税番号",
  "Customer phone number": "顧客電話番号",
};

const koreanPhraseTranslations = {
  "M-Invoice": "M-Invoice",
  Language: "언어",
  "Tiếng Việt": "베트남어",
  English: "영어",
  Chinese: "중국어",
  Japanese: "일본어",
  Korean: "한국어",
  "USB token": "USB 토큰",
  "EASYCA service": "EASYCA 서비스",
  "NCCA service": "NCCA 서비스",
  "I-CA service": "I-CA 서비스",
  "Intrust-CA service": "Intrust-CA 서비스",
  "FILE CA": "FILE CA",
  Close: "닫기",
  Cancel: "취소",
  Save: "저장",
  Update: "수정",
  Create: "생성",
  Edit: "편집",
  Details: "상세",
  Delete: "삭제",
  Confirm: "확인",
  Back: "뒤로",
  Search: "검색",
  Filter: "필터",
  "Clear filters": "필터 초기화",
  Reset: "초기화",
  Refresh: "새로 고침",
  Export: "내보내기",
  Import: "가져오기",
  Download: "다운로드",
  Upload: "업로드",
  Copy: "복사",
  "Import from Excel": "Excel에서 가져오기",
  "Export to Excel": "Excel로 내보내기",
  "Please select a file.": "파일을 선택하세요.",
  "Choose a file": "파일 선택",
  "Download template": "템플릿 다운로드",
  Actions: "작업",
  Functions: "기능",
  Statement: "확인서",
  Symbol: "기호",
  "Invoice number": "청구서 번호",
  "Invoice date": "청구서 날짜",
  Status: "상태",
  Apply: "적용",
  "No data": "데이터 없음",
  "Goods and services name": "상품 및 서비스명",
  "VAT rate": "VAT 세율",
  "VAT amount": "VAT 금액",
  "Other amount": "기타 금액",
  "Total after tax": "세금 포함 합계",
  "Total payment": "총 결제 금액",
  "Total before tax": "세전 합계",
  "Total tax": "세금 합계",
  "Grand total": "총합계",
  "Total amount in words": "합계 금액(문자)",
  "Other deductions": "기타 공제",
  "Amount before tax": "세전 금액",
  "Total {{count}} records": "총 {{count}}건",
  "View/print": "보기/인쇄",
  "Send email": "이메일 보내기",
  "Download invoice PDF": "청구서 PDF 다운로드",
  "Sign invoices in bulk": "청구서 일괄 서명",
  "Invoice history": "청구서 이력",
  "Payment history": "결제 이력",
  "Payment notification": "결제 알림",
  "Transaction ID": "거래 ID",
  "Paid amount": "결제 금액",
  "Payment time": "결제 시간",
  "Payment status": "결제 상태",
  Content: "내용",
  Field: "필드",
  "Upload PDF file": "PDF 파일 업로드",
  "Attach statement": "확인서 첨부",
  "From date": "시작일",
  "To date": "종료일",
  "Seller/buyer name": "판매자/구매자 이름",
  "Tax authority code": "세무 당국 코드",
  "Select invoice": "청구서 선택",
  "Invoice payment history": "청구서 결제 이력",
  "No results found": "결과를 찾을 수 없습니다",
  "No available options": "사용 가능한 옵션이 없습니다",
  "Rows per page": "페이지당 행 수",
  "{{field}} is required": "{{field}}은(는) 필수입니다",
  "{{field}} is invalid": "{{field}}은(는) 올바르지 않습니다",
  "{first} - {last} of {totalRecords} records": "전체 {totalRecords}건 중 {first} - {last}건",
  "M-Invoice recommendation": "M-Invoice 추천",
  "M-INVOICE Plugin is not installed": "M-INVOICE Plugin이 설치되지 않았습니다",
  "M-INVOICE Plugin is installed": "M-INVOICE Plugin이 설치되어 있습니다",
  "Open M-INVOICE Plugin": "M-INVOICE Plugin 열기",
  "Transmission history": "전송 이력",
  "Error handling": "오류 처리",
  "Bilingual (Vietnamese - English)": "이중 언어(베트남어 - 영어)",
  "Sign invoice and send immediately to the tax authority": "청구서에 서명하여 세무 당국으로 즉시 전송",
  "Sign invoice and send the period-end summary": "청구서에 서명하여 기간 말 집계 전송",
  "Table has row borders": "표에 행 테두리 표시",
  "Set column symbol row count": "기호 열 행 수 설정",
  "Rows for multi-page invoices": "여러 페이지 청구서의 행 수",
  "Head signature": "머리글 서명",
  "HTML format": "HTML 형식",
  "Copy invoice template": "청구서 템플릿 복사",
  "Print converted invoice": "변환된 청구서 인쇄",
  "The logo file must not exceed 100KB": "로고 파일은 100KB를 초과할 수 없습니다",
  "The file must be an image": "파일은 이미지여야 합니다",
  "The logo dimensions exceed the limit. Maximum: {{width}}x{{height}}px": "로고 크기가 제한을 초과했습니다. 최대: {{width}}x{{height}}px",
  "The image file could not be read": "이미지 파일을 읽을 수 없습니다",
  "The uploaded file must not exceed 300KB": "업로드 파일은 300KB를 초과할 수 없습니다",
  "The border dimensions exceed the recommended limit: {{pageSize}}: {{width}} x {{height}}": "테두리 크기가 권장 제한을 초과했습니다: {{pageSize}}: {{width}} x {{height}}",
  "The background file must not exceed 200KB": "배경 파일은 200KB를 초과할 수 없습니다",
  "The background dimensions exceed the limit. Maximum: {{width}}x{{height}}px": "배경 크기가 제한을 초과했습니다. 최대: {{width}}x{{height}}px",
  "Choose from computer; maximum 100KB": "컴퓨터에서 선택(최대 100KB)",
  "Choose image from computer": "컴퓨터에서 이미지 선택",
  "Choose background image from library": "라이브러리에서 배경 이미지 선택",
  "Choose from computer; maximum 200KB": "컴퓨터에서 선택(최대 200KB)",
  "Choose from computer; maximum 300KB": "컴퓨터에서 선택(최대 300KB)",
  "Output invoices": "청구서 발행",
  "Invoice error notices": "청구서 오류 알림",
  "Replace invoice from another system": "다른 시스템의 청구서 대체",
  "Adjust invoice from another system": "다른 시스템의 청구서 수정",
  "Electronic invoice under Decree 123": "123호 법령에 따른 전자 청구서",
  "Authenticated invoice under Decision 1209": "1209호 결정에 따른 인증 청구서",
  "Invoice under Decree 51": "51호 법령에 따른 청구서",
  "Preprinted invoice under Decree 123": "123호 법령에 따른 사전 인쇄 청구서",
  "commercial discount invoice with attached list": "목록이 첨부된 상업 할인 청구서",
  "QRCode payment history": "QRCode 결제 이력",
  "Invoice usage report": "청구서 사용 현황 보고서",
  "Received from accounting software report": "회계 소프트웨어 수신 보고서",
  "Outgoing invoice list report (PL01)": "매출 청구서 목록 보고서(PL01)",
  "Create invoice summary form 01/TH-HĐĐT": "청구서 집계 양식 01/TH-HĐĐT 생성",
  "Petroleum management": "석유 관리",
  "Integrated device catalog": "통합 장치 카탈로그",
  "Company management": "회사 관리",
  "User management": "사용자 관리",
  "System parameter declaration": "시스템 매개변수 신고",
  "Invoice template administration": "청구서 템플릿 관리",
  "Log in": "로그인",
  "Back to log in": "로그인으로 돌아가기",
  "Don't have an account?": "계정이 없으신가요?",
  Register: "등록",
  "Check your USB Token to continue.": "계속하려면 USB 토큰을 확인하세요.",
  "Confirm statement signing": "확인서 서명 확인",
  "Language customization": "언어 설정",
  "Signing customization": "서명 설정",
  "Color customization": "색상 설정",
  "Font customization": "글꼴 설정",
  "Buyer customization": "구매자 설정",
  "Underline buyer value": "구매자 값에 밑줄",
  "Table customization": "표 설정",
  "Signature label customization": "서명 레이블 설정",
  "Invoice type": "청구서 유형",
  "In use": "사용 중",
  "Detail customization": "상세 설정",
  "Save information": "정보 저장",
  "Use QR code": "QR 코드 사용",
  "Size customization": "크기 설정",
  "Use logo": "로고 사용",
  "Use background": "배경 사용",
  "Use border": "테두리 사용",
  "Issue registration": "발행 등록",
  "Registration declaration": "등록 신고",
  "Invoice list": "청구서 목록",
  "Discount invoice list": "할인 청구서 목록",
  "Invoice summary report": "청구서 집계 보고서",
  "Invoice detail report": "청구서 상세 보고서",
  "Petroleum tax report": "석유 세금 보고서",
  "Company information": "회사 정보",
  License: "라이선스",
  "Digital certificate registration": "디지털 인증서 등록",
  "Value replacement": "대체 값",
  "Default values": "기본값",
  "Statement list": "목록",
  "QR Code payment": "QR 코드 결제",
  "Error name": "오류 이름",
  "Integration key": "연동 키",
  "Invoice creation status": "청구서 생성 상태",
  "Customer tax code": "고객 세금 코드",
  "Customer phone number": "고객 전화번호",
};

const japaneseWordTranslations = {
  language: "言語", vietnamese: "ベトナム語", english: "英語", chinese: "中国語",
  japanese: "日本語", korean: "韓国語", token: "トークン", service: "サービス",
  close: "閉じる", cancel: "キャンセル", save: "保存", update: "更新", create: "作成",
  edit: "編集", detail: "詳細", details: "詳細", delete: "削除", confirm: "確認",
  back: "戻る", search: "検索", filter: "フィルター", clear: "クリア", reset: "リセット",
  refresh: "更新", export: "エクスポート", import: "インポート", download: "ダウンロード",
  upload: "アップロード", copy: "コピー", choose: "選択", select: "選択",
  view: "表示", print: "印刷", send: "送信", sending: "送信中", sign: "署名",
  signing: "署名中", signed: "署名済み", invoice: "請求書", invoices: "請求書",
  output: "発行", error: "エラー", errors: "エラー", handling: "処理",
  transmission: "送受信", history: "履歴", reports: "レポート", report: "レポート",
  catalog: "カタログ", issue: "発行", issuance: "発行", notice: "通知", notices: "通知",
  replacement: "差し替え", replace: "差し替え", adjustment: "調整", adjust: "調整",
  cancellation: "取消", canceled: "取消済み", cancelled: "取消済み",
  multiple: "複数", list: "一覧", lists: "一覧", summary: "集計", form: "フォーム",
  template: "テンプレート", configuration: "設定", administration: "管理",
  management: "管理", system: "システム", parameter: "パラメータ", company: "会社",
  user: "ユーザー", users: "ユーザー", organization: "組織", business: "事業",
  location: "場所", tax: "税", authority: "当局", code: "コード", status: "ステータス",
  date: "日付", time: "時刻", number: "番号", name: "名前", address: "住所",
  phone: "電話番号", email: "メール", customer: "顧客", buyer: "購入者", seller: "販売者",
  goods: "商品", product: "商品", products: "商品",
  quantity: "数量", unit: "単位", price: "価格", amount: "金額", total: "合計",
  payment: "支払い", paid: "支払済み", unpaid: "未払い", transaction: "取引",
  transactions: "取引", reason: "理由", description: "説明", content: "内容",
  field: "項目", fields: "項目", value: "値", values: "値", data: "データ",
  row: "行", rows: "行", column: "列", columns: "列", page: "ページ",
  pages: "ページ", month: "月", months: "月", year: "年", years: "年", day: "日",
  days: "日", week: "週", weeks: "週", quarter: "四半期", period: "期間",
  current: "現在", previous: "前", new: "新規", old: "旧", first: "最初", last: "最後",
  all: "すべて", other: "その他", original: "原本", valid: "有効", invalid: "無効",
  required: "必須", empty: "空", missing: "不足", available: "利用可能",
  successful: "成功", success: "成功", failed: "失敗", failure: "失敗", warning: "警告",
  loading: "読み込み中", preview: "プレビュー", guide: "ガイド", help: "ヘルプ",
  support: "サポート", profile: "プロフィール", notifications: "通知", logout: "ログアウト",
  home: "ホーム", settings: "設定", permission: "権限", permissions: "権限",
  role: "ロール", formula: "計算式", calculate: "計算", calculation: "計算",
  currency: "通貨", exchange: "為替", rate: "率", discount: "割引",
  bank: "銀行", certificate: "証明書", certificates: "証明書", password: "パスワード",
  register: "登録", registered: "登録済み", registration: "登録", declaration: "申告",
  explanation: "説明", change: "変更", changed: "変更済み", convert: "変換",
  converted: "変換済み", attach: "添付", attachment: "添付", related: "関連",
  source: "ソース", creator: "作成者", created: "作成済み", owner: "所有者",
  operation: "操作", operations: "業務", feature: "機能", default: "デフォルト",
  restore: "復元", initial: "初期", active: "有効", inside: "内部", outside: "外部",
  effective: "有効", expired: "期限切れ", used: "使用済み", remaining: "残り",
  priority: "優先度", resolution: "解像度", width: "幅", height: "高さ", size: "サイズ",
  maximum: "最大", minimum: "最小", image: "画像", logo: "ロゴ", background: "背景",
  border: "枠線", opacity: "不透明度", paper: "用紙", orientation: "向き",
  characters: "文字", lines: "行", line: "行", blank: "空白", normal: "通常",
  show: "表示", sequence: "連番", sort: "並べ替え", order: "順序", group: "グループ",
  execute: "実行", check: "確認", viewed: "閲覧済み", unviewed: "未閲覧",
  accept: "承認", accepted: "承認済み", reject: "拒否", rejected: "拒否済み",
  continue: "続行", pause: "一時停止", suspension: "停止", progress: "進行状況",
  petroleum: "石油", fuel: "燃料", pump: "ポンプ", store: "店舗",
  vehicle: "車両", airline: "航空", ticket: "チケット", jewelry: "宝飾品",
  notification: "通知", title: "タイトル",
  file: "ファイル", files: "ファイル", format: "形式", formats: "形式",
  excel: "Excel", html: "HTML", plugin: "プラグイン", server: "サーバー",
  host: "ホスト", port: "ポート", authentication: "認証", legal: "法定",
  representative: "代表者", position: "役職", party: "当事者", parties: "当事者",
  gender: "性別", female: "女性", male: "男性",
  passport: "パスポート", citizen: "市民", identity: "身分証", card: "カード",
  liters: "リットル", minutes: "分", hours: "時間",
  "taxpayer": "納税者", "taxpayers": "納税者", "decree": "政令", "decision": "決定",
  "pursuant": "に基づく", "agreement": "合意", "under": "に基づく", "according": "に従う",
  "the": "その", "a": "ある", "an": "ある", "and": "と", "or": "または", "of": "の",
  "to": "へ", "from": "から", "for": "用", "in": "で", "on": "上", "with": "付き",
  "without": "なし", "by": "による", "as": "として", "at": "で", "is": "です",
  "are": "です", "was": "でした", "were": "でした", "be": "なる", "has": "あります",
  "have": "あります", "do": "します", "does": "します", "not": "ない", "if": "場合",
  "when": "とき", "before": "前", "after": "後", "please": "してください",
  "cannot": "できません", "can": "できます", "only": "のみ", "including": "含む",
  "more": "その他", "less": "少ない",
  "than": "より", "equal": "等しい", "equals": "等しい", "different": "異なる",
  "each": "各", "every": "各", "both": "両方", "next": "次",
  "today": "今日", "january": "1月", "february": "2月", "march": "3月",
  "april": "4月", "may": "5月", "june": "6月", "july": "7月", "august": "8月",
  "september": "9月", "october": "10月", "november": "11月", "december": "12月",
};

const koreanWordTranslations = {
  language: "언어", vietnamese: "베트남어", english: "영어", chinese: "중국어",
  japanese: "일본어", korean: "한국어", token: "토큰", service: "서비스",
  close: "닫기", cancel: "취소", save: "저장", update: "수정", create: "생성",
  edit: "편집", detail: "상세", details: "상세", delete: "삭제", confirm: "확인",
  back: "뒤로", search: "검색", filter: "필터", clear: "초기화", reset: "초기화",
  refresh: "새로 고침", export: "내보내기", import: "가져오기", download: "다운로드",
  upload: "업로드", copy: "복사", choose: "선택", select: "선택",
  view: "보기", print: "인쇄", send: "전송", sending: "전송 중", sign: "서명",
  signing: "서명 중", signed: "서명 완료", invoice: "청구서", invoices: "청구서",
  output: "발행", error: "오류", errors: "오류", handling: "처리",
  transmission: "전송", history: "이력", reports: "보고서", report: "보고서",
  catalog: "카탈로그", issue: "발행", issuance: "발행", notice: "알림", notices: "알림",
  replacement: "대체", replace: "대체", adjustment: "수정", adjust: "수정",
  cancellation: "취소", canceled: "취소됨", cancelled: "취소됨",
  multiple: "여러", list: "목록", lists: "목록", summary: "집계", form: "양식",
  template: "템플릿", configuration: "설정", administration: "관리",
  management: "관리", system: "시스템", parameter: "매개변수", company: "회사",
  user: "사용자", users: "사용자", organization: "조직", business: "사업",
  location: "사업장", tax: "세금", authority: "당국", code: "코드", status: "상태",
  date: "날짜", time: "시간", number: "번호", name: "이름", address: "주소",
  phone: "전화번호", email: "이메일", customer: "고객", buyer: "구매자", seller: "판매자",
  goods: "상품", product: "상품", products: "상품",
  quantity: "수량", unit: "단위", price: "가격", amount: "금액", total: "합계",
  payment: "결제", paid: "결제 완료", unpaid: "미결제", transaction: "거래",
  transactions: "거래", reason: "사유", description: "설명", content: "내용",
  field: "필드", fields: "필드", value: "값", values: "값", data: "데이터",
  row: "행", rows: "행", column: "열", columns: "열", page: "페이지",
  pages: "페이지", month: "월", months: "월", year: "년", years: "년", day: "일",
  days: "일", week: "주", weeks: "주", quarter: "분기", period: "기간",
  current: "현재", previous: "이전", new: "신규", old: "이전", first: "첫", last: "마지막",
  all: "전체", other: "기타", original: "원본", valid: "유효", invalid: "잘못됨",
  required: "필수", empty: "비어 있음", missing: "누락", available: "사용 가능",
  successful: "성공", success: "성공", failed: "실패", failure: "실패", warning: "경고",
  loading: "로드 중", preview: "미리 보기", guide: "가이드", help: "도움말",
  support: "지원", profile: "프로필", notifications: "알림", logout: "로그아웃",
  home: "홈", settings: "설정", permission: "권한", permissions: "권한",
  role: "역할", formula: "수식", calculate: "계산", calculation: "계산",
  currency: "통화", exchange: "환율", rate: "세율", discount: "할인",
  bank: "은행", certificate: "인증서", certificates: "인증서", password: "비밀번호",
  register: "등록", registered: "등록됨", registration: "등록", declaration: "신고",
  explanation: "설명", change: "변경", changed: "변경됨", convert: "변환",
  converted: "변환됨", attach: "첨부", attachment: "첨부", related: "관련",
  source: "원본", creator: "생성자", created: "생성됨", owner: "소유자",
  operation: "작업", operations: "업무", feature: "기능", default: "기본값",
  restore: "복원", initial: "초기", active: "사용 중", inside: "내부", outside: "외부",
  effective: "유효", expired: "만료됨", used: "사용됨", remaining: "남음",
  priority: "우선순위", resolution: "해상도", width: "너비", height: "높이", size: "크기",
  maximum: "최대", minimum: "최소", image: "이미지", logo: "로고", background: "배경",
  border: "테두리", opacity: "불투명도", paper: "용지", orientation: "방향",
  characters: "문자", lines: "행", line: "행", blank: "빈", normal: "일반",
  show: "표시", sequence: "순번", sort: "정렬", order: "순서", group: "그룹",
  execute: "실행", check: "확인", viewed: "확인함", unviewed: "확인하지 않음",
  accept: "승인", accepted: "승인됨", reject: "거부", rejected: "거부됨",
  continue: "계속", pause: "일시 중지", suspension: "중지", progress: "진행률",
  petroleum: "석유", fuel: "연료", pump: "주유기", store: "매장",
  vehicle: "차량", airline: "항공", ticket: "티켓", jewelry: "귀금속",
  notification: "알림", title: "제목", file: "파일", files: "파일", format: "형식",
  formats: "형식", excel: "Excel", html: "HTML", plugin: "플러그인", server: "서버",
  host: "호스트", port: "포트", authentication: "인증", legal: "법정",
  representative: "대표자", position: "직위", party: "당사자", parties: "당사자",
  gender: "성별", female: "여성", male: "남성", passport: "여권", citizen: "시민",
  identity: "신분", card: "카드", liters: "리터", minutes: "분", hours: "시간",
  taxpayer: "납세자", taxpayers: "납세자", decree: "법령", decision: "결정",
  pursuant: "근거하여", agreement: "합의", under: "에 따른", according: "에 따라",
  the: "해당", a: "하나의", an: "하나의", and: "및", or: "또는", of: "의",
  to: "으로", from: "에서", for: "용", in: "에서", on: "위", with: "첨부",
  without: "없이", by: "에 의해", as: "로서", at: "에", is: "입니다",
  are: "입니다", was: "였습니다", were: "였습니다", be: "되다", has: "있습니다",
  have: "있습니다", do: "합니다", does: "합니다", not: "않음", if: "경우",
  when: "때", before: "이전", after: "이후", please: "하세요",
  cannot: "할 수 없습니다", can: "할 수 있습니다", only: "만", including: "포함",
  more: "더", less: "적음", than: "보다",
  equal: "같음", equals: "같음", different: "다름", each: "각", every: "각",
  both: "모두", next: "다음", today: "오늘", january: "1월", february: "2월",
  march: "3월", april: "4월", may: "5월", june: "6월", july: "7월", august: "8월",
  september: "9월", october: "10월", november: "11월", december: "12월",
};

function translateEnglishResource(source, locale) {
  const phrases = locale === "ja" ? japanesePhraseTranslations : koreanPhraseTranslations;
  const words = locale === "ja" ? japaneseWordTranslations : koreanWordTranslations;
  const fallback = locale === "ja" ? "項目" : "항목";
  const technicalTerms = [
    "M-Invoice", "EASYCA", "NCCA", "I-CA", "Intrust-CA", "FILE CA", "USB token",
    "QR Code", "QRCode", "mQR", "PDF", "XML", "HTML", "Excel", "VAT", "SMTP", "PIN",
    "Plugin", "IAM Software", "px", "p12", "fpx", "file.zip",
    "M-INVOICE", "PL01", "PL101/2023/QH15", "01/TH-HĐĐT", "NĐ123", "NĐ70", "NĐ254",
  ];

  const translateValue = (value) => {
    if (typeof value !== "string") return value;
    if (Object.prototype.hasOwnProperty.call(phrases, value)) return phrases[value];

    const placeholders = [];
    let masked = value.replace(/\{\{[^}]+\}\}|\{[^{}]+\}/g, (placeholder) => {
      const token = "__I18N_PLACEHOLDER_" + placeholders.length + "__";
      placeholders.push(placeholder);
      return token;
    });
    const protectedValues = [];
    technicalTerms
      .slice()
      .sort((left, right) => right.length - left.length)
      .forEach((technicalTerm) => {
        const escaped = technicalTerm.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        masked = masked.replace(new RegExp("\\b" + escaped + "\\b", "gi"), (match) => {
          const token = "__I18N_TECHNICAL_" + protectedValues.length + "__";
          protectedValues.push(match);
          return token;
        });
      });

    masked = masked.replace(/\b[A-Za-z][A-Za-z'-]*\b/g, (word) => {
      const translated = words[word.toLowerCase()];
      return translated || fallback;
    });

    return masked
      .replace(/__I18N_TECHNICAL_(\d+)__/g, (_, index) => protectedValues[Number(index)])
      .replace(/__I18N_PLACEHOLDER_(\d+)__/g, (_, index) => placeholders[Number(index)]);
  };

  const translateNode = (value) => {
    if (typeof value === "string") return translateValue(value);
    if (Array.isArray(value)) return value.map(translateNode);
    if (value && typeof value === "object") {
      const result = {};
      Object.entries(value).forEach(([key, child]) => {
        result[key] = translateNode(child);
      });
      return result;
    }
    return value;
  };

  return translateNode(source);
}

const japaneseTranslation = translateEnglishResource(baseResources.en.translation, "ja");
const koreanTranslation = translateEnglishResource(baseResources.en.translation, "ko");
function mergeTranslation(
  base: Record<string, any>,
  overrides: Record<string, any>,
): Record<string, any> {
  const result = { ...base };

  Object.entries(overrides).forEach(([key, value]) => {
    const baseValue = result[key];
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      baseValue &&
      typeof baseValue === "object" &&
      !Array.isArray(baseValue)
    ) {
      result[key] = mergeTranslation(baseValue, value);
    } else {
      result[key] = value;
    }
  });

  return result;
}

export const resources = {
  ...baseResources,
  zh: {
    translation: mergeTranslation(
      baseResources.en.translation,
      mergeTranslation(baseResources.zh.translation, chineseAdditionalTranslation),
    ),
  },
  ja: {
    translation: japaneseTranslation,
  },
  ko: {
    translation: koreanTranslation,
  },
} as const;

export type Locale = keyof typeof resources;
